
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired477"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    var mod = $parcel$modules[id];
    if (mod !== undefined) {
      return mod.exports;
    }
    var init = $parcel$inits[id];
    if (init !== undefined) {
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired477"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("9ot3w", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
/* modal-header.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $gMc0m = parcelRequire("gMc0m");

parcelRequire("42omo");


var $1s5hv = parcelRequire("1s5hv");


var $8TTLA = parcelRequire("8TTLA");


var $804cB = parcelRequire("804cB");

const $675b4731f49c3b03$var$styles = {
    header: "_18zr1ejb _1e0c1txw _kqswh2mm _4cvr1h6o _1bah1yb4 _6rth1i6y _85i5pxbi _1q511ejb",
    flex: "_2lx21sbv _1bsb1osq",
    titleContainer: "_1ul9idpf"
};
/**
 * __Modal header__
 *
 * A modal header contains the title of the modal and can contain other React elements such as a close button.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples#modal-header)
 * - [Code](https://atlassian.design/components/modal-dialog/code#modal-header-props)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ const $675b4731f49c3b03$var$ModalHeader = (props)=>{
    const { children: children, testId: userDefinedTestId, hasCloseButton: hasCloseButton = false } = props;
    const { hasProvidedOnClose: hasProvidedOnClose, onClose: onClose, testId: modalTestId } = (0, $804cB.useModal)();
    const testId = userDefinedTestId || modalTestId && `${modalTestId}--header`; // Only show if an onClose was provided for the modal dialog
    const shouldShowCloseButton = hasCloseButton && hasProvidedOnClose && onClose;
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        "data-testid": testId,
        className: (0, $gMc0m.default)([
            $675b4731f49c3b03$var$styles.header
        ]),
        children: shouldShowCloseButton ? /*#__PURE__*/ (0, $l998X.jsxs)((0, $1s5hv.default), {
            gap: "space.200",
            justifyContent: "space-between",
            xcss: $675b4731f49c3b03$var$styles.flex,
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)((0, $1s5hv.default), {
                    justifyContent: "end",
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $8TTLA.CloseButton), {
                        onClick: onClose,
                        testId: modalTestId
                    })
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $1s5hv.default), {
                    justifyContent: "start",
                    alignItems: "center",
                    xcss: $675b4731f49c3b03$var$styles.titleContainer,
                    children: children
                })
            ]
        }) : children
    });
};
var $675b4731f49c3b03$export$2e2bcd8739ae039 = $675b4731f49c3b03$var$ModalHeader;
module.exports["default"] = $675b4731f49c3b03$export$2e2bcd8739ae039;

});

parcelRegister("1s5hv", function(module, exports) {
/* flex.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $46c0ad632e23aab5$var$rowGapMap = {
    'space.0': "_1p57ze3t",
    'space.025': "_1p57v77o",
    'space.050': "_1p571b66",
    'space.075': "_1p5712x7",
    'space.100': "_1p57u2gc",
    'space.150': "_1p57utpp",
    'space.200': "_1p57pxbi",
    'space.250': "_1p57v47k",
    'space.300': "_1p571ejb",
    'space.400': "_1p57xy5q",
    'space.500': "_1p571jfw",
    'space.600': "_1p57oahv",
    'space.800': "_1p57xncg",
    'space.1000': "_1p571epz"
};
const $46c0ad632e23aab5$var$columnGapMap = {
    'space.0': "_gy1pze3t",
    'space.025': "_gy1pv77o",
    'space.050': "_gy1p1b66",
    'space.075': "_gy1p12x7",
    'space.100': "_gy1pu2gc",
    'space.150': "_gy1putpp",
    'space.200': "_gy1ppxbi",
    'space.250': "_gy1pv47k",
    'space.300': "_gy1p1ejb",
    'space.400': "_gy1pxy5q",
    'space.500': "_gy1p1jfw",
    'space.600': "_gy1poahv",
    'space.800': "_gy1pxncg",
    'space.1000': "_gy1p1epz"
};
const $46c0ad632e23aab5$var$justifyContentMap = {
    start: "_1bahv2br",
    center: "_1bah1h6o",
    end: "_1bahh9n0",
    'space-between': "_1bah1yb4",
    'space-around': "_1bah1b1v",
    'space-evenly': "_1bahitcz",
    stretch: "_1bah1fhb"
};
const $46c0ad632e23aab5$var$flexDirectionMap = {
    column: "_2lx21bp4",
    row: "_2lx2vrvc"
};
const $46c0ad632e23aab5$var$flexWrapMap = {
    wrap: "_1n261g80",
    nowrap: "_1n261q9c"
};
const $46c0ad632e23aab5$var$alignItemsMap = {
    start: "_4cvrv2br",
    center: "_4cvr1h6o",
    baseline: "_4cvr1q9y",
    end: "_4cvrh9n0",
    stretch: "_4cvr1fhb"
};
const $46c0ad632e23aab5$var$styles = {
    root: "_1e0c1txw _vchhusvi"
}; /**
    * __Flex__
    *
    * `Flex` is a primitive component that implements the CSS Flexbox API.
    *
    * - [Examples](https://atlassian.design/components/primitives/flex/examples)
    * - [Code](https://atlassian.design/components/primitives/flex/code)
    *
    * @example
    * ```tsx
    * // eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
    * import { Flex, Box } from '@atlaskit/primitives'
    *
    * const Component = () => (
    *   <Flex direction="column">
    *     <Box padding="space.100" backgroundColor="neutral"></Box>
    *     <Box padding="space.100" backgroundColor="neutral"></Box>
    *   </Flex>
    * )
    * ```
    */ 
const $46c0ad632e23aab5$var$Flex = /*#__PURE__*/ (0, $42omo.memo)(/*#__PURE__*/ (0, $42omo.forwardRef)(({ as: Component = 'div', role: role, alignItems: alignItems, justifyContent: justifyContent, gap: gap, columnGap: columnGap, rowGap: rowGap, children: children, testId: testId, direction: direction, wrap: wrap, xcss: xcss, ...ariaAttributes }, ref)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)(Component, {
        ...ariaAttributes,
        role: role,
        className: (0, $gMc0m.default)([
            $46c0ad632e23aab5$var$styles.root,
            gap && $46c0ad632e23aab5$var$columnGapMap[gap],
            columnGap && $46c0ad632e23aab5$var$columnGapMap[columnGap],
            gap && $46c0ad632e23aab5$var$rowGapMap[gap],
            rowGap && $46c0ad632e23aab5$var$rowGapMap[rowGap],
            alignItems && $46c0ad632e23aab5$var$alignItemsMap[alignItems],
            direction && $46c0ad632e23aab5$var$flexDirectionMap[direction],
            justifyContent && $46c0ad632e23aab5$var$justifyContentMap[justifyContent],
            wrap && $46c0ad632e23aab5$var$flexWrapMap[wrap],
            xcss
        ]),
        "data-testid": testId,
        ref: ref,
        children: children
    });
}));
$46c0ad632e23aab5$var$Flex.displayName = 'Flex';
var $46c0ad632e23aab5$export$2e2bcd8739ae039 = $46c0ad632e23aab5$var$Flex;
module.exports["default"] = $46c0ad632e23aab5$export$2e2bcd8739ae039;

});

parcelRegister("8TTLA", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $1qfLF = parcelRequire("1qfLF");


var $hmuev = parcelRequire("hmuev");

const $5924532aef146558$export$de65de8213222d10 = ({ label: label, onBlur: onBlur, onClick: onClick, testId: testId })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $1qfLF.default), {
        testId: testId && `${testId}--close-button`,
        appearance: "subtle",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($hmuev))),
        label: label || 'Close Modal',
        onBlur: onBlur,
        onClick: onClick
    });
module.exports["CloseButton"] = $5924532aef146558$export$de65de8213222d10;

});

parcelRegister("1qfLF", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $3654r = parcelRequire("3654r");


var $3gadb = parcelRequire("3gadb");


var $6F6hl = parcelRequire("6F6hl");


var $iprY1 = parcelRequire("iprY1");


var $jvXSm = parcelRequire("jvXSm");


var $6kISY = parcelRequire("6kISY");

/**
 * __Icon Button__
 *
 * Renders an icon-only button lets people take a common and recognizable action where space is limited.
 *
 * - [Examples](https://atlassian.design/components/button/icon-button/examples)
 * - [Code](https://atlassian.design/components/button/icon-button/code)
 * - [Usage](https://atlassian.design/components/button/icon-button/usage)
 */ const $660af81825e1c4b6$var$IconButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).forwardRef(function Button({ // Prevent duplicate labels being added.
'aria-label': preventedAriaLabel, 'aria-labelledby': ariaLabelledBy, analyticsContext: analyticsContext, appearance: appearance, autoFocus: autoFocus, icon: icon, interactionName: interactionName, isDisabled: isDisabled, isLoading: isLoading = false, isSelected: isSelected, isTooltipDisabled: isTooltipDisabled = true, label: label, onClick: onClick, onClickCapture: onClickCapture, onKeyDownCapture: onKeyDownCapture, onKeyUpCapture: onKeyUpCapture, onMouseDownCapture: onMouseDownCapture, onMouseUpCapture: onMouseUpCapture, onPointerDownCapture: onPointerDownCapture, onPointerUpCapture: onPointerUpCapture, onTouchEndCapture: onTouchEndCapture, onTouchStartCapture: onTouchStartCapture, shape: shape, spacing: spacing, testId: testId, tooltip: tooltip, type: type = 'button', ...unsafeRest }, ref) {
    // @ts-expect-error
    const { className: _className, css: _css, as: _as, style: _style, ...saferRest } = unsafeRest;
    if (isTooltipDisabled) return /*#__PURE__*/ (0, $l998X.jsx)((0, $iprY1.default), {
        ...saferRest,
        ref: ref,
        appearance: appearance,
        autoFocus: autoFocus,
        isDisabled: isDisabled,
        isLoading: isLoading,
        isSelected: isSelected,
        isIconButton: true,
        isCircle: shape === 'circle',
        hasIconBefore: !!icon,
        spacing: spacing,
        ariaLabelledBy: ariaLabelledBy,
        onClick: onClick,
        onClickCapture: onClickCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onTouchStartCapture: onTouchStartCapture,
        onTouchEndCapture: onTouchEndCapture,
        testId: testId,
        componentName: "IconButton",
        analyticsContext: analyticsContext,
        type: type,
        interactionName: interactionName,
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $jvXSm.default), {
            type: "icon",
            isLoading: isLoading,
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)((0, $6kISY.default), {
                    icon: icon
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $6F6hl.default), {
                    children: label
                })
            ]
        })
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $3gadb.default), {
        content: tooltip?.content ?? label,
        testId: tooltip?.testId,
        position: tooltip?.position,
        delay: tooltip?.delay,
        onShow: tooltip?.onShow,
        onHide: tooltip?.onHide,
        mousePosition: tooltip?.mousePosition,
        analyticsContext: tooltip?.analyticsContext,
        strategy: tooltip?.strategy,
        tag: tooltip?.tag,
        truncate: tooltip?.truncate,
        component: tooltip?.component,
        hideTooltipOnClick: tooltip?.hideTooltipOnClick,
        hideTooltipOnMouseDown: tooltip?.hideTooltipOnMouseDown,
        ignoreTooltipPointerEvents: tooltip?.ignoreTooltipPointerEvents,
        shortcut: tooltip?.shortcut,
        children: (triggerProps)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $iprY1.default), {
                ...saferRest,
                appearance: appearance,
                autoFocus: autoFocus,
                isDisabled: isDisabled,
                isLoading: isLoading,
                isSelected: isSelected,
                isIconButton: true,
                isCircle: shape === 'circle',
                hasIconBefore: false,
                spacing: spacing,
                ariaLabelledBy: ariaLabelledBy,
                onClick: (e, analyticsEvent)=>{
                    onClick?.(e, analyticsEvent);
                    triggerProps.onClick?.(e);
                },
                onMouseOver: (e)=>{
                    triggerProps.onMouseOver?.(e);
                    saferRest.onMouseOver?.(e);
                },
                onMouseOut: (e)=>{
                    triggerProps.onMouseOut?.(e);
                    saferRest.onMouseOut?.(e);
                },
                onMouseMove: (e)=>{
                    triggerProps.onMouseMove?.(e);
                    saferRest.onMouseMove?.(e);
                },
                onMouseDown: (e)=>{
                    triggerProps.onMouseDown?.(e);
                    saferRest.onMouseDown?.(e);
                },
                onFocus: (e)=>{
                    triggerProps.onFocus?.(e);
                    saferRest.onFocus?.(e);
                },
                onBlur: (e)=>{
                    triggerProps.onBlur?.(e);
                    saferRest.onBlur?.(e);
                },
                ref: (0, $3654r.default)([
                    ref,
                    triggerProps?.ref
                ].filter(Boolean)),
                onMouseDownCapture: onMouseDownCapture,
                onMouseUpCapture: onMouseUpCapture,
                onKeyDownCapture: onKeyDownCapture,
                onKeyUpCapture: onKeyUpCapture,
                onTouchStartCapture: onTouchStartCapture,
                onTouchEndCapture: onTouchEndCapture,
                onPointerDownCapture: onPointerDownCapture,
                onPointerUpCapture: onPointerUpCapture,
                onClickCapture: onClickCapture,
                type: type,
                testId: testId,
                analyticsContext: analyticsContext,
                interactionName: interactionName,
                componentName: "IconButton",
                children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $jvXSm.default), {
                    type: "icon",
                    isLoading: isLoading,
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $6kISY.default), {
                            icon: icon
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $6F6hl.default), {
                            children: label
                        })
                    ]
                })
            })
    });
}));
$660af81825e1c4b6$var$IconButton.displayName = 'IconButton';
var $660af81825e1c4b6$export$2e2bcd8739ae039 = $660af81825e1c4b6$var$IconButton;
module.exports["default"] = $660af81825e1c4b6$export$2e2bcd8739ae039;

});

parcelRegister("fVUfS", function(module, exports) {
/* pressable.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $1bHXt = parcelRequire("1bHXt");


var $gxtzC = parcelRequire("gxtzC");


var $9I2p1 = parcelRequire("9I2p1");


var $ee7An = parcelRequire("ee7An");


var $90YwQ = parcelRequire("90YwQ");


var $1HnpQ = parcelRequire("1HnpQ");

const $008d34ae4d0e7195$var$styles = {
    root: "_19itglyw _vchhusvi _r06hglyw _80omtlke",
    disabled: "_80om13gf"
}; /**
    * __Pressable__
    *
    * A primitive for building custom buttons.
    *
    * - [Examples](https://atlassian.design/components/primitives/pressable/examples)
    * - [Code](https://atlassian.design/components/primitives/pressable/code)
    * - [Usage](https://atlassian.design/components/primitives/pressable/usage)
    */ 
const $008d34ae4d0e7195$var$Pressable = /*#__PURE__*/ (0, $42omo.forwardRef)(({ children: children, isDisabled: isDisabled, type: type = 'button', onClick: providedOnClick = (0, $ee7An.default), interactionName: interactionName, componentName: componentName, analyticsContext: analyticsContext, style: style, testId: testId, xcss: xcss, tabIndex: tabIndex, ...htmlAttributes }, ref)=>{
    const interactionContext = (0, $42omo.useContext)((0, $90YwQ.default));
    const handleClick = (0, $42omo.useCallback)((e, analyticsEvent)=>{
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    const onClick = (0, $gxtzC.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: 'clicked',
        componentName: componentName || 'Pressable',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local",
        analyticsData: analyticsContext,
        actionSubject: 'button'
    }); // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    const { className: _spreadClass, ...safeHtmlAttributes } = htmlAttributes;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $1HnpQ.default // @ts-ignore -- not using expect since it causes issues with help-center local consumption - we don't allow `button` on Focusable for makers as they should use Pressable instead
    ), {
        as: "button",
        // Adding a tabIndex of 0 to the button will allow it to be focused on click.
        // This is a known issue in Safari that is meant to be "intended", see https://bugs.webkit.org/show_bug.cgi?id=22261
        tabIndex: tabIndex ?? ((0, $9I2p1.isSafari)() && !isDisabled ? 0 : undefined),
        style: style,
        ...safeHtmlAttributes,
        type: type,
        onClick: onClick,
        disabled: isDisabled,
        xcss: (0, $1bHXt.cx)($008d34ae4d0e7195$var$styles.root, isDisabled && $008d34ae4d0e7195$var$styles.disabled, xcss),
        testId: testId,
        ref: ref,
        children: children
    });
});
var $008d34ae4d0e7195$export$2e2bcd8739ae039 = $008d34ae4d0e7195$var$Pressable;
module.exports["default"] = $008d34ae4d0e7195$export$2e2bcd8739ae039;

});

parcelRegister("1HnpQ", function(module, exports) {
/* focusable.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $035a66874d3e86fd$var$focusRingStyles = null;
const $035a66874d3e86fd$var$insetFocusRingStyles = null;
const $035a66874d3e86fd$var$Focusable = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: Component = 'button', children: children, isInset: isInset, testId: testId, style: style, xcss: xcss, ...htmlAttributes }, ref)=>{
    // This is to remove className from safeHtmlAttributes
    // @ts-ignore -- not using expect since it causes issues with help-center local consumption - className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    const { className: _spreadClass, ...safeHtmlAttributes } = htmlAttributes;
    return /*#__PURE__*/ (0, $l998X.jsx)(Component, {
        ...safeHtmlAttributes,
        ref: ref,
        className: (0, $gMc0m.default)([
            "_ymio1r31 _ypr0glyw _zcxs1o36 _mizu1v1w _1ah3dkaa _ra3xnqa1 _128mdkaa _1cvmnqa1 _4davt94y",
            isInset && "_1ah31gjf _2mwq1gjf",
            xcss
        ]),
        style: style,
        "data-testid": testId,
        children: children
    });
});
var $035a66874d3e86fd$export$2e2bcd8739ae039 = $035a66874d3e86fd$var$Focusable;
module.exports["default"] = $035a66874d3e86fd$export$2e2bcd8739ae039;

});

parcelRegister("804cB", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $dbEzH = parcelRequire("dbEzH");

const $f5cb14e7ec743f95$export$33ffd74ebf07f060 = ()=>{
    const modalContext = (0, $42omo.useContext)((0, $dbEzH.ModalContext));
    if (modalContext == null) throw Error("@atlaskit/modal-dialog: Modal context unavailable \u2013 this component needs to be a child of ModalDialog.");
    return modalContext;
};
module.exports["useModal"] = $f5cb14e7ec743f95$export$33ffd74ebf07f060;

});

parcelRegister("d8eRd", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
/* modal-title.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $a3fRD = parcelRequire("a3fRD");


var $ebrpi = parcelRequire("ebrpi");


var $804cB = parcelRequire("804cB");

const $3fbc980834196fab$var$iconColor = {
    danger: "var(--ds-icon-danger, #C9372C)",
    warning: "var(--ds-icon-warning, #E06C00)"
};
const $3fbc980834196fab$var$iconStyles = null;
const $3fbc980834196fab$var$titleStyles = null;
const $3fbc980834196fab$var$textStyles = null;
const $3fbc980834196fab$var$truncatedTextStyles = null;
const $3fbc980834196fab$var$TitleIcon = ({ appearance: appearance })=>{
    const Icon = appearance === 'danger' ? (0, (/*@__PURE__*/$parcel$interopDefault($a3fRD))) : (0, (/*@__PURE__*/$parcel$interopDefault($ebrpi)));
    return /*#__PURE__*/ (0, $l998X.jsx)("span", {
        className: (0, $gMc0m.default)([
            "_16jlidpf _1o9zidpf _i0dl1wug _syaz1kw7 _1wyb1kw7 _zg8l1kw7 _k48p1kw7 _1dyz1kw7 _vwz41kw7"
        ]),
        children: /*#__PURE__*/ (0, $l998X.jsx)(Icon, {
            label: appearance,
            color: $3fbc980834196fab$var$iconColor[appearance],
            spacing: "spacious"
        })
    });
};
/**
 * __Modal title__
 *
 * A modal title is used to display a title within a modal.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples)
 * - [Code](https://atlassian.design/components/modal-dialog/code)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ const $3fbc980834196fab$var$ModalTitle = (props)=>{
    const { appearance: appearance, children: children, isMultiline: isMultiline = true, testId: userDefinedTestId } = props;
    const { titleId: titleId, testId: modalTestId } = (0, $804cB.useModal)();
    const testId = userDefinedTestId || modalTestId && `${modalTestId}--title`;
    return /*#__PURE__*/ (0, $l998X.jsxs)("h1", {
        "data-testid": testId,
        className: (0, $gMc0m.default)([
            "_zulpu2gc _11c81af2 _1e0c1txw _1ul9idpf _6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t"
        ]),
        children: [
            appearance && /*#__PURE__*/ (0, $l998X.jsx)($3fbc980834196fab$var$TitleIcon, {
                appearance: appearance
            }),
            /*#__PURE__*/ (0, $l998X.jsx)("span", {
                id: titleId,
                "data-testid": testId && `${testId}-text`,
                className: (0, $gMc0m.default)([
                    "_16jlkb7n _1o9zkb7n _i0dl1wug _1ul9idpf _slp31hna",
                    !isMultiline && "_1reo15vq _18m915vq _1bto1l2s _o5721q9c"
                ]),
                children: children
            })
        ]
    });
};
var $3fbc980834196fab$export$2e2bcd8739ae039 = $3fbc980834196fab$var$ModalTitle;
module.exports["default"] = $3fbc980834196fab$export$2e2bcd8739ae039;

});

parcelRegister("1DHa6", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
/* modal-body.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $gMc0m = parcelRequire("gMc0m");

parcelRequire("42omo");


var $crya1 = parcelRequire("crya1");


var $804cB = parcelRequire("804cB");

/* scroll-container.tsx generated by @compiled/babel-plugin v0.36.1 */ 



var $42omo = parcelRequire("42omo");


var $fFa3V = parcelRequire("fFa3V");


var $2P8Ax = parcelRequire("2P8Ax");


var $1Whri = parcelRequire("1Whri");


var $3654r = parcelRequire("3654r");


var $ee7An = parcelRequire("ee7An");


var $aCLu8 = parcelRequire("aCLu8");


var $1HnpQ = parcelRequire("1HnpQ");

const $0f8b4794e6938131$var$keylineColor = "var(--ds-border, #0B120E24)";
const $0f8b4794e6938131$var$styles = {
    base: "_16jlkb7n _1o9zkb7n _i0dl1kw7 _1e0c1kw7 _2lx21kw7 _6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t _1reo15vq _18m91wug _1jykn7od _wzg61wug",
    topKeyline: "_mqm21uh4",
    bottomKeyline: "_179r1uh4"
};
const $0f8b4794e6938131$var$keylineHeight = 2;
/**
 * A container that shows top and bottom keylines when the
 * content overflows into the scrollable element.
 */ const $0f8b4794e6938131$var$ScrollContainer = /*#__PURE__*/ (0, $42omo.forwardRef)(({ testId: testId, children: children }, ref)=>{
    const scrollableRef = (0, $42omo.useRef)(null);
    const [showTopKeyline, setTopKeyline] = (0, $42omo.useState)(false);
    const [showBottomKeyline, setBottomKeyline] = (0, $42omo.useState)(false);
    const [showContentFocus, setContentFocus] = (0, $42omo.useState)(false);
    // Schedule a content focus on the target element
    // WARNING: In theory, `target` may not be available when `rafSchedule` hits in concurrent rendering
    (0, $42omo.useEffect)(()=>{
        const schedule = (0, $2P8Ax.default)(()=>{
            const target = scrollableRef.current;
            target && setContentFocus(target.scrollHeight > target.clientHeight);
        });
        schedule();
    }, [
        scrollableRef
    ]);
    const setLazyKeylines = (0, $aCLu8.default)((0, $2P8Ax.default)(()=>{
        const target = scrollableRef.current;
        if (target) {
            const scrollableDistance = target.scrollHeight - target.clientHeight;
            if (target.previousElementSibling) setTopKeyline(target.scrollTop > $0f8b4794e6938131$var$keylineHeight);
            if (target.nextElementSibling) setBottomKeyline(target.scrollTop <= scrollableDistance - $0f8b4794e6938131$var$keylineHeight);
        }
    }));
    // On load (and scroll/resize events), we set "keylines"
    // these border the content to indicate scrollability when content underflows the header or footer
    (0, $42omo.useEffect)(()=>{
        const target = scrollableRef.current;
        setLazyKeylines();
        const unbindWindowEvent = (0, $fFa3V.bind)(window, {
            type: 'resize',
            listener: setLazyKeylines
        });
        const unbindTargetEvent = target ? (0, $fFa3V.bind)(target, {
            type: 'scroll',
            listener: setLazyKeylines
        }) : (0, $ee7An.default);
        return ()=>{
            unbindWindowEvent();
            unbindTargetEvent();
        };
    }, [
        setLazyKeylines
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $1HnpQ.default), {
        as: "div",
        isInset: true,
        tabIndex: showContentFocus ? 0 : undefined,
        role: showContentFocus ? 'region' : undefined,
        "aria-label": showContentFocus ? 'Scrollable content' : undefined,
        testId: testId && `${testId}--scrollable`,
        ref: (0, $3654r.default)([
            ref,
            scrollableRef
        ]),
        xcss: (0, $1Whri.cx)($0f8b4794e6938131$var$styles.base, showTopKeyline && $0f8b4794e6938131$var$styles.topKeyline, showBottomKeyline && $0f8b4794e6938131$var$styles.bottomKeyline),
        children: children
    });
});
$0f8b4794e6938131$var$ScrollContainer.displayName = 'ScrollContainer';
var $0f8b4794e6938131$export$2e2bcd8739ae039 = $0f8b4794e6938131$var$ScrollContainer;






var $dbEzH = parcelRequire("dbEzH");

function $3a89e0d55be82e39$export$2e2bcd8739ae039() {
    const shouldScrollInViewport = (0, $42omo.useContext)((0, $dbEzH.ScrollContext));
    if (shouldScrollInViewport == null) throw Error("@atlaskit/modal-dialog: Scroll context unavailable \u2013 this component needs to be a child of ModalDialog.");
    return shouldScrollInViewport;
}


const $b62a238333cef43f$var$styles = {
    root: "_16jlkb7n _1o9zkb7n _i0dl1wug _11c8fhey",
    paddingBlock: "_1rjcv77o",
    paddingInline: "_18zr1ejb"
};
/**
 * __Modal body__
 *
 * A modal body is used to display the main content of a modal.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples)
 * - [Code](https://atlassian.design/components/modal-dialog/code#modal-body-props)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ const $b62a238333cef43f$var$ModalBody = (props)=>{
    const { children: children, testId: userDefinedTestId, hasInlinePadding: hasInlinePadding = true } = props;
    const { testId: modalTestId } = (0, $804cB.useModal)();
    const shouldScrollInViewport = (0, $3a89e0d55be82e39$export$2e2bcd8739ae039)();
    const testId = userDefinedTestId || modalTestId && `${modalTestId}--body`;
    return shouldScrollInViewport ? /*#__PURE__*/ (0, $l998X.jsx)("div", {
        "data-testid": testId,
        className: (0, $gMc0m.default)([
            $b62a238333cef43f$var$styles.root,
            hasInlinePadding && $b62a238333cef43f$var$styles.paddingInline
        ]),
        children: children
    }) : /*#__PURE__*/ (0, $l998X.jsx)((0, $crya1.TouchScrollable), {
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $0f8b4794e6938131$export$2e2bcd8739ae039), {
            testId: userDefinedTestId || modalTestId,
            children: /*#__PURE__*/ (0, $l998X.jsx)("div", {
                "data-testid": testId,
                className: (0, $gMc0m.default)([
                    $b62a238333cef43f$var$styles.root,
                    /**
      * Adding block padding for scroll keylines, which are only shown when the scrolling
      * is on the container.
      */ $b62a238333cef43f$var$styles.paddingBlock,
                    hasInlinePadding && $b62a238333cef43f$var$styles.paddingInline
                ]),
                children: children
            })
        })
    });
};
var $b62a238333cef43f$export$2e2bcd8739ae039 = $b62a238333cef43f$var$ModalBody;
module.exports["default"] = $b62a238333cef43f$export$2e2bcd8739ae039;

});

parcelRegister("8o1lj", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
/* modal-footer.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $804cB = parcelRequire("804cB");

const $946150c7df517ac0$var$footerStyles = null;
/**
 * __Modal footer__
 *
 * A modal footer often contains a primary action and the ability to cancel and close the dialog, though can contain any React element.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples#modal-footer)
 * - [Code](https://atlassian.design/components/modal-dialog/code#modal-footer-props)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ const $946150c7df517ac0$var$ModalFooter = (props)=>{
    const { children: children, testId: userDefinedTestId } = props;
    const { testId: modalTestId } = (0, $804cB.useModal)();
    const testId = userDefinedTestId || modalTestId && `${modalTestId}--footer`;
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        "data-testid": testId,
        className: (0, $gMc0m.default)([
            "_zulpu2gc _18zr1ejb _1e0c1txw _kqswh2mm _4cvr1h6o _1bahesu3 _1pfh1i6y _85i51ejb _1q51pxbi"
        ]),
        children: children
    });
};
var $946150c7df517ac0$export$2e2bcd8739ae039 = $946150c7df517ac0$var$ModalFooter;
module.exports["default"] = $946150c7df517ac0$export$2e2bcd8739ae039;

});

parcelRegister("6f0Oj", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $42omo = parcelRequire("42omo");


var $9K4OG = parcelRequire("9K4OG");


var $5rrZR = parcelRequire("5rrZR");


var $avd77 = parcelRequire("avd77");


var $ecnYn = parcelRequire("ecnYn");

function $b2f482e24395e02d$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $b2f482e24395e02d$export$e71c4d32a2263218 = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: Component = 'div', children: children, backgroundColor: backgroundColor, padding: padding, paddingBlock: paddingBlock, paddingBlockStart: paddingBlockStart, paddingBlockEnd: paddingBlockEnd, paddingInline: paddingInline, paddingInlineStart: paddingInlineStart, paddingInlineEnd: paddingInlineEnd, style: style, testId: testId, xcss: xcss, ...htmlAttributes }, ref)=>{
    // This is to remove className from safeHtmlAttributes
    // @ts-ignore -- not using expect since it causes issues with help-center local consumption - className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    const { className: _spreadClass, ...safeHtmlAttributes } = htmlAttributes;
    const resolvedStyles = (0, $ecnYn.parseXcss)(xcss);
    const node = // @ts-expect-error Expression produces a union type that is too complex to represent. I think this is unavoidable
    /*#__PURE__*/ (0, $9K4OG.jsx)(Component, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        // @ts-ignore Expression produces a union type that is too complex to represent. We may be able to narrow the type here but unsure.
        ref: ref,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: resolvedStyles.static,
        ...safeHtmlAttributes,
        css: [
            $b2f482e24395e02d$var$baseStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            backgroundColor && (0, $avd77.backgroundColorStylesMap)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $avd77.isSurfaceColorToken)(backgroundColor) && (0, $avd77.surfaceColorStylesMap)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            padding && (0, $avd77.paddingStylesMap).padding[padding],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlock && (0, $avd77.paddingStylesMap).paddingBlock[paddingBlock],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockStart && (0, $avd77.paddingStylesMap).paddingBlockStart[paddingBlockStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockEnd && (0, $avd77.paddingStylesMap).paddingBlockEnd[paddingBlockEnd],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInline && (0, $avd77.paddingStylesMap).paddingInline[paddingInline],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineStart && (0, $avd77.paddingStylesMap).paddingInlineStart[paddingInlineStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineEnd && (0, $avd77.paddingStylesMap).paddingInlineEnd[paddingInlineEnd],
            resolvedStyles.emotion
        ],
        "data-testid": testId
    }, children);
    return backgroundColor ? /*#__PURE__*/ (0, $9K4OG.jsx)((0, $5rrZR.SurfaceContext).Provider, {
        value: backgroundColor
    }, node) : node;
});
var $b2f482e24395e02d$export$2e2bcd8739ae039 = $b2f482e24395e02d$export$e71c4d32a2263218;
const $b2f482e24395e02d$var$baseStyles = {
    name: "1b8qmvl",
    styles: "box-sizing:border-box;appearance:none;border:none"
};
module.exports["Box"] = $b2f482e24395e02d$export$e71c4d32a2263218;
module.exports["default"] = $b2f482e24395e02d$export$2e2bcd8739ae039;

});

parcelRegister("5rrZR", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $fe09f048ab2b6c21$export$1ca2a26fecb070ae = /*#__PURE__*/ (0, $42omo.createContext)('elevation.surface');
const $fe09f048ab2b6c21$export$1aeb4f6b93c4540d = ()=>{
    return (0, $42omo.useContext)($fe09f048ab2b6c21$export$1ca2a26fecb070ae);
};
$fe09f048ab2b6c21$export$1ca2a26fecb070ae.displayName = 'SurfaceProvider';
module.exports["SurfaceContext"] = $fe09f048ab2b6c21$export$1ca2a26fecb070ae;
module.exports["useSurface"] = $fe09f048ab2b6c21$export$1aeb4f6b93c4540d;

});

parcelRegister("avd77", function(module, exports) {
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $9K4OG = parcelRequire("9K4OG");


var $a9dFP = parcelRequire("a9dFP");

const $7e5dacb61893bdcb$export$6ccdbebca2ee545f = {
    '100%': '100%',
    'size.100': '1rem',
    'size.200': '1.5rem',
    'size.300': '2rem',
    'size.400': '2.5rem',
    'size.500': '3rem',
    'size.600': '6rem',
    'size.1000': '12rem'
};
const $7e5dacb61893bdcb$export$958d0ae7f2977ae4 = {
    'space.0': "var(--ds-space-0, 0px)",
    'space.025': "var(--ds-space-025, 2px)",
    'space.050': "var(--ds-space-050, 4px)",
    'space.075': "var(--ds-space-075, 6px)",
    'space.100': "var(--ds-space-100, 8px)",
    'space.150': "var(--ds-space-150, 12px)",
    'space.200': "var(--ds-space-200, 16px)",
    'space.250': "var(--ds-space-250, 20px)",
    'space.300': "var(--ds-space-300, 24px)",
    'space.400': "var(--ds-space-400, 32px)",
    'space.500': "var(--ds-space-500, 40px)",
    'space.600': "var(--ds-space-600, 48px)",
    'space.800': "var(--ds-space-800, 64px)",
    'space.1000': "var(--ds-space-1000, 80px)"
};
const $7e5dacb61893bdcb$export$d2dc61f58390201c = {
    'space.negative.025': "var(--ds-space-negative-025, -2px)",
    'space.negative.050': "var(--ds-space-negative-050, -4px)",
    'space.negative.075': "var(--ds-space-negative-075, -6px)",
    'space.negative.100': "var(--ds-space-negative-100, -8px)",
    'space.negative.150': "var(--ds-space-negative-150, -12px)",
    'space.negative.200': "var(--ds-space-negative-200, -16px)",
    'space.negative.250': "var(--ds-space-negative-250, -20px)",
    'space.negative.300': "var(--ds-space-negative-300, -24px)",
    'space.negative.400': "var(--ds-space-negative-400, -32px)"
};
const $7e5dacb61893bdcb$export$632685d741f3dbbf = {
    ...$7e5dacb61893bdcb$export$958d0ae7f2977ae4,
    ...$7e5dacb61893bdcb$export$d2dc61f58390201c
};
const $7e5dacb61893bdcb$export$2185ce37f9bdd963 = {
    'color.background.neutral.bold': 'color.text.inverse',
    'color.background.neutral.bold.hovered': 'color.text.inverse',
    'color.background.neutral.bold.pressed': 'color.text.inverse',
    'color.background.selected.bold': 'color.text.inverse',
    'color.background.selected.bold.hovered': 'color.text.inverse',
    'color.background.selected.bold.pressed': 'color.text.inverse',
    'color.background.brand.bold': 'color.text.inverse',
    'color.background.brand.bold.hovered': 'color.text.inverse',
    'color.background.brand.bold.pressed': 'color.text.inverse',
    'color.background.brand.boldest': 'color.text.inverse',
    'color.background.brand.boldest.hovered': 'color.text.inverse',
    'color.background.brand.boldest.pressed': 'color.text.inverse',
    'color.background.danger.bold': 'color.text.inverse',
    'color.background.danger.bold.hovered': 'color.text.inverse',
    'color.background.danger.bold.pressed': 'color.text.inverse',
    'color.background.warning.bold': 'color.text.warning.inverse',
    'color.background.warning.bold.hovered': 'color.text.warning.inverse',
    'color.background.warning.bold.pressed': 'color.text.warning.inverse',
    'color.background.success.bold': 'color.text.inverse',
    'color.background.success.bold.hovered': 'color.text.inverse',
    'color.background.success.bold.pressed': 'color.text.inverse',
    'color.background.discovery.bold': 'color.text.inverse',
    'color.background.discovery.bold.hovered': 'color.text.inverse',
    'color.background.discovery.bold.pressed': 'color.text.inverse',
    'color.background.information.bold': 'color.text.inverse',
    'color.background.information.bold.hovered': 'color.text.inverse',
    'color.background.information.bold.pressed': 'color.text.inverse'
};
const $7e5dacb61893bdcb$export$daf94a976c798b4f = {
    'opacity.disabled': "var(--ds-opacity-disabled, 0.4)",
    'opacity.loading': "var(--ds-opacity-loading, 0.2)"
};
const $7e5dacb61893bdcb$export$7aff6e7ba39bb774 = {
    'elevation.shadow.overflow': "var(--ds-shadow-overflow, 0px 0px 8px #1E1F2128, 0px 0px 1px #1E1F211e)",
    'elevation.shadow.overflow.perimeter': "var(--ds-shadow-overflow-perimeter, #1E1F211f)",
    'elevation.shadow.overflow.spread': "var(--ds-shadow-overflow-spread, #1E1F2129)",
    'elevation.shadow.overlay': "var(--ds-shadow-overlay, 0px 8px 12px #1E1F2126, 0px 0px 1px #1E1F214f)",
    'elevation.shadow.raised': "var(--ds-shadow-raised, 0px 1px 1px #1E1F2140, 0px 0px 1px #1E1F214f)"
};
const $7e5dacb61893bdcb$export$41a358c9c2356760 = {
    'elevation.surface': "var(--ds-surface, #FFFFFF)",
    'elevation.surface.hovered': "var(--ds-surface-hovered, #F0F1F2)",
    'elevation.surface.pressed': "var(--ds-surface-pressed, #DDDEE1)",
    'elevation.surface.overlay': "var(--ds-surface-overlay, #FFFFFF)",
    'elevation.surface.overlay.hovered': "var(--ds-surface-overlay-hovered, #F0F1F2)",
    'elevation.surface.overlay.pressed': "var(--ds-surface-overlay-pressed, #DDDEE1)",
    'elevation.surface.raised': "var(--ds-surface-raised, #FFFFFF)",
    'elevation.surface.raised.hovered': "var(--ds-surface-raised-hovered, #F0F1F2)",
    'elevation.surface.raised.pressed': "var(--ds-surface-raised-pressed, #DDDEE1)",
    'elevation.surface.sunken': "var(--ds-surface-sunken, #F8F8F8)"
};
const $7e5dacb61893bdcb$export$1531ad5bb3fbedac = {
    'color.border': "var(--ds-border, #0B120E24)",
    'color.border.accent.lime': "var(--ds-border-accent-lime, #6A9A23)",
    'color.border.accent.red': "var(--ds-border-accent-red, #E2483D)",
    'color.border.accent.orange': "var(--ds-border-accent-orange, #E06C00)",
    'color.border.accent.yellow': "var(--ds-border-accent-yellow, #B38600)",
    'color.border.accent.green': "var(--ds-border-accent-green, #22A06B)",
    'color.border.accent.teal': "var(--ds-border-accent-teal, #2898BD)",
    'color.border.accent.blue': "var(--ds-border-accent-blue, #357DE8)",
    'color.border.accent.purple': "var(--ds-border-accent-purple, #AF59E1)",
    'color.border.accent.magenta': "var(--ds-border-accent-magenta, #CD519D)",
    'color.border.accent.gray': "var(--ds-border-accent-gray, #7D818A)",
    'color.border.disabled': "var(--ds-border-disabled, #0515240F)",
    'color.border.focused': "var(--ds-border-focused, #4688EC)",
    'color.border.input': "var(--ds-border-input, #8C8F97)",
    'color.border.inverse': "var(--ds-border-inverse, #FFFFFF)",
    'color.border.selected': "var(--ds-border-selected, #1868DB)",
    'color.border.brand': "var(--ds-border-brand, #1868DB)",
    'color.border.danger': "var(--ds-border-danger, #E2483D)",
    'color.border.warning': "var(--ds-border-warning, #E06C00)",
    'color.border.success': "var(--ds-border-success, #6A9A23)",
    'color.border.discovery': "var(--ds-border-discovery, #AF59E1)",
    'color.border.information': "var(--ds-border-information, #357DE8)",
    'color.border.bold': "var(--ds-border-bold, #7D818A)"
};
const $7e5dacb61893bdcb$export$d1d79bf68ac056bd = {
    'color.background.accent.lime.subtlest': "var(--ds-background-accent-lime-subtlest, #EFFFD6)",
    'color.background.accent.lime.subtlest.hovered': "var(--ds-background-accent-lime-subtlest-hovered, #D3F1A7)",
    'color.background.accent.lime.subtlest.pressed': "var(--ds-background-accent-lime-subtlest-pressed, #BDE97C)",
    'color.background.accent.lime.subtler': "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    'color.background.accent.lime.subtler.hovered': "var(--ds-background-accent-lime-subtler-hovered, #BDE97C)",
    'color.background.accent.lime.subtler.pressed': "var(--ds-background-accent-lime-subtler-pressed, #B3DF72)",
    'color.background.accent.lime.subtle': "var(--ds-background-accent-lime-subtle, #94C748)",
    'color.background.accent.lime.subtle.hovered': "var(--ds-background-accent-lime-subtle-hovered, #B3DF72)",
    'color.background.accent.lime.subtle.pressed': "var(--ds-background-accent-lime-subtle-pressed, #BDE97C)",
    'color.background.accent.lime.bolder': "var(--ds-background-accent-lime-bolder, #5B7F24)",
    'color.background.accent.lime.bolder.hovered': "var(--ds-background-accent-lime-bolder-hovered, #4C6B1F)",
    'color.background.accent.lime.bolder.pressed': "var(--ds-background-accent-lime-bolder-pressed, #3F5224)",
    'color.background.accent.red.subtlest': "var(--ds-background-accent-red-subtlest, #FFECEB)",
    'color.background.accent.red.subtlest.hovered': "var(--ds-background-accent-red-subtlest-hovered, #FFD5D2)",
    'color.background.accent.red.subtlest.pressed': "var(--ds-background-accent-red-subtlest-pressed, #FFB8B2)",
    'color.background.accent.red.subtler': "var(--ds-background-accent-red-subtler, #FFD5D2)",
    'color.background.accent.red.subtler.hovered': "var(--ds-background-accent-red-subtler-hovered, #FFB8B2)",
    'color.background.accent.red.subtler.pressed': "var(--ds-background-accent-red-subtler-pressed, #FD9891)",
    'color.background.accent.red.subtle': "var(--ds-background-accent-red-subtle, #F87168)",
    'color.background.accent.red.subtle.hovered': "var(--ds-background-accent-red-subtle-hovered, #FD9891)",
    'color.background.accent.red.subtle.pressed': "var(--ds-background-accent-red-subtle-pressed, #FFB8B2)",
    'color.background.accent.red.bolder': "var(--ds-background-accent-red-bolder, #C9372C)",
    'color.background.accent.red.bolder.hovered': "var(--ds-background-accent-red-bolder-hovered, #AE2E24)",
    'color.background.accent.red.bolder.pressed': "var(--ds-background-accent-red-bolder-pressed, #872821)",
    'color.background.accent.orange.subtlest': "var(--ds-background-accent-orange-subtlest, #FFF5DB)",
    'color.background.accent.orange.subtlest.hovered': "var(--ds-background-accent-orange-subtlest-hovered, #FCE4A6)",
    'color.background.accent.orange.subtlest.pressed': "var(--ds-background-accent-orange-subtlest-pressed, #FBD779)",
    'color.background.accent.orange.subtler': "var(--ds-background-accent-orange-subtler, #FCE4A6)",
    'color.background.accent.orange.subtler.hovered': "var(--ds-background-accent-orange-subtler-hovered, #FBD779)",
    'color.background.accent.orange.subtler.pressed': "var(--ds-background-accent-orange-subtler-pressed, #FBC828)",
    'color.background.accent.orange.subtle': "var(--ds-background-accent-orange-subtle, #FCA700)",
    'color.background.accent.orange.subtle.hovered': "var(--ds-background-accent-orange-subtle-hovered, #FBC828)",
    'color.background.accent.orange.subtle.pressed': "var(--ds-background-accent-orange-subtle-pressed, #FBD779)",
    'color.background.accent.orange.bolder': "var(--ds-background-accent-orange-bolder, #BD5B00)",
    'color.background.accent.orange.bolder.hovered': "var(--ds-background-accent-orange-bolder-hovered, #9E4C00)",
    'color.background.accent.orange.bolder.pressed': "var(--ds-background-accent-orange-bolder-pressed, #7A3B00)",
    'color.background.accent.yellow.subtlest': "var(--ds-background-accent-yellow-subtlest, #FEF7C8)",
    'color.background.accent.yellow.subtlest.hovered': "var(--ds-background-accent-yellow-subtlest-hovered, #F5E989)",
    'color.background.accent.yellow.subtlest.pressed': "var(--ds-background-accent-yellow-subtlest-pressed, #EFDD4E)",
    'color.background.accent.yellow.subtler': "var(--ds-background-accent-yellow-subtler, #F5E989)",
    'color.background.accent.yellow.subtler.hovered': "var(--ds-background-accent-yellow-subtler-hovered, #EFDD4E)",
    'color.background.accent.yellow.subtler.pressed': "var(--ds-background-accent-yellow-subtler-pressed, #EED12B)",
    'color.background.accent.yellow.subtle': "var(--ds-background-accent-yellow-subtle, #EED12B)",
    'color.background.accent.yellow.subtle.hovered': "var(--ds-background-accent-yellow-subtle-hovered, #DDB30E)",
    'color.background.accent.yellow.subtle.pressed': "var(--ds-background-accent-yellow-subtle-pressed, #EFDD4E)",
    'color.background.accent.yellow.bolder': "var(--ds-background-accent-yellow-bolder, #946F00)",
    'color.background.accent.yellow.bolder.hovered': "var(--ds-background-accent-yellow-bolder-hovered, #7F5F01)",
    'color.background.accent.yellow.bolder.pressed': "var(--ds-background-accent-yellow-bolder-pressed, #614A05)",
    'color.background.accent.green.subtlest': "var(--ds-background-accent-green-subtlest, #DCFFF1)",
    'color.background.accent.green.subtlest.hovered': "var(--ds-background-accent-green-subtlest-hovered, #BAF3DB)",
    'color.background.accent.green.subtlest.pressed': "var(--ds-background-accent-green-subtlest-pressed, #97EDC9)",
    'color.background.accent.green.subtler': "var(--ds-background-accent-green-subtler, #BAF3DB)",
    'color.background.accent.green.subtler.hovered': "var(--ds-background-accent-green-subtler-hovered, #97EDC9)",
    'color.background.accent.green.subtler.pressed': "var(--ds-background-accent-green-subtler-pressed, #7EE2B8)",
    'color.background.accent.green.subtle': "var(--ds-background-accent-green-subtle, #4BCE97)",
    'color.background.accent.green.subtle.hovered': "var(--ds-background-accent-green-subtle-hovered, #7EE2B8)",
    'color.background.accent.green.subtle.pressed': "var(--ds-background-accent-green-subtle-pressed, #97EDC9)",
    'color.background.accent.green.bolder': "var(--ds-background-accent-green-bolder, #1F845A)",
    'color.background.accent.green.bolder.hovered': "var(--ds-background-accent-green-bolder-hovered, #216E4E)",
    'color.background.accent.green.bolder.pressed': "var(--ds-background-accent-green-bolder-pressed, #19573D)",
    'color.background.accent.teal.subtlest': "var(--ds-background-accent-teal-subtlest, #E7F9FF)",
    'color.background.accent.teal.subtlest.hovered': "var(--ds-background-accent-teal-subtlest-hovered, #C6EDFB)",
    'color.background.accent.teal.subtlest.pressed': "var(--ds-background-accent-teal-subtlest-pressed, #B1E4F7)",
    'color.background.accent.teal.subtler': "var(--ds-background-accent-teal-subtler, #C6EDFB)",
    'color.background.accent.teal.subtler.hovered': "var(--ds-background-accent-teal-subtler-hovered, #B1E4F7)",
    'color.background.accent.teal.subtler.pressed': "var(--ds-background-accent-teal-subtler-pressed, #9DD9EE)",
    'color.background.accent.teal.subtle': "var(--ds-background-accent-teal-subtle, #6CC3E0)",
    'color.background.accent.teal.subtle.hovered': "var(--ds-background-accent-teal-subtle-hovered, #9DD9EE)",
    'color.background.accent.teal.subtle.pressed': "var(--ds-background-accent-teal-subtle-pressed, #B1E4F7)",
    'color.background.accent.teal.bolder': "var(--ds-background-accent-teal-bolder, #227D9B)",
    'color.background.accent.teal.bolder.hovered': "var(--ds-background-accent-teal-bolder-hovered, #206A83)",
    'color.background.accent.teal.bolder.pressed': "var(--ds-background-accent-teal-bolder-pressed, #1A5265)",
    'color.background.accent.blue.subtlest': "var(--ds-background-accent-blue-subtlest, #E9F2FE)",
    'color.background.accent.blue.subtlest.hovered': "var(--ds-background-accent-blue-subtlest-hovered, #CFE1FD)",
    'color.background.accent.blue.subtlest.pressed': "var(--ds-background-accent-blue-subtlest-pressed, #ADCBFB)",
    'color.background.accent.blue.subtler': "var(--ds-background-accent-blue-subtler, #CFE1FD)",
    'color.background.accent.blue.subtler.hovered': "var(--ds-background-accent-blue-subtler-hovered, #ADCBFB)",
    'color.background.accent.blue.subtler.pressed': "var(--ds-background-accent-blue-subtler-pressed, #8FB8F6)",
    'color.background.accent.blue.subtle': "var(--ds-background-accent-blue-subtle, #669DF1)",
    'color.background.accent.blue.subtle.hovered': "var(--ds-background-accent-blue-subtle-hovered, #8FB8F6)",
    'color.background.accent.blue.subtle.pressed': "var(--ds-background-accent-blue-subtle-pressed, #ADCBFB)",
    'color.background.accent.blue.bolder': "var(--ds-background-accent-blue-bolder, #1868DB)",
    'color.background.accent.blue.bolder.hovered': "var(--ds-background-accent-blue-bolder-hovered, #1558BC)",
    'color.background.accent.blue.bolder.pressed': "var(--ds-background-accent-blue-bolder-pressed, #144794)",
    'color.background.accent.purple.subtlest': "var(--ds-background-accent-purple-subtlest, #F8EEFE)",
    'color.background.accent.purple.subtlest.hovered': "var(--ds-background-accent-purple-subtlest-hovered, #EED7FC)",
    'color.background.accent.purple.subtlest.pressed': "var(--ds-background-accent-purple-subtlest-pressed, #E3BDFA)",
    'color.background.accent.purple.subtler': "var(--ds-background-accent-purple-subtler, #EED7FC)",
    'color.background.accent.purple.subtler.hovered': "var(--ds-background-accent-purple-subtler-hovered, #E3BDFA)",
    'color.background.accent.purple.subtler.pressed': "var(--ds-background-accent-purple-subtler-pressed, #D8A0F7)",
    'color.background.accent.purple.subtle': "var(--ds-background-accent-purple-subtle, #C97CF4)",
    'color.background.accent.purple.subtle.hovered': "var(--ds-background-accent-purple-subtle-hovered, #D8A0F7)",
    'color.background.accent.purple.subtle.pressed': "var(--ds-background-accent-purple-subtle-pressed, #E3BDFA)",
    'color.background.accent.purple.bolder': "var(--ds-background-accent-purple-bolder, #964AC0)",
    'color.background.accent.purple.bolder.hovered': "var(--ds-background-accent-purple-bolder-hovered, #803FA5)",
    'color.background.accent.purple.bolder.pressed': "var(--ds-background-accent-purple-bolder-pressed, #673286)",
    'color.background.accent.magenta.subtlest': "var(--ds-background-accent-magenta-subtlest, #FFECF8)",
    'color.background.accent.magenta.subtlest.hovered': "var(--ds-background-accent-magenta-subtlest-hovered, #FDD0EC)",
    'color.background.accent.magenta.subtlest.pressed': "var(--ds-background-accent-magenta-subtlest-pressed, #FCB6E1)",
    'color.background.accent.magenta.subtler': "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    'color.background.accent.magenta.subtler.hovered': "var(--ds-background-accent-magenta-subtler-hovered, #FCB6E1)",
    'color.background.accent.magenta.subtler.pressed': "var(--ds-background-accent-magenta-subtler-pressed, #F797D2)",
    'color.background.accent.magenta.subtle': "var(--ds-background-accent-magenta-subtle, #E774BB)",
    'color.background.accent.magenta.subtle.hovered': "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
    'color.background.accent.magenta.subtle.pressed': "var(--ds-background-accent-magenta-subtle-pressed, #FCB6E1)",
    'color.background.accent.magenta.bolder': "var(--ds-background-accent-magenta-bolder, #AE4787)",
    'color.background.accent.magenta.bolder.hovered': "var(--ds-background-accent-magenta-bolder-hovered, #943D73)",
    'color.background.accent.magenta.bolder.pressed': "var(--ds-background-accent-magenta-bolder-pressed, #77325B)",
    'color.background.accent.gray.subtlest': "var(--ds-background-accent-gray-subtlest, #F0F1F2)",
    'color.background.accent.gray.subtlest.hovered': "var(--ds-background-accent-gray-subtlest-hovered, #DDDEE1)",
    'color.background.accent.gray.subtlest.pressed': "var(--ds-background-accent-gray-subtlest-pressed, #B7B9BE)",
    'color.background.accent.gray.subtler': "var(--ds-background-accent-gray-subtler, #DDDEE1)",
    'color.background.accent.gray.subtler.hovered': "var(--ds-background-accent-gray-subtler-hovered, #B7B9BE)",
    'color.background.accent.gray.subtler.pressed': "var(--ds-background-accent-gray-subtler-pressed, #8C8F97)",
    'color.background.accent.gray.subtle': "var(--ds-background-accent-gray-subtle, #8C8F97)",
    'color.background.accent.gray.subtle.hovered': "var(--ds-background-accent-gray-subtle-hovered, #B7B9BE)",
    'color.background.accent.gray.subtle.pressed': "var(--ds-background-accent-gray-subtle-pressed, #DDDEE1)",
    'color.background.accent.gray.bolder': "var(--ds-background-accent-gray-bolder, #6B6E76)",
    'color.background.accent.gray.bolder.hovered': "var(--ds-background-accent-gray-bolder-hovered, #505258)",
    'color.background.accent.gray.bolder.pressed': "var(--ds-background-accent-gray-bolder-pressed, #3B3D42)",
    'color.background.disabled': "var(--ds-background-disabled, #17171708)",
    'color.background.input': "var(--ds-background-input, #FFFFFF)",
    'color.background.input.hovered': "var(--ds-background-input-hovered, #F8F8F8)",
    'color.background.input.pressed': "var(--ds-background-input-pressed, #FFFFFF)",
    'color.background.inverse.subtle': "var(--ds-background-inverse-subtle, #00000029)",
    'color.background.inverse.subtle.hovered': "var(--ds-background-inverse-subtle-hovered, #0000003D)",
    'color.background.inverse.subtle.pressed': "var(--ds-background-inverse-subtle-pressed, #00000052)",
    'color.background.neutral': "var(--ds-background-neutral, #0515240F)",
    'color.background.neutral.hovered': "var(--ds-background-neutral-hovered, #0B120E24)",
    'color.background.neutral.pressed': "var(--ds-background-neutral-pressed, #080F214A)",
    'color.background.neutral.subtle': "var(--ds-background-neutral-subtle, #00000000)",
    'color.background.neutral.subtle.hovered': "var(--ds-background-neutral-subtle-hovered, #0515240F)",
    'color.background.neutral.subtle.pressed': "var(--ds-background-neutral-subtle-pressed, #0B120E24)",
    'color.background.neutral.bold': "var(--ds-background-neutral-bold, #292A2E)",
    'color.background.neutral.bold.hovered': "var(--ds-background-neutral-bold-hovered, #3B3D42)",
    'color.background.neutral.bold.pressed': "var(--ds-background-neutral-bold-pressed, #505258)",
    'color.background.selected': "var(--ds-background-selected, #E9F2FE)",
    'color.background.selected.hovered': "var(--ds-background-selected-hovered, #CFE1FD)",
    'color.background.selected.pressed': "var(--ds-background-selected-pressed, #8FB8F6)",
    'color.background.selected.bold': "var(--ds-background-selected-bold, #1868DB)",
    'color.background.selected.bold.hovered': "var(--ds-background-selected-bold-hovered, #1558BC)",
    'color.background.selected.bold.pressed': "var(--ds-background-selected-bold-pressed, #123263)",
    'color.background.brand.subtlest': "var(--ds-background-brand-subtlest, #E9F2FE)",
    'color.background.brand.subtlest.hovered': "var(--ds-background-brand-subtlest-hovered, #CFE1FD)",
    'color.background.brand.subtlest.pressed': "var(--ds-background-brand-subtlest-pressed, #ADCBFB)",
    'color.background.brand.bold': "var(--ds-background-brand-bold, #1868DB)",
    'color.background.brand.bold.hovered': "var(--ds-background-brand-bold-hovered, #1558BC)",
    'color.background.brand.bold.pressed': "var(--ds-background-brand-bold-pressed, #144794)",
    'color.background.brand.boldest': "var(--ds-background-brand-boldest, #1C2B42)",
    'color.background.brand.boldest.hovered': "var(--ds-background-brand-boldest-hovered, #123263)",
    'color.background.brand.boldest.pressed': "var(--ds-background-brand-boldest-pressed, #144794)",
    'color.background.danger': "var(--ds-background-danger, #FFECEB)",
    'color.background.danger.hovered': "var(--ds-background-danger-hovered, #FFD5D2)",
    'color.background.danger.pressed': "var(--ds-background-danger-pressed, #FFB8B2)",
    'color.background.danger.subtler': "var(--ds-background-danger-subtler, #FFD5D2)",
    'color.background.danger.subtler.hovered': "var(--ds-background-danger-subtler-hovered, #FFB8B2)",
    'color.background.danger.subtler.pressed': "var(--ds-background-danger-subtler-pressed, #FD9891)",
    'color.background.danger.bold': "var(--ds-background-danger-bold, #C9372C)",
    'color.background.danger.bold.hovered': "var(--ds-background-danger-bold-hovered, #AE2E24)",
    'color.background.danger.bold.pressed': "var(--ds-background-danger-bold-pressed, #872821)",
    'color.background.warning': "var(--ds-background-warning, #FFF5DB)",
    'color.background.warning.hovered': "var(--ds-background-warning-hovered, #FCE4A6)",
    'color.background.warning.pressed': "var(--ds-background-warning-pressed, #FBD779)",
    'color.background.warning.subtler': "var(--ds-background-warning-subtler, #FCE4A6)",
    'color.background.warning.subtler.hovered': "var(--ds-background-warning-subtler-hovered, #FBD779)",
    'color.background.warning.subtler.pressed': "var(--ds-background-warning-subtler-pressed, #FBC828)",
    'color.background.warning.bold': "var(--ds-background-warning-bold, #FBC828)",
    'color.background.warning.bold.hovered': "var(--ds-background-warning-bold-hovered, #FCA700)",
    'color.background.warning.bold.pressed': "var(--ds-background-warning-bold-pressed, #F68909)",
    'color.background.success': "var(--ds-background-success, #EFFFD6)",
    'color.background.success.hovered': "var(--ds-background-success-hovered, #D3F1A7)",
    'color.background.success.pressed': "var(--ds-background-success-pressed, #BDE97C)",
    'color.background.success.subtler': "var(--ds-background-success-subtler, #D3F1A7)",
    'color.background.success.subtler.hovered': "var(--ds-background-success-subtler-hovered, #BDE97C)",
    'color.background.success.subtler.pressed': "var(--ds-background-success-subtler-pressed, #B3DF72)",
    'color.background.success.bold': "var(--ds-background-success-bold, #5B7F24)",
    'color.background.success.bold.hovered': "var(--ds-background-success-bold-hovered, #4C6B1F)",
    'color.background.success.bold.pressed': "var(--ds-background-success-bold-pressed, #3F5224)",
    'color.background.discovery': "var(--ds-background-discovery, #F8EEFE)",
    'color.background.discovery.hovered': "var(--ds-background-discovery-hovered, #EED7FC)",
    'color.background.discovery.pressed': "var(--ds-background-discovery-pressed, #E3BDFA)",
    'color.background.discovery.subtler': "var(--ds-background-discovery-subtler, #EED7FC)",
    'color.background.discovery.subtler.hovered': "var(--ds-background-discovery-subtler-hovered, #E3BDFA)",
    'color.background.discovery.subtler.pressed': "var(--ds-background-discovery-subtler-pressed, #D8A0F7)",
    'color.background.discovery.bold': "var(--ds-background-discovery-bold, #964AC0)",
    'color.background.discovery.bold.hovered': "var(--ds-background-discovery-bold-hovered, #803FA5)",
    'color.background.discovery.bold.pressed': "var(--ds-background-discovery-bold-pressed, #673286)",
    'color.background.information': "var(--ds-background-information, #E9F2FE)",
    'color.background.information.hovered': "var(--ds-background-information-hovered, #CFE1FD)",
    'color.background.information.pressed': "var(--ds-background-information-pressed, #ADCBFB)",
    'color.background.information.subtler': "var(--ds-background-information-subtler, #CFE1FD)",
    'color.background.information.subtler.hovered': "var(--ds-background-information-subtler-hovered, #ADCBFB)",
    'color.background.information.subtler.pressed': "var(--ds-background-information-subtler-pressed, #8FB8F6)",
    'color.background.information.bold': "var(--ds-background-information-bold, #1868DB)",
    'color.background.information.bold.hovered': "var(--ds-background-information-bold-hovered, #1558BC)",
    'color.background.information.bold.pressed': "var(--ds-background-information-bold-pressed, #144794)",
    'color.blanket': "var(--ds-blanket, #050C1F75)",
    'color.blanket.selected': "var(--ds-blanket-selected, #388BFF14)",
    'color.blanket.danger': "var(--ds-blanket-danger, #EF5C4814)",
    'color.skeleton': "var(--ds-skeleton, #0515240F)",
    'color.skeleton.subtle': "var(--ds-skeleton-subtle, #17171708)",
    'elevation.surface': "var(--ds-surface, #FFFFFF)",
    'elevation.surface.hovered': "var(--ds-surface-hovered, #F0F1F2)",
    'elevation.surface.pressed': "var(--ds-surface-pressed, #DDDEE1)",
    'elevation.surface.overlay': "var(--ds-surface-overlay, #FFFFFF)",
    'elevation.surface.overlay.hovered': "var(--ds-surface-overlay-hovered, #F0F1F2)",
    'elevation.surface.overlay.pressed': "var(--ds-surface-overlay-pressed, #DDDEE1)",
    'elevation.surface.raised': "var(--ds-surface-raised, #FFFFFF)",
    'elevation.surface.raised.hovered': "var(--ds-surface-raised-hovered, #F0F1F2)",
    'elevation.surface.raised.pressed': "var(--ds-surface-raised-pressed, #DDDEE1)",
    'elevation.surface.sunken': "var(--ds-surface-sunken, #F8F8F8)",
    'utility.elevation.surface.current': "var(--ds-elevation-surface-current, #FFFFFF)"
};
const $7e5dacb61893bdcb$export$8473307aa00d6ea1 = {
    'color.text': "var(--ds-text, #292A2E)",
    'color.text.accent.lime': "var(--ds-text-accent-lime, #4C6B1F)",
    'color.text.accent.lime.bolder': "var(--ds-text-accent-lime-bolder, #37471F)",
    'color.text.accent.red': "var(--ds-text-accent-red, #AE2E24)",
    'color.text.accent.red.bolder': "var(--ds-text-accent-red-bolder, #5D1F1A)",
    'color.text.accent.orange': "var(--ds-text-accent-orange, #9E4C00)",
    'color.text.accent.orange.bolder': "var(--ds-text-accent-orange-bolder, #693200)",
    'color.text.accent.yellow': "var(--ds-text-accent-yellow, #7F5F01)",
    'color.text.accent.yellow.bolder': "var(--ds-text-accent-yellow-bolder, #533F04)",
    'color.text.accent.green': "var(--ds-text-accent-green, #216E4E)",
    'color.text.accent.green.bolder': "var(--ds-text-accent-green-bolder, #164B35)",
    'color.text.accent.teal': "var(--ds-text-accent-teal, #206A83)",
    'color.text.accent.teal.bolder': "var(--ds-text-accent-teal-bolder, #164555)",
    'color.text.accent.blue': "var(--ds-text-accent-blue, #1558BC)",
    'color.text.accent.blue.bolder': "var(--ds-text-accent-blue-bolder, #123263)",
    'color.text.accent.purple': "var(--ds-text-accent-purple, #803FA5)",
    'color.text.accent.purple.bolder': "var(--ds-text-accent-purple-bolder, #48245D)",
    'color.text.accent.magenta': "var(--ds-text-accent-magenta, #943D73)",
    'color.text.accent.magenta.bolder': "var(--ds-text-accent-magenta-bolder, #50253F)",
    'color.text.accent.gray': "var(--ds-text-accent-gray, #505258)",
    'color.text.accent.gray.bolder': "var(--ds-text-accent-gray-bolder, #1E1F21)",
    'color.text.disabled': "var(--ds-text-disabled, #080F214A)",
    'color.text.inverse': "var(--ds-text-inverse, #FFFFFF)",
    'color.text.selected': "var(--ds-text-selected, #1868DB)",
    'color.text.brand': "var(--ds-text-brand, #1868DB)",
    'color.text.danger': "var(--ds-text-danger, #AE2E24)",
    'color.text.danger.bolder': "var(--ds-text-danger-bolder, #5D1F1A)",
    'color.text.warning': "var(--ds-text-warning, #9E4C00)",
    'color.text.warning.inverse': "var(--ds-text-warning-inverse, #292A2E)",
    'color.text.warning.bolder': "var(--ds-text-warning-bolder, #693200)",
    'color.text.success': "var(--ds-text-success, #4C6B1F)",
    'color.text.success.bolder': "var(--ds-text-success-bolder, #37471F)",
    'color.text.discovery': "var(--ds-text-discovery, #803FA5)",
    'color.text.discovery.bolder': "var(--ds-text-discovery-bolder, #48245D)",
    'color.text.information': "var(--ds-text-information, #1558BC)",
    'color.text.information.bolder': "var(--ds-text-information-bolder, #123263)",
    'color.text.subtlest': "var(--ds-text-subtlest, #6B6E76)",
    'color.text.subtle': "var(--ds-text-subtle, #505258)",
    'color.link': "var(--ds-link, #1868DB)",
    'color.link.pressed': "var(--ds-link-pressed, #1558BC)",
    'color.link.visited': "var(--ds-link-visited, #803FA5)",
    'color.link.visited.pressed': "var(--ds-link-visited-pressed, #48245D)"
};
const $7e5dacb61893bdcb$export$498780f74be9af68 = {
    'color.icon': "var(--ds-icon, #292A2E)",
    'color.icon.accent.lime': "var(--ds-icon-accent-lime, #6A9A23)",
    'color.icon.accent.red': "var(--ds-icon-accent-red, #C9372C)",
    'color.icon.accent.orange': "var(--ds-icon-accent-orange, #E06C00)",
    'color.icon.accent.yellow': "var(--ds-icon-accent-yellow, #B38600)",
    'color.icon.accent.green': "var(--ds-icon-accent-green, #22A06B)",
    'color.icon.accent.teal': "var(--ds-icon-accent-teal, #2898BD)",
    'color.icon.accent.blue': "var(--ds-icon-accent-blue, #357DE8)",
    'color.icon.accent.purple': "var(--ds-icon-accent-purple, #AF59E1)",
    'color.icon.accent.magenta': "var(--ds-icon-accent-magenta, #CD519D)",
    'color.icon.accent.gray': "var(--ds-icon-accent-gray, #7D818A)",
    'color.icon.disabled': "var(--ds-icon-disabled, #080F214A)",
    'color.icon.inverse': "var(--ds-icon-inverse, #FFFFFF)",
    'color.icon.selected': "var(--ds-icon-selected, #1868DB)",
    'color.icon.brand': "var(--ds-icon-brand, #1868DB)",
    'color.icon.danger': "var(--ds-icon-danger, #C9372C)",
    'color.icon.warning': "var(--ds-icon-warning, #E06C00)",
    'color.icon.warning.inverse': "var(--ds-icon-warning-inverse, #292A2E)",
    'color.icon.success': "var(--ds-icon-success, #6A9A23)",
    'color.icon.discovery': "var(--ds-icon-discovery, #AF59E1)",
    'color.icon.information': "var(--ds-icon-information, #357DE8)",
    'color.icon.subtlest': "var(--ds-icon-subtlest, #6B6E76)",
    'color.icon.subtle': "var(--ds-icon-subtle, #505258)"
};
const $7e5dacb61893bdcb$export$b5f31a7e431d2eab = {
    '1': 1,
    card: 100,
    navigation: 200,
    dialog: 300,
    layer: 400,
    blanket: 500,
    modal: 510,
    flag: 600,
    spotlight: 700,
    tooltip: 800
};
const $7e5dacb61893bdcb$export$e1b83c5210c471b8 = {
    'border.width': "var(--ds-border-width, 1px)",
    'border.width.selected': "var(--ds-border-width-selected, 2px)",
    'border.width.focused': "var(--ds-border-width-focused, 2px)"
};
const $7e5dacb61893bdcb$export$3c0a6c3e64bb180d = {
    'radius.xsmall': "var(--ds-radius-xsmall, 2px)",
    'radius.small': "var(--ds-radius-small, 3px)",
    'radius.medium': "var(--ds-radius-medium, 6px)",
    'radius.large': "var(--ds-radius-large, 8px)",
    'radius.xlarge': "var(--ds-radius-xlarge, 12px)",
    'radius.xxlarge': "var(--ds-radius-xxlarge, 16px)",
    'radius.full': "var(--ds-radius-full, 9999px)",
    'radius.tile': "var(--ds-radius-tile, 25%)"
};
const $7e5dacb61893bdcb$export$6ffa317d5e70375 = {
    'font.body': 'var(--ds-font-body, normal 400 14px/20px "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    // @deprecated
    'font.body.UNSAFE_small': 'var(--ds-font-body-UNSAFE_small, normal 400 12px/16px "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    'font.body.large': 'var(--ds-font-body-large, normal 400 16px/24px "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    'font.body.small': 'var(--ds-font-body-small, normal 400 12px/16px "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    'font.code': 'var(--ds-font-code, normal 400 0.875em/1 "Atlassian Mono", ui-monospace, Menlo, "Segoe UI Mono", "Ubuntu Mono", monospace)',
    'font.heading.large': 'var(--ds-font-heading-large, normal 653 24px/28px "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    'font.heading.medium': 'var(--ds-font-heading-medium, normal 653 20px/24px "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    'font.heading.small': 'var(--ds-font-heading-small, normal 653 16px/20px "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    'font.heading.xlarge': 'var(--ds-font-heading-xlarge, normal 653 28px/32px "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    'font.heading.xsmall': 'var(--ds-font-heading-xsmall, normal 653 14px/20px "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    'font.heading.xxlarge': 'var(--ds-font-heading-xxlarge, normal 653 32px/36px "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    'font.heading.xxsmall': 'var(--ds-font-heading-xxsmall, normal 653 12px/16px "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    'font.metric.large': 'var(--ds-font-metric-large, normal 653 28px/32px "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    'font.metric.medium': 'var(--ds-font-metric-medium, normal 653 24px/28px "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    'font.metric.small': 'var(--ds-font-metric-small, normal 653 16px/20px "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)'
};
const $7e5dacb61893bdcb$export$303e322c6b1ed114 = {
    'font.weight.bold': "var(--ds-font-weight-bold, 653)",
    'font.weight.medium': "var(--ds-font-weight-medium, 500)",
    'font.weight.regular': "var(--ds-font-weight-regular, 400)",
    'font.weight.semibold': "var(--ds-font-weight-semibold, 600)"
};
const $7e5dacb61893bdcb$export$3c7e9587132614b4 = {
    'font.family.body': 'var(--ds-font-family-body, "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    'font.family.brand.body': 'var(--ds-font-family-brand-body, "Charlie Text", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    'font.family.brand.heading': 'var(--ds-font-family-brand-heading, "Charlie Display", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    'font.family.code': 'var(--ds-font-family-code, "Atlassian Mono", ui-monospace, Menlo, "Segoe UI Mono", "Ubuntu Mono", monospace)',
    'font.family.heading': 'var(--ds-font-family-heading, "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)'
};
const $7e5dacb61893bdcb$export$236bfe3a33ef1292 = {
    medium: 'var(--ds-font-body, normal 400 14px/20px "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    UNSAFE_small: 'var(--ds-font-body-UNSAFE_small, normal 400 12px/16px "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    large: 'var(--ds-font-body-large, normal 400 16px/24px "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    small: 'var(--ds-font-body-small, normal 400 12px/16px "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)'
};
const $7e5dacb61893bdcb$export$855cfd311192d666 = {
    bold: "var(--ds-font-weight-bold, 653)",
    medium: "var(--ds-font-weight-medium, 500)",
    regular: "var(--ds-font-weight-regular, 400)",
    semibold: "var(--ds-font-weight-semibold, 600)"
};
const $7e5dacb61893bdcb$export$b805719bc8cb376 = {
    large: 'var(--ds-font-metric-large, normal 653 28px/32px "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    medium: 'var(--ds-font-metric-medium, normal 653 24px/28px "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)',
    small: 'var(--ds-font-metric-small, normal 653 16px/20px "Atlassian Sans", ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, "Helvetica Neue", sans-serif)'
};
const $7e5dacb61893bdcb$var$spacingProperties = [
    // Used by Box
    'padding',
    'paddingBlock',
    'paddingBlockStart',
    'paddingBlockEnd',
    'paddingInline',
    'paddingInlineStart',
    'paddingInlineEnd',
    // Used by Inline and Stack
    'gap',
    'rowGap',
    'columnGap'
];
const $7e5dacb61893bdcb$export$ca0f9c2de39ffed7 = (cssProperty, tokenMap)=>{
    return Object.keys(tokenMap).reduce((emotionSpacingMap, token)=>{
        // eslint-disable-next-line @repo/internal/styles/no-exported-styles
        emotionSpacingMap[token] = /*#__PURE__*/ (0, $9K4OG.css)({
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            [cssProperty]: tokenMap[token]
        });
        return emotionSpacingMap;
    }, {});
};
const $7e5dacb61893bdcb$export$e615f061ca585a6c = $7e5dacb61893bdcb$var$spacingProperties.reduce((styleMap, spacingProperty)=>{
    styleMap[spacingProperty] = $7e5dacb61893bdcb$export$ca0f9c2de39ffed7(spacingProperty, $7e5dacb61893bdcb$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
const $7e5dacb61893bdcb$export$bf46c3f9eeafc71f = $7e5dacb61893bdcb$var$spacingProperties.reduce((styleMap, spacingProperty)=>{
    styleMap[spacingProperty] = $7e5dacb61893bdcb$export$ca0f9c2de39ffed7(spacingProperty, $7e5dacb61893bdcb$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
const $7e5dacb61893bdcb$export$e7af83bafe7f9e63 = $7e5dacb61893bdcb$export$ca0f9c2de39ffed7('backgroundColor', $7e5dacb61893bdcb$export$d1d79bf68ac056bd);
const $7e5dacb61893bdcb$export$3a1bcba60b23d7f0 = $7e5dacb61893bdcb$export$ca0f9c2de39ffed7('color', $7e5dacb61893bdcb$export$8473307aa00d6ea1);
const $7e5dacb61893bdcb$export$45f3f4fe16f9f7d5 = $7e5dacb61893bdcb$export$ca0f9c2de39ffed7('fontWeight', $7e5dacb61893bdcb$export$303e322c6b1ed114);
const $7e5dacb61893bdcb$export$68cc305da27dbaa4 = $7e5dacb61893bdcb$export$ca0f9c2de39ffed7('fontFamily', $7e5dacb61893bdcb$export$3c7e9587132614b4);
const $7e5dacb61893bdcb$export$128f10c238242f83 = $7e5dacb61893bdcb$export$ca0f9c2de39ffed7('font', $7e5dacb61893bdcb$export$6ffa317d5e70375);
const $7e5dacb61893bdcb$export$219d364c0da35ae4 = $7e5dacb61893bdcb$export$ca0f9c2de39ffed7('font', $7e5dacb61893bdcb$export$236bfe3a33ef1292);
const $7e5dacb61893bdcb$export$38845ca010b93505 = $7e5dacb61893bdcb$export$ca0f9c2de39ffed7('fontWeight', $7e5dacb61893bdcb$export$855cfd311192d666);
const $7e5dacb61893bdcb$export$ff257d957d48c421 = $7e5dacb61893bdcb$export$ca0f9c2de39ffed7((0, $a9dFP.CURRENT_SURFACE_CSS_VAR), $7e5dacb61893bdcb$export$41a358c9c2356760);
const $7e5dacb61893bdcb$export$5e65a44e5b6ecadb = (color)=>$7e5dacb61893bdcb$export$41a358c9c2356760[color] !== undefined;
const $7e5dacb61893bdcb$export$7001ce64d9ff7c7f = $7e5dacb61893bdcb$export$ca0f9c2de39ffed7('font', $7e5dacb61893bdcb$export$b805719bc8cb376);
module.exports["dimensionMap"] = $7e5dacb61893bdcb$export$6ccdbebca2ee545f;
module.exports["positiveSpaceMap"] = $7e5dacb61893bdcb$export$958d0ae7f2977ae4;
module.exports["allSpaceMap"] = $7e5dacb61893bdcb$export$632685d741f3dbbf;
module.exports["inverseColorMap"] = $7e5dacb61893bdcb$export$2185ce37f9bdd963;
module.exports["opacityMap"] = $7e5dacb61893bdcb$export$daf94a976c798b4f;
module.exports["shadowMap"] = $7e5dacb61893bdcb$export$7aff6e7ba39bb774;
module.exports["borderColorMap"] = $7e5dacb61893bdcb$export$1531ad5bb3fbedac;
module.exports["backgroundColorMap"] = $7e5dacb61893bdcb$export$d1d79bf68ac056bd;
module.exports["textColorMap"] = $7e5dacb61893bdcb$export$8473307aa00d6ea1;
module.exports["layerMap"] = $7e5dacb61893bdcb$export$b5f31a7e431d2eab;
module.exports["borderWidthMap"] = $7e5dacb61893bdcb$export$e1b83c5210c471b8;
module.exports["borderRadiusMap"] = $7e5dacb61893bdcb$export$3c0a6c3e64bb180d;
module.exports["fontMap"] = $7e5dacb61893bdcb$export$6ffa317d5e70375;
module.exports["fontWeightMap"] = $7e5dacb61893bdcb$export$303e322c6b1ed114;
module.exports["fontFamilyMap"] = $7e5dacb61893bdcb$export$3c7e9587132614b4;
module.exports["paddingStylesMap"] = $7e5dacb61893bdcb$export$e615f061ca585a6c;
module.exports["spaceStylesMap"] = $7e5dacb61893bdcb$export$bf46c3f9eeafc71f;
module.exports["backgroundColorStylesMap"] = $7e5dacb61893bdcb$export$e7af83bafe7f9e63;
module.exports["textColorStylesMap"] = $7e5dacb61893bdcb$export$3a1bcba60b23d7f0;
module.exports["textSizeStylesMap"] = $7e5dacb61893bdcb$export$219d364c0da35ae4;
module.exports["textWeightStylesMap"] = $7e5dacb61893bdcb$export$38845ca010b93505;
module.exports["surfaceColorStylesMap"] = $7e5dacb61893bdcb$export$ff257d957d48c421;
module.exports["isSurfaceColorToken"] = $7e5dacb61893bdcb$export$5e65a44e5b6ecadb;

});

parcelRegister("ecnYn", function(module, exports) {
/* xcss.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
parcelRequire("42omo");


var $9K4OG = parcelRequire("9K4OG");


var $avd77 = parcelRequire("avd77");


var $kyRHQ = parcelRequire("kyRHQ");

const $612ff9077a434533$export$9a199fbafee0014e = {
    backgroundColor: (0, $avd77.backgroundColorMap),
    blockSize: (0, $avd77.dimensionMap),
    borderBlockColor: (0, $avd77.borderColorMap),
    borderBlockEndColor: (0, $avd77.borderColorMap),
    borderBlockEndWidth: (0, $avd77.borderWidthMap),
    borderBlockStartColor: (0, $avd77.borderColorMap),
    borderBlockStartWidth: (0, $avd77.borderWidthMap),
    borderBlockWidth: (0, $avd77.borderWidthMap),
    borderBottomColor: (0, $avd77.borderColorMap),
    borderBottomLeftRadius: (0, $avd77.borderRadiusMap),
    borderBottomRightRadius: (0, $avd77.borderRadiusMap),
    borderBottomWidth: (0, $avd77.borderWidthMap),
    borderColor: (0, $avd77.borderColorMap),
    borderEndEndRadius: (0, $avd77.borderRadiusMap),
    borderEndStartRadius: (0, $avd77.borderRadiusMap),
    borderInlineColor: (0, $avd77.borderColorMap),
    borderInlineEndColor: (0, $avd77.borderColorMap),
    borderInlineEndWidth: (0, $avd77.borderWidthMap),
    borderInlineStartColor: (0, $avd77.borderColorMap),
    borderInlineStartWidth: (0, $avd77.borderWidthMap),
    borderInlineWidth: (0, $avd77.borderWidthMap),
    borderLeftColor: (0, $avd77.borderColorMap),
    borderLeftWidth: (0, $avd77.borderWidthMap),
    borderRadius: (0, $avd77.borderRadiusMap),
    borderRightColor: (0, $avd77.borderColorMap),
    borderRightWidth: (0, $avd77.borderWidthMap),
    borderStartEndRadius: (0, $avd77.borderRadiusMap),
    borderStartStartRadius: (0, $avd77.borderRadiusMap),
    borderTopColor: (0, $avd77.borderColorMap),
    borderTopLeftRadius: (0, $avd77.borderRadiusMap),
    borderTopRightRadius: (0, $avd77.borderRadiusMap),
    borderTopWidth: (0, $avd77.borderWidthMap),
    borderWidth: (0, $avd77.borderWidthMap),
    bottom: (0, $avd77.allSpaceMap),
    boxShadow: (0, $avd77.shadowMap),
    color: (0, $avd77.textColorMap),
    columnGap: (0, $avd77.positiveSpaceMap),
    font: (0, $avd77.fontMap),
    fontFamily: (0, $avd77.fontFamilyMap),
    fontWeight: (0, $avd77.fontWeightMap),
    gap: (0, $avd77.positiveSpaceMap),
    height: (0, $avd77.dimensionMap),
    inlineSize: (0, $avd77.dimensionMap),
    inset: (0, $avd77.allSpaceMap),
    insetBlock: (0, $avd77.allSpaceMap),
    insetBlockEnd: (0, $avd77.allSpaceMap),
    insetBlockStart: (0, $avd77.allSpaceMap),
    insetInline: (0, $avd77.allSpaceMap),
    insetInlineEnd: (0, $avd77.allSpaceMap),
    insetInlineStart: (0, $avd77.allSpaceMap),
    left: (0, $avd77.allSpaceMap),
    margin: (0, $avd77.allSpaceMap),
    marginBlock: (0, $avd77.allSpaceMap),
    marginBlockEnd: (0, $avd77.allSpaceMap),
    marginBlockStart: (0, $avd77.allSpaceMap),
    marginBottom: (0, $avd77.allSpaceMap),
    marginInline: (0, $avd77.allSpaceMap),
    marginInlineEnd: (0, $avd77.allSpaceMap),
    marginInlineStart: (0, $avd77.allSpaceMap),
    marginLeft: (0, $avd77.allSpaceMap),
    marginRight: (0, $avd77.allSpaceMap),
    marginTop: (0, $avd77.allSpaceMap),
    maxBlockSize: (0, $avd77.dimensionMap),
    maxHeight: (0, $avd77.dimensionMap),
    maxInlineSize: (0, $avd77.dimensionMap),
    maxWidth: (0, $avd77.dimensionMap),
    minBlockSize: (0, $avd77.dimensionMap),
    minHeight: (0, $avd77.dimensionMap),
    minInlineSize: (0, $avd77.dimensionMap),
    minWidth: (0, $avd77.dimensionMap),
    opacity: (0, $avd77.opacityMap),
    outlineColor: (0, $avd77.borderColorMap),
    outlineOffset: (0, $avd77.allSpaceMap),
    outlineWidth: (0, $avd77.borderWidthMap),
    padding: (0, $avd77.positiveSpaceMap),
    paddingBlock: (0, $avd77.positiveSpaceMap),
    paddingBlockEnd: (0, $avd77.positiveSpaceMap),
    paddingBlockStart: (0, $avd77.positiveSpaceMap),
    paddingBottom: (0, $avd77.positiveSpaceMap),
    paddingInline: (0, $avd77.positiveSpaceMap),
    paddingInlineEnd: (0, $avd77.positiveSpaceMap),
    paddingInlineStart: (0, $avd77.positiveSpaceMap),
    paddingLeft: (0, $avd77.positiveSpaceMap),
    paddingRight: (0, $avd77.positiveSpaceMap),
    paddingTop: (0, $avd77.positiveSpaceMap),
    right: (0, $avd77.allSpaceMap),
    rowGap: (0, $avd77.positiveSpaceMap),
    top: (0, $avd77.allSpaceMap),
    width: (0, $avd77.dimensionMap),
    zIndex: (0, $avd77.layerMap)
};
const $612ff9077a434533$var$uniqueSymbol = Symbol('UNSAFE_INTERNAL_styles');
const $612ff9077a434533$var$isSafeEnvToThrow = ()=>typeof $kyRHQ === 'object' && typeof $kyRHQ.env === 'object' && false;
const $612ff9077a434533$var$reNestedSelectors = /(\.|\s|&+|\*\>|#|\[.*\])/;
const $612ff9077a434533$var$safeSelectors = /^@media .*$|^::?.*$|^@supports .*$/;
const $612ff9077a434533$var$transformStyles = (styleObj)=>{
    if (!styleObj || typeof styleObj !== 'object') return styleObj;
     // If styles are defined as a CSSObject[], recursively call on each element until we reach CSSObject
    if (Array.isArray(styleObj)) return styleObj.map($612ff9077a434533$var$transformStyles);
     // Modifies styleObj in place. Be careful.
    Object.entries(styleObj).forEach(([key, value])=>{
        // If key is a pseudo class or a pseudo element, then value should be an object.
        // So, call transformStyles on the value
        if (typeof value === 'object' && $612ff9077a434533$var$safeSelectors.test(key)) {
            styleObj[key] = $612ff9077a434533$var$transformStyles(value);
            return;
        }
        if ($612ff9077a434533$var$isSafeEnvToThrow()) {
            // We don't support `.class`, `[data-testid]`, `> *`, `#some-id`
            if ($612ff9077a434533$var$reNestedSelectors.test(key)) throw new Error(`Styles not supported for key '${key}'.`);
        } // We have now dealt with all the special cases, so,
        // check whether what remains is a style property
        // that can be transformed.
        if (!(key in $612ff9077a434533$export$9a199fbafee0014e)) return;
        const tokenValue = $612ff9077a434533$export$9a199fbafee0014e[key][value];
        styleObj[key] = tokenValue ?? value;
    });
    return styleObj;
};
const $612ff9077a434533$var$baseXcss = (style)=>{
    const transformedStyles = $612ff9077a434533$var$transformStyles(style);
    return {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        [$612ff9077a434533$var$uniqueSymbol]: /*#__PURE__*/ (0, $9K4OG.css)(transformedStyles)
    };
}; /**
    * Picks out runtime XCSS objects and build-time XCSS strings. This is needed
    * to supported both Emotion and Compiled styles until we've fully migrated
    * to Compiled.
    *
    * @private
    * @deprecated
    */ 
const $612ff9077a434533$export$a9c84988c8f81f2d = (args)=>{
    if (Array.isArray(args)) {
        const emotion = [];
        const staticArr = [];
        for (const arg of args){
            const result = $612ff9077a434533$export$a9c84988c8f81f2d(arg);
            if (result.emotion) emotion.push(...result.emotion);
            if (result.static) staticArr.push(result.static);
        }
        return {
            emotion: emotion,
            static: staticArr.join(' ')
        };
    }
    const objArgs = args;
    const { [$612ff9077a434533$var$uniqueSymbol]: styles } = objArgs || {};
    if (styles) return {
        emotion: [
            styles
        ]
    };
    if (args) {
        // We use string interpolation here instead of .toString() just
        // in case the resulting object doesn't have the method available.
        const stringifiedArgs = `${args}`;
        if (stringifiedArgs) return {
            static: stringifiedArgs
        };
    }
    return {};
};
function $612ff9077a434533$export$f6c783d06584602c(style) {
    return $612ff9077a434533$var$baseXcss(style);
}
module.exports["parseXcss"] = $612ff9077a434533$export$a9c84988c8f81f2d;
module.exports["xcss"] = $612ff9077a434533$export$f6c783d06584602c;

});

parcelRegister("auNCB", function(module, exports) {
/* anchor.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $1bHXt = parcelRequire("1bHXt");


var $dRnqM = parcelRequire("dRnqM");


var $gxtzC = parcelRequire("gxtzC");


var $6i41U = parcelRequire("6i41U");


var $ee7An = parcelRequire("ee7An");


var $c0qxy = parcelRequire("c0qxy");


var $90YwQ = parcelRequire("90YwQ");


var $6F6hl = parcelRequire("6F6hl");


var $1HnpQ = parcelRequire("1HnpQ");

const $f11abad57339aafd$var$styles = {
    root: "_4bfu1r31 _1hms8stv _ajmmnqa1 _vchhusvi",
    position: "_kqswh2mm"
};
const $f11abad57339aafd$var$IS_EXTERNAL_LINK_REGEX = /^(?:(http|https):\/\/)/;
const $f11abad57339aafd$var$IS_NON_HTTP_BASED = /^(((mailto|tel|sms|blob):)|(#))/; /**
                                                              * __Anchor__
                                                              *
                                                              * A primitive for building custom anchor links.
                                                              *
                                                              * - [Examples](https://atlassian.design/components/primitives/anchor/examples)
                                                              * - [Code](https://atlassian.design/components/primitives/anchor/code)
                                                              * - [Usage](https://atlassian.design/components/primitives/anchor/usage)
                                                              */ 
const $f11abad57339aafd$var$AnchorNoRef = ({ href: href, children: children, onClick: providedOnClick = (0, $ee7An.default), interactionName: interactionName, componentName: componentName, analyticsContext: analyticsContext, 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledBy, style: style, target: target, testId: testId, xcss: xcss, newWindowLabel: newWindowLabel = '(opens new window)', ...htmlAttributes }, ref)=>{
    const interactionContext = (0, $42omo.useContext)((0, $90YwQ.default));
    const handleClick = (0, $42omo.useCallback)((e, analyticsEvent)=>{
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    const opensNewWindowLabelId = (0, $c0qxy.useId)();
    const onClick = (0, $gxtzC.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: 'clicked',
        componentName: componentName || 'Anchor',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local",
        analyticsData: analyticsContext,
        actionSubject: 'link'
    }); // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    const { className: _spreadClass, ...safeHtmlAttributes } = htmlAttributes;
    const RouterLink = (0, $6i41U.default)();
    const isExternal = typeof href === 'string' && $f11abad57339aafd$var$IS_EXTERNAL_LINK_REGEX.test(href);
    const isNonHttpBased = typeof href === 'string' && $f11abad57339aafd$var$IS_NON_HTTP_BASED.test(href); /**
                                                                                    * Renders a router link if:
                                                                                    *
                                                                                    * - a link component is set in the app provider
                                                                                    * - it's not an external link (starting with `http://` or `https://`)
                                                                                    * - it's not a non-HTTP-based link (e.g. emails, phone numbers, hash links etc.).
                                                                                    */ 
    const isRouterLink = RouterLink && !isExternal && !isNonHttpBased;
    const hrefObjectUsedWithoutRouterLink = RouterLink === undefined && typeof href === 'object';
    (0, $dRnqM.default)(!hrefObjectUsedWithoutRouterLink, `@atlaskit/primitives: Anchor primitive cannot pass an object to 'href' unless a router link is configured in the AppProvider`);
    const Component = isRouterLink ? RouterLink : 'a';
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $1HnpQ.default // @ts-expect-error we don't allow `a` on Focusable for makers as they should use Anchor instead
    ), {
        as: Component,
        className: xcss,
        style: style,
        ref: ref,
        ...safeHtmlAttributes,
        href: !isRouterLink && typeof href !== 'string' ? undefined : href,
        target: target,
        onClick: onClick,
        "aria-label": ariaLabel && target === '_blank' && !ariaLabelledBy ? `${ariaLabel} , ${newWindowLabel}` : ariaLabel,
        "aria-labelledby": ariaLabelledBy && target === '_blank' ? `${ariaLabelledBy} ${opensNewWindowLabelId}` : ariaLabelledBy,
        xcss: (0, $1bHXt.cx)($f11abad57339aafd$var$styles.root, $f11abad57339aafd$var$styles.position, xcss),
        testId: testId,
        "data-is-router-link": testId ? isRouterLink ? 'true' : 'false' : undefined,
        children: [
            children,
            target === '_blank' && (children && !ariaLabel && !ariaLabelledBy || ariaLabelledBy) && /*#__PURE__*/ (0, $l998X.jsx)((0, $6F6hl.default), {
                id: opensNewWindowLabelId,
                children: `, ${newWindowLabel}`
            })
        ]
    });
};
// Workarounds to support generic types with forwardRef
/**
 * __Anchor__
 *
 * Anchor is a primitive for building custom anchor links. It's a wrapper around the HTML `<a>` element that provides a consistent API for handling client-side routing and Atlassian Design System styling.
 *
 * - [Examples](https://atlassian.design/components/primitives/anchor/examples)
 * - [Code](https://atlassian.design/components/primitives/anchor/code)
 * - [Usage](https://atlassian.design/components/primitives/anchor/usage)
 */ const $f11abad57339aafd$var$Anchor = /*#__PURE__*/ (0, $42omo.forwardRef)($f11abad57339aafd$var$AnchorNoRef);
var $f11abad57339aafd$export$2e2bcd8739ae039 = $f11abad57339aafd$var$Anchor;
module.exports["default"] = $f11abad57339aafd$export$2e2bcd8739ae039;

});

parcelRegister("gdv5Z", function(module, exports) {
/* box.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $5rrZR = parcelRequire("5rrZR");

const $57ce31ea3f72b099$var$baseStyles = null;
const $57ce31ea3f72b099$var$backgroundColorMap = {
    'color.background.accent.lime.subtlest': "_bfhkm890",
    'color.background.accent.lime.subtlest.hovered': "_bfhkd4y8",
    'color.background.accent.lime.subtlest.pressed': "_bfhkkuup",
    'color.background.accent.lime.subtler': "_bfhkz2ec",
    'color.background.accent.lime.subtler.hovered': "_bfhk1gf0",
    'color.background.accent.lime.subtler.pressed': "_bfhk2kxc",
    'color.background.accent.lime.subtle': "_bfhkbq5w",
    'color.background.accent.lime.subtle.hovered': "_bfhkfoww",
    'color.background.accent.lime.subtle.pressed': "_bfhk1jbd",
    'color.background.accent.lime.bolder': "_bfhktde4",
    'color.background.accent.lime.bolder.hovered': "_bfhknzpa",
    'color.background.accent.lime.bolder.pressed': "_bfhkh0j0",
    'color.background.accent.red.subtlest': "_bfhk1vk5",
    'color.background.accent.red.subtlest.hovered': "_bfhk1i6i",
    'color.background.accent.red.subtlest.pressed': "_bfhknbir",
    'color.background.accent.red.subtler': "_bfhk1rtt",
    'color.background.accent.red.subtler.hovered': "_bfhkaffd",
    'color.background.accent.red.subtler.pressed': "_bfhk1j5a",
    'color.background.accent.red.subtle': "_bfhkkrt9",
    'color.background.accent.red.subtle.hovered': "_bfhk1sou",
    'color.background.accent.red.subtle.pressed': "_bfhk1fnn",
    'color.background.accent.red.bolder': "_bfhkuibq",
    'color.background.accent.red.bolder.hovered': "_bfhk100f",
    'color.background.accent.red.bolder.pressed': "_bfhk1cl6",
    'color.background.accent.orange.subtlest': "_bfhkf5uh",
    'color.background.accent.orange.subtlest.hovered': "_bfhk19yr",
    'color.background.accent.orange.subtlest.pressed': "_bfhkf90x",
    'color.background.accent.orange.subtler': "_bfhk165s",
    'color.background.accent.orange.subtler.hovered': "_bfhk1ei0",
    'color.background.accent.orange.subtler.pressed': "_bfhkdpo3",
    'color.background.accent.orange.subtle': "_bfhk1kkj",
    'color.background.accent.orange.subtle.hovered': "_bfhk9mfs",
    'color.background.accent.orange.subtle.pressed': "_bfhkaxpp",
    'color.background.accent.orange.bolder': "_bfhk1qg1",
    'color.background.accent.orange.bolder.hovered': "_bfhk12qo",
    'color.background.accent.orange.bolder.pressed': "_bfhk1fyq",
    'color.background.accent.yellow.subtlest': "_bfhkibhp",
    'color.background.accent.yellow.subtlest.hovered': "_bfhkaetg",
    'color.background.accent.yellow.subtlest.pressed': "_bfhk1o1l",
    'color.background.accent.yellow.subtler': "_bfhk1773",
    'color.background.accent.yellow.subtler.hovered': "_bfhk1uw7",
    'color.background.accent.yellow.subtler.pressed': "_bfhk1r9w",
    'color.background.accent.yellow.subtle': "_bfhk8y3s",
    'color.background.accent.yellow.subtle.hovered': "_bfhk819w",
    'color.background.accent.yellow.subtle.pressed': "_bfhk1jx0",
    'color.background.accent.yellow.bolder': "_bfhk1vop",
    'color.background.accent.yellow.bolder.hovered': "_bfhkkjqf",
    'color.background.accent.yellow.bolder.pressed': "_bfhk1okt",
    'color.background.accent.green.subtlest': "_bfhkn729",
    'color.background.accent.green.subtlest.hovered': "_bfhk3utz",
    'color.background.accent.green.subtlest.pressed': "_bfhkyfny",
    'color.background.accent.green.subtler': "_bfhk1wnw",
    'color.background.accent.green.subtler.hovered': "_bfhk1e2h",
    'color.background.accent.green.subtler.pressed': "_bfhkybhx",
    'color.background.accent.green.subtle': "_bfhk1rsu",
    'color.background.accent.green.subtle.hovered': "_bfhk12e3",
    'color.background.accent.green.subtle.pressed': "_bfhk1g86",
    'color.background.accent.green.bolder': "_bfhk1e5c",
    'color.background.accent.green.bolder.hovered': "_bfhka5yi",
    'color.background.accent.green.bolder.pressed': "_bfhk1j68",
    'color.background.accent.teal.subtlest': "_bfhk7xuz",
    'color.background.accent.teal.subtlest.hovered': "_bfhk108c",
    'color.background.accent.teal.subtlest.pressed': "_bfhk1cxp",
    'color.background.accent.teal.subtler': "_bfhk1a17",
    'color.background.accent.teal.subtler.hovered': "_bfhkkwwr",
    'color.background.accent.teal.subtler.pressed': "_bfhk1jb0",
    'color.background.accent.teal.subtle': "_bfhktdv8",
    'color.background.accent.teal.subtle.hovered': "_bfhkzh8h",
    'color.background.accent.teal.subtle.pressed': "_bfhk16zl",
    'color.background.accent.teal.bolder': "_bfhk2c8p",
    'color.background.accent.teal.bolder.hovered': "_bfhkl3ve",
    'color.background.accent.teal.bolder.pressed': "_bfhktor0",
    'color.background.accent.blue.subtlest': "_bfhk1s93",
    'color.background.accent.blue.subtlest.hovered': "_bfhkdaj9",
    'color.background.accent.blue.subtlest.pressed': "_bfhkxm0g",
    'color.background.accent.blue.subtler': "_bfhk1dy8",
    'color.background.accent.blue.subtler.hovered': "_bfhk815t",
    'color.background.accent.blue.subtler.pressed': "_bfhkrwxf",
    'color.background.accent.blue.subtle': "_bfhk115i",
    'color.background.accent.blue.subtle.hovered': "_bfhk9pr4",
    'color.background.accent.blue.subtle.pressed': "_bfhknpx7",
    'color.background.accent.blue.bolder': "_bfhk16e3",
    'color.background.accent.blue.bolder.hovered': "_bfhk1vbm",
    'color.background.accent.blue.bolder.pressed': "_bfhk1xwi",
    'color.background.accent.purple.subtlest': "_bfhkp2ly",
    'color.background.accent.purple.subtlest.hovered': "_bfhkkca2",
    'color.background.accent.purple.subtlest.pressed': "_bfhk1jbm",
    'color.background.accent.purple.subtler': "_bfhk1nm4",
    'color.background.accent.purple.subtler.hovered': "_bfhkattl",
    'color.background.accent.purple.subtler.pressed': "_bfhk3nfk",
    'color.background.accent.purple.subtle': "_bfhk18ah",
    'color.background.accent.purple.subtle.hovered': "_bfhk8bp1",
    'color.background.accent.purple.subtle.pressed': "_bfhk1cd2",
    'color.background.accent.purple.bolder': "_bfhkya33",
    'color.background.accent.purple.bolder.hovered': "_bfhk1af5",
    'color.background.accent.purple.bolder.pressed': "_bfhk6cze",
    'color.background.accent.magenta.subtlest': "_bfhk8tvm",
    'color.background.accent.magenta.subtlest.hovered': "_bfhkr3zd",
    'color.background.accent.magenta.subtlest.pressed': "_bfhk1ckf",
    'color.background.accent.magenta.subtler': "_bfhkv9ra",
    'color.background.accent.magenta.subtler.hovered': "_bfhk1axx",
    'color.background.accent.magenta.subtler.pressed': "_bfhk42ri",
    'color.background.accent.magenta.subtle': "_bfhk1mi6",
    'color.background.accent.magenta.subtle.hovered': "_bfhkrwyz",
    'color.background.accent.magenta.subtle.pressed': "_bfhk6c15",
    'color.background.accent.magenta.bolder': "_bfhkc3uk",
    'color.background.accent.magenta.bolder.hovered': "_bfhk1ok8",
    'color.background.accent.magenta.bolder.pressed': "_bfhkeawv",
    'color.background.accent.gray.subtlest': "_bfhkysee",
    'color.background.accent.gray.subtlest.hovered': "_bfhkwejn",
    'color.background.accent.gray.subtlest.pressed': "_bfhk18ut",
    'color.background.accent.gray.subtler': "_bfhk7qp0",
    'color.background.accent.gray.subtler.hovered': "_bfhk10ef",
    'color.background.accent.gray.subtler.pressed': "_bfhk1rk9",
    'color.background.accent.gray.subtle': "_bfhk18j9",
    'color.background.accent.gray.subtle.hovered': "_bfhk1nv3",
    'color.background.accent.gray.subtle.pressed': "_bfhkq9tj",
    'color.background.accent.gray.bolder': "_bfhk1i45",
    'color.background.accent.gray.bolder.hovered': "_bfhkbyip",
    'color.background.accent.gray.bolder.pressed': "_bfhk1van",
    'color.background.disabled': "_bfhkby5v",
    'color.background.input': "_bfhk1j9a",
    'color.background.input.hovered': "_bfhkl4ek",
    'color.background.input.pressed': "_bfhkr01l",
    'color.background.inverse.subtle': "_bfhk1vck",
    'color.background.inverse.subtle.hovered': "_bfhkmpja",
    'color.background.inverse.subtle.pressed': "_bfhk1gii",
    'color.background.neutral': "_bfhki8nm",
    'color.background.neutral.hovered': "_bfhkplhp",
    'color.background.neutral.pressed': "_bfhk1gdz",
    'color.background.neutral.subtle': "_bfhksm61",
    'color.background.neutral.subtle.hovered': "_bfhk1dpa",
    'color.background.neutral.subtle.pressed': "_bfhkfcek",
    'color.background.neutral.bold': "_bfhk1aqn",
    'color.background.neutral.bold.hovered': "_bfhk1ibz",
    'color.background.neutral.bold.pressed': "_bfhkof27",
    'color.background.selected': "_bfhk15s3",
    'color.background.selected.hovered': "_bfhkufnl",
    'color.background.selected.pressed': "_bfhknozp",
    'color.background.selected.bold': "_bfhkjmqp",
    'color.background.selected.bold.hovered': "_bfhk1q28",
    'color.background.selected.bold.pressed': "_bfhk12kk",
    'color.background.brand.subtlest': "_bfhk1gmr",
    'color.background.brand.subtlest.hovered': "_bfhk3v15",
    'color.background.brand.subtlest.pressed': "_bfhku02c",
    'color.background.brand.bold': "_bfhk1856",
    'color.background.brand.bold.hovered': "_bfhkhf2y",
    'color.background.brand.bold.pressed': "_bfhkg6ey",
    'color.background.brand.boldest': "_bfhk1o4i",
    'color.background.brand.boldest.hovered': "_bfhklefx",
    'color.background.brand.boldest.pressed': "_bfhk16k6",
    'color.background.danger': "_bfhk1gly",
    'color.background.danger.hovered': "_bfhk1yvi",
    'color.background.danger.pressed': "_bfhk1r4b",
    'color.background.danger.bold': "_bfhkybec",
    'color.background.danger.bold.hovered': "_bfhks9hg",
    'color.background.danger.bold.pressed': "_bfhk13a9",
    'color.background.warning': "_bfhk1917",
    'color.background.warning.hovered': "_bfhk19zu",
    'color.background.warning.pressed': "_bfhkzr32",
    'color.background.warning.bold': "_bfhk1kmu",
    'color.background.warning.bold.hovered': "_bfhk1spp",
    'color.background.warning.bold.pressed': "_bfhk4m4m",
    'color.background.success': "_bfhk1y9u",
    'color.background.success.hovered': "_bfhk1vfx",
    'color.background.success.pressed': "_bfhk1wl5",
    'color.background.success.bold': "_bfhkkcmj",
    'color.background.success.bold.hovered': "_bfhky7x8",
    'color.background.success.bold.pressed': "_bfhkwcbh",
    'color.background.discovery': "_bfhk6vm6",
    'color.background.discovery.hovered': "_bfhk12eq",
    'color.background.discovery.pressed': "_bfhk18vq",
    'color.background.discovery.bold': "_bfhku5tj",
    'color.background.discovery.bold.hovered': "_bfhkfqeg",
    'color.background.discovery.bold.pressed': "_bfhk1f1m",
    'color.background.information': "_bfhk19ip",
    'color.background.information.hovered': "_bfhk86z5",
    'color.background.information.pressed': "_bfhk1c1j",
    'color.background.information.bold': "_bfhkx4w0",
    'color.background.information.bold.hovered': "_bfhkq2ii",
    'color.background.information.bold.pressed': "_bfhkf89v",
    'color.blanket': "_bfhk1i5c",
    'color.blanket.selected': "_bfhk7wq0",
    'color.blanket.danger': "_bfhkrprw",
    'color.skeleton': "_bfhkizff",
    'color.skeleton.subtle': "_bfhkvkf5",
    'elevation.surface': "_bfhkvuon",
    'elevation.surface.hovered': "_bfhk19i6",
    'elevation.surface.pressed': "_bfhk13ro",
    'elevation.surface.overlay': "_bfhk1bhr",
    'elevation.surface.overlay.hovered': "_bfhk6o2t",
    'elevation.surface.overlay.pressed': "_bfhkm8nx",
    'elevation.surface.raised': "_bfhkhp5a",
    'elevation.surface.raised.hovered': "_bfhk116u",
    'elevation.surface.raised.pressed': "_bfhk14aj",
    'elevation.surface.sunken': "_bfhkhfxm",
    'utility.elevation.surface.current': "_bfhkchd4"
};
const $57ce31ea3f72b099$var$CURRENT_SURFACE_CSS_VAR = `--ds-elevation-surface-current`;
const $57ce31ea3f72b099$var$setSurfaceTokenMap = {
    'elevation.surface': "_1q1lvuon",
    'elevation.surface.hovered': "_1q1l19i6",
    'elevation.surface.pressed': "_1q1l13ro",
    'elevation.surface.overlay': "_1q1l1bhr",
    'elevation.surface.overlay.hovered': "_1q1l6o2t",
    'elevation.surface.overlay.pressed': "_1q1lm8nx",
    'elevation.surface.raised': "_1q1lhp5a",
    'elevation.surface.raised.hovered': "_1q1l116u",
    'elevation.surface.raised.pressed': "_1q1l14aj",
    'elevation.surface.sunken': "_1q1lhfxm"
};
const $57ce31ea3f72b099$var$paddingBlockStartMap = {
    'space.0': "_1q51ze3t",
    'space.025': "_1q51v77o",
    'space.050': "_1q511b66",
    'space.075': "_1q5112x7",
    'space.100': "_1q51u2gc",
    'space.150': "_1q51utpp",
    'space.200': "_1q51pxbi",
    'space.250': "_1q51v47k",
    'space.300': "_1q511ejb",
    'space.400': "_1q51xy5q",
    'space.500': "_1q511jfw",
    'space.600': "_1q51oahv",
    'space.800': "_1q51xncg",
    'space.1000': "_1q511epz"
};
const $57ce31ea3f72b099$var$paddingBlockEndMap = {
    'space.0': "_85i5ze3t",
    'space.025': "_85i5v77o",
    'space.050': "_85i51b66",
    'space.075': "_85i512x7",
    'space.100': "_85i5u2gc",
    'space.150': "_85i5utpp",
    'space.200': "_85i5pxbi",
    'space.250': "_85i5v47k",
    'space.300': "_85i51ejb",
    'space.400': "_85i5xy5q",
    'space.500': "_85i51jfw",
    'space.600': "_85i5oahv",
    'space.800': "_85i5xncg",
    'space.1000': "_85i51epz"
};
const $57ce31ea3f72b099$var$paddingInlineStartMap = {
    'space.0': "_bozgze3t",
    'space.025': "_bozgv77o",
    'space.050': "_bozg1b66",
    'space.075': "_bozg12x7",
    'space.100': "_bozgu2gc",
    'space.150': "_bozgutpp",
    'space.200': "_bozgpxbi",
    'space.250': "_bozgv47k",
    'space.300': "_bozg1ejb",
    'space.400': "_bozgxy5q",
    'space.500': "_bozg1jfw",
    'space.600': "_bozgoahv",
    'space.800': "_bozgxncg",
    'space.1000': "_bozg1epz"
};
const $57ce31ea3f72b099$var$paddingInlineEndMap = {
    'space.0': "_y4tize3t",
    'space.025': "_y4tiv77o",
    'space.050': "_y4ti1b66",
    'space.075': "_y4ti12x7",
    'space.100': "_y4tiu2gc",
    'space.150': "_y4tiutpp",
    'space.200': "_y4tipxbi",
    'space.250': "_y4tiv47k",
    'space.300': "_y4ti1ejb",
    'space.400': "_y4tixy5q",
    'space.500': "_y4ti1jfw",
    'space.600': "_y4tioahv",
    'space.800': "_y4tixncg",
    'space.1000': "_y4ti1epz"
}; /**
    * __Box__
    *
    * A Box is a primitive component that has the design decisions of the Atlassian Design System baked in.
    * Renders a `div` by default.
    *
    * - [Examples](https://atlassian.design/components/primitives/box/examples)
    * - [Code](https://atlassian.design/components/primitives/box/code)
    * - [Usage](https://atlassian.design/components/primitives/box/usage)
    */ 
const $57ce31ea3f72b099$var$Box = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: Component = 'div', children: children, backgroundColor: backgroundColor, padding: padding, paddingBlock: paddingBlock = padding, paddingBlockStart: paddingBlockStart = paddingBlock, paddingBlockEnd: paddingBlockEnd = paddingBlock, paddingInline: paddingInline = padding, paddingInlineStart: paddingInlineStart = paddingInline, paddingInlineEnd: paddingInlineEnd = paddingInline, style: style, testId: testId, xcss: xcss, ...htmlAttributes }, ref)=>{
    // This is to remove className from safeHtmlAttributes
    // @ts-ignore -- not using expect since it causes issues with help-center local consumption - className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    const { className: _spreadClass, ...safeHtmlAttributes } = htmlAttributes;
    const node = /*#__PURE__*/ (0, $l998X.jsx)(Component // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    , {
        style: style,
        ref: ref,
        className: (0, $gMc0m.default)([
            "_19itglyw _vchhusvi _r06hglyw",
            backgroundColor && $57ce31ea3f72b099$var$backgroundColorMap[backgroundColor],
            backgroundColor && $57ce31ea3f72b099$var$isSurfaceToken(backgroundColor) && $57ce31ea3f72b099$var$setSurfaceTokenMap[backgroundColor],
            paddingBlockStart && $57ce31ea3f72b099$var$paddingBlockStartMap[paddingBlockStart],
            paddingBlockEnd && $57ce31ea3f72b099$var$paddingBlockEndMap[paddingBlockEnd],
            paddingInlineStart && $57ce31ea3f72b099$var$paddingInlineStartMap[paddingInlineStart],
            paddingInlineEnd && $57ce31ea3f72b099$var$paddingInlineEndMap[paddingInlineEnd],
            xcss
        ]),
        ...safeHtmlAttributes,
        "data-testid": testId,
        children: children
    });
    if (backgroundColor) return /*#__PURE__*/ (0, $l998X.jsx)((0, $5rrZR.SurfaceContext).Provider, {
        value: backgroundColor,
        children: node
    });
    return node;
});
var $57ce31ea3f72b099$export$2e2bcd8739ae039 = $57ce31ea3f72b099$var$Box;
function $57ce31ea3f72b099$var$isSurfaceToken(backgroundColor) {
    return backgroundColor in $57ce31ea3f72b099$var$setSurfaceTokenMap;
}
module.exports["default"] = $57ce31ea3f72b099$export$2e2bcd8739ae039;

});

parcelRegister("u9agA", function(module, exports) {
/* inline.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $1Whri = parcelRequire("1Whri");


var $1s5hv = parcelRequire("1s5hv");

const $99c9b99bf8ec1016$var$styles = {
    separator: "_1mouze3t _195g1i6y _syazazsu _lcxvglyw _uiztglyw",
    hug: "_16jlidpf",
    fill: "_1bsb1osq _16jlkb7n"
};
const $99c9b99bf8ec1016$var$Separator = ({ children: children })=>/*#__PURE__*/ (0, $l998X.jsx)("span", {
        className: (0, $gMc0m.default)([
            $99c9b99bf8ec1016$var$styles.separator
        ]),
        children: children
    }); /**
                                                                   * __Inline__
                                                                   *
                                                                   * Inline is a primitive component based on CSS Flexbox that manages the horizontal layout of direct children.
                                                                   *
                                                                   * @example
                                                                   * ```tsx
                                                                   *  <Inline>
                                                                   *    <Box padding="space.100" backgroundColor="neutral"></Box>
                                                                   *    <Box padding="space.100" backgroundColor="neutral"></Box>
                                                                   *  </Inline>
                                                                   * ```
                                                                   *
                                                                   */ 
const $99c9b99bf8ec1016$var$Inline = /*#__PURE__*/ (0, $42omo.memo)(/*#__PURE__*/ (0, $42omo.forwardRef)(({ as: as, alignInline: alignInline, alignBlock: alignItems = 'start', shouldWrap: shouldWrap = false, spread: spread, grow: grow, space: space, rowSpace: rowSpace, separator: separator, xcss: xcss, testId: testId, role: role, children: rawChildren, ...ariaAttributes }, ref)=>{
    const separatorComponent = typeof separator === 'string' ? /*#__PURE__*/ (0, $l998X.jsx)($99c9b99bf8ec1016$var$Separator, {
        children: separator
    }) : separator;
    const children = separatorComponent ? (0, $42omo.Children).toArray(rawChildren).filter(Boolean).map((child, index)=>{
        return /*#__PURE__*/ (0, $l998X.jsxs)((0, $42omo.Fragment), {
            children: [
                separator && index > 0 ? separatorComponent : null,
                child
            ]
        }, index);
    }) : rawChildren;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $1s5hv.default), {
        ...ariaAttributes,
        as: as,
        role: role,
        alignItems: alignItems,
        justifyContent: spread || alignInline,
        direction: "row",
        gap: space,
        rowGap: rowSpace,
        wrap: shouldWrap ? 'wrap' : undefined,
        xcss: (0, $1Whri.cx)(grow === 'hug' && $99c9b99bf8ec1016$var$styles.hug, grow === 'fill' && $99c9b99bf8ec1016$var$styles.fill, xcss),
        testId: testId,
        ref: ref,
        children: children
    });
}));
$99c9b99bf8ec1016$var$Inline.displayName = 'Inline';
var $99c9b99bf8ec1016$export$2e2bcd8739ae039 = $99c9b99bf8ec1016$var$Inline;
module.exports["default"] = $99c9b99bf8ec1016$export$2e2bcd8739ae039;

});

parcelRegister("iXCQx", function(module, exports) {
/* text.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $dRnqM = parcelRequire("dRnqM");


var $kFobZ = parcelRequire("kFobZ");


var $5rrZR = parcelRequire("5rrZR");

const $30e81a3114605546$var$asAllowlist = [
    'span',
    'p',
    'strong',
    'em'
];
const $30e81a3114605546$var$useColor = (colorProp, hasTextAncestor)=>{
    const surface = (0, $5rrZR.useSurface)();
    if (colorProp === 'inherit') return undefined;
    if (colorProp) return colorProp;
    if (hasTextAncestor) return undefined;
    if ($30e81a3114605546$export$2185ce37f9bdd963.hasOwnProperty(surface)) return $30e81a3114605546$export$2185ce37f9bdd963[surface];
    return 'color.text';
};
const $30e81a3114605546$var$styles = {
    root: "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1i4qfg65",
    'as.strong': "_k48pwu06",
    'as.em': "_zg8l1m30",
    'textAlign.center': "_y3gn1h6o",
    'textAlign.end': "_y3gnh9n0",
    'textAlign.start': "_y3gnv2br",
    truncation: "_1reo15vq _18m915vq _1e0ccj1k _sudp1e54",
    breakAll: "_1nmz9jpi"
};
const $30e81a3114605546$var$fontSizeMap = {
    medium: "_11c8fhey",
    UNSAFE_small: "_11c8rymc",
    large: "_11c81d4k",
    small: "_11c8wadc"
};
const $30e81a3114605546$var$fontWeightMap = {
    bold: "_k48pwu06",
    medium: "_k48p1wq8",
    regular: "_k48pi7a9",
    semibold: "_k48p1pd9"
};
const $30e81a3114605546$var$textColorMap = {
    'color.text': "_syazi7uo",
    'color.text.accent.lime': "_syaz1tco",
    'color.text.accent.lime.bolder': "_syaz1ik3",
    'color.text.accent.red': "_syaz9lu1",
    'color.text.accent.red.bolder': "_syazhwvp",
    'color.text.accent.orange': "_syazp1lv",
    'color.text.accent.orange.bolder': "_syaz7i1p",
    'color.text.accent.yellow': "_syazfb2s",
    'color.text.accent.yellow.bolder': "_syazekll",
    'color.text.accent.green': "_syazh55r",
    'color.text.accent.green.bolder': "_syaz1y78",
    'color.text.accent.teal': "_syaz17qg",
    'color.text.accent.teal.bolder': "_syaz12v7",
    'color.text.accent.blue': "_syaz16jw",
    'color.text.accent.blue.bolder': "_syaz1kyx",
    'color.text.accent.purple': "_syazqmo9",
    'color.text.accent.purple.bolder': "_syaz1mn1",
    'color.text.accent.magenta': "_syaz1s8m",
    'color.text.accent.magenta.bolder': "_syaz1qur",
    'color.text.accent.gray': "_syaz1sqi",
    'color.text.accent.gray.bolder': "_syaz1tmo",
    'color.text.disabled': "_syaz1gmx",
    'color.text.inverse': "_syaz15cr",
    'color.text.selected': "_syaz6x5g",
    'color.text.brand': "_syaz1oa5",
    'color.text.danger': "_syaz1tmw",
    'color.text.warning': "_syaz1xn9",
    'color.text.warning.inverse': "_syaz1yd3",
    'color.text.success': "_syazgsak",
    'color.text.discovery': "_syazdv2p",
    'color.text.information': "_syazu3tg",
    'color.text.subtlest': "_syaz1rpy",
    'color.text.subtle': "_syazazsu",
    'color.link': "_syaz13af",
    'color.link.pressed': "_syaz12zz",
    'color.link.visited': "_syaz1ra0",
    'color.link.visited.pressed': "_syaz17z1"
};
const $30e81a3114605546$export$2185ce37f9bdd963 = {
    'color.background.neutral.bold': 'color.text.inverse',
    'color.background.neutral.bold.hovered': 'color.text.inverse',
    'color.background.neutral.bold.pressed': 'color.text.inverse',
    'color.background.selected.bold': 'color.text.inverse',
    'color.background.selected.bold.hovered': 'color.text.inverse',
    'color.background.selected.bold.pressed': 'color.text.inverse',
    'color.background.brand.bold': 'color.text.inverse',
    'color.background.brand.bold.hovered': 'color.text.inverse',
    'color.background.brand.bold.pressed': 'color.text.inverse',
    'color.background.brand.boldest': 'color.text.inverse',
    'color.background.brand.boldest.hovered': 'color.text.inverse',
    'color.background.brand.boldest.pressed': 'color.text.inverse',
    'color.background.danger.bold': 'color.text.inverse',
    'color.background.danger.bold.hovered': 'color.text.inverse',
    'color.background.danger.bold.pressed': 'color.text.inverse',
    'color.background.warning.bold': 'color.text.warning.inverse',
    'color.background.warning.bold.hovered': 'color.text.warning.inverse',
    'color.background.warning.bold.pressed': 'color.text.warning.inverse',
    'color.background.success.bold': 'color.text.inverse',
    'color.background.success.bold.hovered': 'color.text.inverse',
    'color.background.success.bold.pressed': 'color.text.inverse',
    'color.background.discovery.bold': 'color.text.inverse',
    'color.background.discovery.bold.hovered': 'color.text.inverse',
    'color.background.discovery.bold.pressed': 'color.text.inverse',
    'color.background.information.bold': 'color.text.inverse',
    'color.background.information.bold.hovered': 'color.text.inverse',
    'color.background.information.bold.pressed': 'color.text.inverse'
};
/**
 * __Text__
 *
 * Text is a primitive component that has the Atlassian Design System's design guidelines baked in.
 * This includes considerations for text attributes such as color, font size, font weight, and line height.
 * It renders a `span` by default.
 *
 * @internal
 */ const $30e81a3114605546$var$Text = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: Component = 'span', color: colorProp, align: align, testId: testId, id: id, size: size, weight: weight, maxLines: maxLines, xcss: xcss, children: children }, ref)=>{
    (0, $dRnqM.default)($30e81a3114605546$var$asAllowlist.includes(Component), `@atlaskit/primitives: Text received an invalid "as" value of "${Component}"`);
    const hasTextAncestor = (0, $kFobZ.useHasTextAncestor)();
    const color = $30e81a3114605546$var$useColor(colorProp, hasTextAncestor);
    if (!size && !hasTextAncestor) size = 'medium';
    const component = /*#__PURE__*/ (0, $l998X.jsx)(Component, {
        id: id,
        className: (0, $gMc0m.default)([
            $30e81a3114605546$var$styles.root,
            size && $30e81a3114605546$var$fontSizeMap[size],
            color && $30e81a3114605546$var$textColorMap[color],
            maxLines && $30e81a3114605546$var$styles.truncation,
            maxLines === 1 && $30e81a3114605546$var$styles.breakAll,
            align && $30e81a3114605546$var$styles[`textAlign.${align}`],
            weight && $30e81a3114605546$var$fontWeightMap[weight],
            Component === 'em' && $30e81a3114605546$var$styles['as.em'],
            Component === 'strong' && $30e81a3114605546$var$styles['as.strong'],
            xcss
        ]),
        style: {
            WebkitLineClamp: maxLines
        },
        "data-testid": testId,
        ref: ref,
        children: children
    });
    if (hasTextAncestor) // no need to re-apply context if the text is already wrapped
    return component;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $kFobZ.HasTextAncestorProvider), {
        value: true,
        children: component
    });
});
var $30e81a3114605546$export$2e2bcd8739ae039 = $30e81a3114605546$var$Text;
module.exports["default"] = $30e81a3114605546$export$2e2bcd8739ae039;

});

parcelRegister("eyWa4", function(module, exports) {
/* stack.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $1Whri = parcelRequire("1Whri");


var $1s5hv = parcelRequire("1s5hv");

const $222464dfbbd88f38$var$styles = {
    hug: "_16jlidpf",
    fill: "_1bsb1osq _16jlkb7n"
};
/**
 * __Stack__
 *
 * Stack is a primitive component based on flexbox that manages the block layout of direct children.
 *
 * @example
 * ```tsx
 *  <Stack>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *  </Stack>
 * ```
 *
 */ const $222464dfbbd88f38$var$Stack = /*#__PURE__*/ (0, $42omo.memo)(/*#__PURE__*/ (0, $42omo.forwardRef)(({ as: as, alignInline: alignItems, alignBlock: alignBlock = 'stretch', spread: spread, grow: grow, space: space, children: children, testId: testId, xcss: xcss, role: role, ...ariaAttributes }, ref)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $1s5hv.default), {
        ...ariaAttributes,
        as: as,
        role: role,
        gap: space,
        direction: "column",
        alignItems: alignItems,
        justifyContent: spread || alignBlock,
        xcss: (0, $1Whri.cx)(grow === 'hug' && $222464dfbbd88f38$var$styles.hug, grow === 'fill' && $222464dfbbd88f38$var$styles.fill, xcss),
        testId: testId,
        ref: ref,
        children: children
    });
}));
$222464dfbbd88f38$var$Stack.displayName = 'Stack';
var $222464dfbbd88f38$export$2e2bcd8739ae039 = $222464dfbbd88f38$var$Stack;
module.exports["default"] = $222464dfbbd88f38$export$2e2bcd8739ae039;

});

parcelRegister("4KS7f", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $bOG3Z = parcelRequire("bOG3Z");


var $gcG0P = parcelRequire("gcG0P");


var $hYfEs = parcelRequire("hYfEs");


var $etbQ0 = parcelRequire("etbQ0");


var $boHsq = parcelRequire("boHsq");

function $ecebd5c55c31879a$var$getInteractionState({ isDisabled: isDisabled = false, isActive: isActive = false, isFocus: isFocus = false, isHover: isHover = false, isSelected: isSelected = false, isLoading: isLoading = false }) {
    if (isDisabled) return 'disabled';
    if (isSelected && isFocus) return 'focusSelected';
    if (isSelected) return 'selected';
    // not allowing active or focus style changes while loading
    if (!isLoading && isActive) return 'active';
    if (!isLoading && isHover) return 'hover';
    if (isFocus) return 'focus';
    return 'default';
}
const $ecebd5c55c31879a$var$initial = {
    isHover: false,
    isActive: false,
    isFocus: false
};
/**
 * __Custom theme button__
 *
 * @deprecated Legacy buttons are deprecated and will be removed from `atlaskit/button` in an upcoming major release. Please use the new Button components from `@atlaskit/button/new`
 *
 * Please refer to the [migration guide](https://atlassian.design/components/button/button-legacy/migration-guide) for further details.
 *
 * A custom theme button. Avoid using this component. It exists for those already using custom theming, which is hard to use and has performance issues.
 *
 * - [Examples](https://atlassian.design/components/button/examples#custom-theme-button)
 */ const $ecebd5c55c31879a$var$CustomThemeButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).forwardRef(function CustomThemeButton({ appearance: // Calculate default props for use in custom themes
appearance = 'default', autoFocus: autoFocus = false, isDisabled: isDisabled = false, isSelected: isSelected = false, shouldFitContainer: shouldFitContainer = false, spacing: spacing = 'default', isLoading: isLoading = false, onMouseEnter: providedOnMouseEnter, onMouseLeave: providedOnMouseLeave, onMouseDown: providedOnMouseDown, onMouseUp: providedOnMouseUp, onFocus: providedOnFocus, onBlur: providedOnBlur, theme: theme = (0, $boHsq.defaultThemeFn), ...rest }, ref) {
    // TODO is there a nicer way to do this?
    // Add default props back into object for spreading
    const restProps = {
        appearance: appearance,
        autoFocus: autoFocus,
        isDisabled: isDisabled,
        isSelected: isSelected,
        shouldFitContainer: shouldFitContainer,
        spacing: spacing,
        ...rest
    };
    const [state, setState] = (0, $42omo.useState)($ecebd5c55c31879a$var$initial);
    const onMouseEnter = (0, $42omo.useCallback)((event)=>{
        setState((current)=>({
                ...current,
                isHover: true
            }));
        if (providedOnMouseEnter) providedOnMouseEnter(event);
    }, [
        providedOnMouseEnter
    ]);
    const onMouseLeave = (0, $42omo.useCallback)((event)=>{
        setState((current)=>({
                ...current,
                isHover: false,
                isActive: false
            }));
        if (providedOnMouseLeave) providedOnMouseLeave(event);
    }, [
        providedOnMouseLeave
    ]);
    const onMouseDown = (0, $42omo.useCallback)((event)=>{
        setState((current)=>({
                ...current,
                isActive: true
            }));
        if (providedOnMouseDown) providedOnMouseDown(event);
    }, [
        providedOnMouseDown
    ]);
    const onMouseUp = (0, $42omo.useCallback)((event)=>{
        setState((current)=>({
                ...current,
                isActive: false
            }));
        if (providedOnMouseUp) providedOnMouseUp(event);
    }, [
        providedOnMouseUp
    ]);
    const onFocus = (0, $42omo.useCallback)((event)=>{
        setState((current)=>({
                ...current,
                isFocus: true
            }));
        if (providedOnFocus) providedOnFocus(event);
    }, [
        providedOnFocus
    ]);
    const onBlur = (0, $42omo.useCallback)((event)=>{
        setState((current)=>({
                ...current,
                isFocus: false
            }));
        if (providedOnBlur) providedOnBlur(event);
    }, [
        providedOnBlur
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $boHsq.default).Provider, {
        value: theme,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $bOG3Z.default).Consumer, {
            children: ({ mode: mode })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $boHsq.default).Consumer, {
                    mode: mode,
                    state: $ecebd5c55c31879a$var$getInteractionState({
                        ...state,
                        isLoading: isLoading,
                        isSelected: restProps.isSelected,
                        isDisabled: restProps.isDisabled
                    }),
                    iconIsOnlyChild: (0, $hYfEs.default)(restProps),
                    isLoading: isLoading,
                    ...restProps,
                    children: ({ buttonStyles: buttonStyles })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $gcG0P.default), {
                            ...restProps,
                            ref: ref,
                            overlay: isLoading ? /*#__PURE__*/ (0, $l998X.jsx)((0, $etbQ0.default), {
                                ...restProps
                            }) : null,
                            // No need to render aria-disabled when it is false
                            "aria-disabled": isLoading || restProps['aria-disabled'],
                            onMouseEnter: onMouseEnter,
                            onMouseLeave: onMouseLeave,
                            onMouseDown: onMouseDown,
                            onMouseUp: onMouseUp,
                            onFocus: onFocus,
                            onBlur: onBlur,
                            buttonCss: (0, $boHsq.getSpecifiers)(buttonStyles)
                        })
                })
        })
    });
}));
// Tools including enzyme rely on components having a display name
$ecebd5c55c31879a$var$CustomThemeButton.displayName = 'CustomThemeButton';
var $ecebd5c55c31879a$export$2e2bcd8739ae039 = $ecebd5c55c31879a$var$CustomThemeButton;
module.exports["default"] = $ecebd5c55c31879a$export$2e2bcd8739ae039;

});

parcelRegister("boHsq", function(module, exports) {
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $9j05A = parcelRequire("9j05A");


var $10BNt = parcelRequire("10BNt");

const $8730f26c81bbd247$var$stateToSelectorMap = {
    focus: '&:focus',
    focusSelected: '&:focus',
    hover: '&:hover',
    active: '&:active',
    disabled: '&[disabled]'
};
function $8730f26c81bbd247$export$31512de7fa606fa4({ appearance: appearance = 'default', spacing: spacing = 'default', mode: mode = 'light', isSelected: isSelected = false, shouldFitContainer: shouldFitContainer = false, iconIsOnlyChild: iconIsOnlyChild = false, isLoading: isLoading = false, state: state }) {
    let result = (0, $10BNt.getCss)({
        appearance: appearance,
        spacing: spacing,
        mode: mode,
        isSelected: isSelected,
        shouldFitContainer: shouldFitContainer,
        isOnlySingleIcon: iconIsOnlyChild
    });
    // we need to disable the default browser focus styles always
    // this is because we are not expressing that we can have two pseudo states at a time
    result.outline = 'none';
    // Pulling relevant styles up to the top level
    const selector = $8730f26c81bbd247$var$stateToSelectorMap[state];
    if (selector) result = {
        ...result,
        ...result[selector]
    };
    if (isLoading) result = {
        ...result,
        // Pull overlay styles up to the top
        ...result['&[data-has-overlay="true"]']
    };
    // Delete all selectors and just keep root styles
    Object.keys(result).forEach((key)=>{
        // want to keep this one
        if (key === '&::-moz-focus-inner') return;
        // Not using .startsWith for ie11
        if (key.indexOf('&') === 0) delete result[key];
    });
    return result;
}
function $8730f26c81bbd247$export$643db0b8d8778e(styles) {
    return {
        '&, &:hover, &:active, &:focus, &:focus-visible, &:visited, &:disabled, &[disabled]': styles
    };
}
function $8730f26c81bbd247$export$437a7f77d13d7916(current, values) {
    return current(values);
}
const $8730f26c81bbd247$var$Theme = (0, $9j05A.createTheme)((themeProps)=>({
        buttonStyles: $8730f26c81bbd247$export$31512de7fa606fa4(themeProps),
        // No styles being applied directly to spinner by default
        // Keeping this for legacy compat. We could remove it, but given
        // that we are changing theme soon there is no point
        spinnerStyles: {}
    }));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$8730f26c81bbd247$export$2e2bcd8739ae039 = $8730f26c81bbd247$var$Theme;
module.exports["getSpecifiers"] = $8730f26c81bbd247$export$643db0b8d8778e;
module.exports["defaultThemeFn"] = $8730f26c81bbd247$export$437a7f77d13d7916;
module.exports["default"] = $8730f26c81bbd247$export$2e2bcd8739ae039;

});

parcelRegister("8CZUH", function(module, exports) {
$parcel$export(module.exports, "default", () => $52a35e42f4f0505c$export$2e2bcd8739ae039);

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $85mFk = parcelRequire("85mFk");

function $52a35e42f4f0505c$export$2e2bcd8739ae039(props) {
    // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $85mFk.default), {
        ...props,
        isFullScreen: false
    });
}

});

parcelRegister("2hNw6", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $fFa3V = parcelRequire("fFa3V");

/**
 * This is an object of usable media query helpers using our internal breakpoints configuration.
 *
 * When using Compiled CSS-in-JS, please ensure that only a single declaration can take effect at a time.
 * This means that you should avoid multiple breakpoints taking effect at the same time,
 * eg. ```{ [media.above.xs]: { color: 'red' }, [media.above.sm]: { color: 'green' }}```.
 * Instead, make sure that only one breakpoint can take effect at a time,
 * e.g, ```{ [media.only.xs]: { color: 'red' }, [media.above.sm]: { color: 'green' }}```.
 * For more details, please see <https://compiledcssinjs.com/docs/atomic-css#selector-specificity>.
 */ const $c1fa9040ef00e564$export$987d49ffe1b0900f = {
    above: {
        // TODO: Should this even exist, we don't want `css({ [media.above.xxs]: { … } })` because that just adds duplicates styles!
        xxs: '@media all',
        xs: '@media (min-width: 30rem)',
        sm: '@media (min-width: 48rem)',
        md: '@media (min-width: 64rem)',
        lg: '@media (min-width: 90rem)',
        xl: '@media (min-width: 110.5rem)'
    },
    only: {
        xxs: '@media (min-width: 0rem) and (max-width: 29.99rem)',
        xs: '@media (min-width: 30rem) and (max-width: 47.99rem)',
        sm: '@media (min-width: 48rem) and (max-width: 63.99rem)',
        md: '@media (min-width: 64rem) and (max-width: 89.99rem)',
        lg: '@media (min-width: 90rem) and (max-width: 110.49rem)',
        xl: '@media (min-width: 110.5rem)'
    },
    below: {
        xs: '@media not all and (min-width: 30rem)',
        sm: '@media not all and (min-width: 48rem)',
        md: '@media not all and (min-width: 64rem)',
        lg: '@media not all and (min-width: 90rem)',
        xl: '@media not all and (min-width: 110.5rem)'
    }
};


const $ce3c82ea32c3605a$var$queries = {
    'above.xxs': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $c1fa9040ef00e564$export$987d49ffe1b0900f).above.xxs.replace('@media ', '').trim()),
    'above.xs': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $c1fa9040ef00e564$export$987d49ffe1b0900f).above.xs.replace('@media ', '').trim()),
    'above.sm': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $c1fa9040ef00e564$export$987d49ffe1b0900f).above.sm.replace('@media ', '').trim()),
    'above.md': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $c1fa9040ef00e564$export$987d49ffe1b0900f).above.md.replace('@media ', '').trim()),
    'above.lg': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $c1fa9040ef00e564$export$987d49ffe1b0900f).above.lg.replace('@media ', '').trim()),
    'above.xl': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $c1fa9040ef00e564$export$987d49ffe1b0900f).above.xl.replace('@media ', '').trim()),
    'below.xs': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $c1fa9040ef00e564$export$987d49ffe1b0900f).below.xs.replace('@media ', '').trim()),
    'below.sm': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $c1fa9040ef00e564$export$987d49ffe1b0900f).below.sm.replace('@media ', '').trim()),
    'below.md': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $c1fa9040ef00e564$export$987d49ffe1b0900f).below.md.replace('@media ', '').trim()),
    'below.lg': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $c1fa9040ef00e564$export$987d49ffe1b0900f).below.lg.replace('@media ', '').trim()),
    'below.xl': typeof window === 'undefined' ? undefined : window?.matchMedia?.((0, $c1fa9040ef00e564$export$987d49ffe1b0900f).below.xl.replace('@media ', '').trim())
};
const $ce3c82ea32c3605a$export$49e55ae2c03d6045 = (queryString, listener)=>{
    const listenerRef = (0, $42omo.useRef)(listener);
    (0, $42omo.useEffect)(()=>{
        // Bind the listener if changed so it's called on the next change event; no guarantee on timing.
        listenerRef.current = listener;
    }, [
        listener
    ]);
    /**
	 * We explicitly only react to boolean changes for binding our listener
	 * Changes to the functional reference are ignored.
	 */ const hasListener = !!listener;
    /**
	 * The `matchMedia(…)` return value for our breakpoint query.
	 */ const mq = $ce3c82ea32c3605a$var$queries[queryString];
    (0, $42omo.useLayoutEffect)(()=>{
        listenerRef.current = listener; // Bind the listener now in case the `useEffect` hasn't fired above yet
        if (!mq || !hasListener || !listenerRef.current) return;
        return (0, $fFa3V.bind)(mq, {
            type: 'change',
            listener: (event)=>{
                // We explicitly call the current version of the function
                return listenerRef.current(event);
            }
        });
    }, // eslint-disable-next-line react-hooks/exhaustive-deps -- explicitly do not trigger the effect on `listener` reference change, only on a boolean representation of it.
    [
        mq,
        hasListener
    ]);
    return mq || null;
};
module.exports["UNSAFE_useMediaQuery"] = $ce3c82ea32c3605a$export$49e55ae2c03d6045;

});

parcelRegister("5dK2X", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $42omo = parcelRequire("42omo");


var $9K4OG = parcelRequire("9K4OG");


var $dRnqM = parcelRequire("dRnqM");


var $kFobZ = parcelRequire("kFobZ");


var $5rrZR = parcelRequire("5rrZR");


var $avd77 = parcelRequire("avd77");

function $09e903c734194f41$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $09e903c734194f41$var$asAllowlist = [
    'span',
    'p',
    'strong',
    'em'
];
// Long term we should remove those instances from the reset - it should be a reset to 0.
// For now, at least we know <Text> will be unaffected by this.
const $09e903c734194f41$var$resetStyles = {
    name: "eb2bs7",
    styles: "margin:0;overflow-wrap:anywhere"
};
const $09e903c734194f41$var$strongStyles = {
    name: "17rayov",
    styles: "font-weight:var(--ds-font-weight-bold, 653)"
};
const $09e903c734194f41$var$emStyles = {
    name: "1jwcxx3",
    styles: "font-style:italic"
};
const $09e903c734194f41$var$textAlignMap = {
    center: {
        name: "1azakc",
        styles: "text-align:center"
    },
    end: {
        name: "va2k03",
        styles: "text-align:end"
    },
    start: {
        name: "9kuh93",
        styles: "text-align:start"
    }
};
const $09e903c734194f41$var$truncationStyles = {
    name: "478gwf",
    styles: "display:-webkit-box;overflow:hidden;-webkit-box-orient:vertical"
};
const $09e903c734194f41$var$wordBreakMap = {
    breakAll: {
        name: "1m5hyg0",
        styles: "word-break:break-all"
    }
}; /**
    * Custom hook designed to abstract the parsing of the color props and make it clearer in the future how color is reconciled between themes and tokens.
    */ 
const $09e903c734194f41$var$useColor = (colorProp, hasTextAncestor)=>{
    const surface = (0, $5rrZR.useSurface)();
    if (colorProp === 'inherit') return undefined;
    if (colorProp) return colorProp;
    if (hasTextAncestor) return undefined;
    if ((0, $avd77.inverseColorMap).hasOwnProperty(surface)) return (0, $avd77.inverseColorMap)[surface];
    return 'color.text';
}; /**
    * __Text__
    *
    * Text is a primitive component that has the Atlassian Design System's design guidelines baked in.
    * This includes considerations for text attributes such as color, font size, font weight, and line height.
    * It renders a `span` by default.
    *
    * @internal
    */ 
const $09e903c734194f41$var$Text = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: Component = 'span', color: colorProp, align: align, testId: testId, id: id, size: size, weight: weight, maxLines: maxLines, children: children }, ref)=>{
    (0, $dRnqM.default)($09e903c734194f41$var$asAllowlist.includes(Component), `@atlaskit/primitives: Text received an invalid "as" value of "${Component}"`);
    const hasTextAncestor = (0, $kFobZ.useHasTextAncestor)();
    const color = $09e903c734194f41$var$useColor(colorProp, hasTextAncestor);
    if (!size && !hasTextAncestor) size = 'medium';
    const component = /*#__PURE__*/ (0, $9K4OG.jsx)(Component, {
        ref: ref,
        css: [
            $09e903c734194f41$var$resetStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            size && (0, $avd77.textSizeStylesMap)[size],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            color && (0, $avd77.textColorStylesMap)[color],
            maxLines && $09e903c734194f41$var$truncationStyles,
            maxLines === 1 && $09e903c734194f41$var$wordBreakMap.breakAll,
            align && $09e903c734194f41$var$textAlignMap[align],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
            weight && (0, $avd77.textWeightStylesMap)[weight],
            Component === 'em' && $09e903c734194f41$var$emStyles,
            Component === 'strong' && $09e903c734194f41$var$strongStyles
        ],
        style: {
            WebkitLineClamp: maxLines
        },
        "data-testid": testId,
        id: id
    }, children);
    return hasTextAncestor ? // no need to re-apply context if the text is already wrapped
    component : /*#__PURE__*/ (0, $9K4OG.jsx)((0, $kFobZ.HasTextAncestorProvider), {
        value: true
    }, component);
});
var $09e903c734194f41$export$2e2bcd8739ae039 = $09e903c734194f41$var$Text;
module.exports["default"] = $09e903c734194f41$export$2e2bcd8739ae039;

});

parcelRegister("7p4As", function(module, exports) {
/* link.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $1Whri = parcelRequire("1Whri");


var $3654r = parcelRequire("3654r");


var $f93tv = parcelRequire("f93tv");


var $dh538 = parcelRequire("dh538");


var $auNCB = parcelRequire("auNCB");


var $jvXSm = parcelRequire("jvXSm");


var $6kISY = parcelRequire("6kISY");

const $9f94761968690603$var$styles = {
    base: "_2rkofajl _11c8fhey _v5649dqc _189eidpf _1rjc12x7 _1e0c116y _vchhusvi _1bsb1wug _p12f1osq _kqswh2mm _4cvr1q9y _1bah1h6o _gy1p1b66 _1o9zidpf _4t3iviql _k48p1wq8 _y4tiutpp _bozgutpp _y3gn1h6o _s7n4nkob _14mj1kw7 _9v7aze3t _1tv3nqa1 _39yqe4h9 _11fnglyw _18postnw",
    baseT26Shape: "_2rko1qi0",
    linkDecorationUnset: "_4bfu1snc _1hmsagmp _ajmmvv82 _1a3b1r31 _4fprglyw _5goinqa1 _9oik1r31 _1bnxglyw _jf4cnqa1 _1nrm1r31 _c2waglyw _1iohnqa1",
    disabled: "_80om13gf _bfhkby5v _syaz1gmx _aetrglyw _irr3by5v _30l31gmx _1di6by5v _9h8h1gmx",
    spacingCompact: "_1rjcv77o _gy1p1b66 _4t3i1k8s _y4tiutpp _bozgutpp _s7n4nkob",
    buttonIconBefore: "_bozgu2gc",
    buttonIconAfter: "_y4tiu2gc",
    fullWidth: "_1bsb1osq"
};
const $9f94761968690603$var$defaultStyles = {
    root: "_bfhksm61 _syazazsu _8l3m1l7x _aetrb3bt _1053azsu _f8pjazsu _irr31dpa _30l3azsu _1di6fcek _9h8hazsu"
};
const $9f94761968690603$var$primaryStyles = {
    root: "_bfhk1856 _syaz15cr _105315cr _f8pj15cr _30l315cr _irr3hf2y _9h8h15cr _1di6g6ey"
};
const $9f94761968690603$var$warningStyles = {
    root: "_bfhk1kmu _syaz1yd3 _10531yd3 _f8pj1yd3 _30l31yd3 _irr31spp _9h8h1yd3 _1di64m4m"
};
const $9f94761968690603$var$dangerStyles = {
    root: "_bfhkybec _syaz15cr _105315cr _f8pj15cr _30l315cr _irr3s9hg _9h8h15cr _1di613a9"
};
const $9f94761968690603$var$discoveryStyles = {
    root: "_bfhku5tj _syaz15cr _105315cr _f8pj15cr _30l315cr _irr3fqeg _9h8h15cr _1di61f1m"
};
const $9f94761968690603$var$subtleStyles = {
    root: "_bfhksm61 _syazazsu _1053azsu _f8pj1mjl _irr31dpa _30l3azsu _1di6fcek _9h8hazsu"
};
const $9f94761968690603$var$selectedStyles = {
    root: "_bfhk15s3 _syaz6x5g _8l3mq98m _aetrb3bt _10536x5g _f8pj6x5g _30l36x5g _9h8h6x5g",
    warning: "_bfhk15s3 _syaz6x5g _30l36x5g _irr315s3 _9h8h6x5g _1di615s3",
    danger: "_bfhk15s3 _syaz6x5g _30l36x5g _irr315s3 _9h8h6x5g _1di615s3",
    discovery: "_bfhk15s3 _syaz6x5g _30l36x5g _irr315s3 _9h8h6x5g _1di615s3"
}; /**
    * __Link Button__
    *
    * Renders a link in the style of a button.
    *
    * - [Examples](https://atlassian.design/components/link-button/examples)
    * - [Code](https://atlassian.design/components/link-button/code)
    * - [Usage](https://atlassian.design/components/link-button/usage)
    */ 
const $9f94761968690603$var$LinkButtonBase = ({ analyticsContext: analyticsContext, appearance: appearance = 'default', 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledBy, autoFocus: autoFocus = false, children: children, href: href, iconAfter: iconAfter, iconBefore: iconBefore, interactionName: interactionName, isDisabled: isDisabled, isSelected: isSelected, onClick: onClick, onClickCapture: onClickCapture, onKeyDownCapture: onKeyDownCapture, onKeyUpCapture: onKeyUpCapture, onMouseDownCapture: onMouseDownCapture, onMouseUpCapture: onMouseUpCapture, onPointerDownCapture: onPointerDownCapture, onPointerUpCapture: onPointerUpCapture, onTouchEndCapture: onTouchEndCapture, onTouchStartCapture: onTouchStartCapture, shouldFitContainer: shouldFitContainer, spacing: spacing, testId: testId, ...unsafeRest }, ref)=>{
    // @ts-expect-error
    const { className: _className, css: _css, as: _as, style: _style, ...saferRest } = unsafeRest;
    const hasIconAfter = Boolean(iconAfter);
    const hasIconBefore = Boolean(iconBefore);
    const localRef = (0, $42omo.useRef)(null);
    (0, $f93tv.default)(localRef, autoFocus);
    const combinedRef = (0, $3654r.default)([
        localRef,
        ref
    ]);
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $auNCB.default), {
        analyticsContext: analyticsContext,
        ref: combinedRef,
        // @ts-expect-error (`href` is required, we could make it optional but don't want to encourage this pattern elsewhere)
        href: isDisabled ? undefined : href,
        role: isDisabled ? 'link' : undefined,
        "aria-disabled": isDisabled === true ? true : undefined,
        "aria-label": ariaLabel,
        "aria-labelledby": ariaLabelledBy,
        onClick: onClick,
        onClickCapture: onClickCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onTouchEndCapture: onTouchEndCapture,
        onTouchStartCapture: onTouchStartCapture,
        testId: testId,
        componentName: "LinkButton",
        interactionName: interactionName,
        ...saferRest,
        xcss: (0, $1Whri.cx)($9f94761968690603$var$styles.base, (0, $dh538.fg)('platform-dst-shape-theme-default') && $9f94761968690603$var$styles.baseT26Shape, appearance === 'default' && $9f94761968690603$var$defaultStyles.root, appearance === 'primary' && $9f94761968690603$var$primaryStyles.root, appearance === 'warning' && $9f94761968690603$var$warningStyles.root, appearance === 'danger' && $9f94761968690603$var$dangerStyles.root, appearance === 'discovery' && $9f94761968690603$var$discoveryStyles.root, appearance === 'subtle' && $9f94761968690603$var$subtleStyles.root, $9f94761968690603$var$styles.linkDecorationUnset, isSelected && $9f94761968690603$var$selectedStyles.root, isSelected && appearance === 'danger' && $9f94761968690603$var$selectedStyles.danger, isSelected && appearance === 'warning' && $9f94761968690603$var$selectedStyles.warning, isSelected && appearance === 'discovery' && $9f94761968690603$var$selectedStyles.discovery, isDisabled && $9f94761968690603$var$styles.disabled, spacing === 'compact' && $9f94761968690603$var$styles.spacingCompact, hasIconBefore && $9f94761968690603$var$styles.buttonIconBefore, hasIconAfter && $9f94761968690603$var$styles.buttonIconAfter, shouldFitContainer && $9f94761968690603$var$styles.fullWidth),
        children: [
            iconBefore && /*#__PURE__*/ (0, $l998X.jsx)((0, $jvXSm.default), {
                type: "icon",
                position: "before",
                isLoading: false,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $6kISY.default), {
                    icon: iconBefore
                })
            }),
            children && /*#__PURE__*/ (0, $l998X.jsx)((0, $jvXSm.default), {
                isLoading: false,
                children: children
            }),
            iconAfter && /*#__PURE__*/ (0, $l998X.jsx)((0, $jvXSm.default), {
                type: "icon",
                position: "after",
                isLoading: false,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $6kISY.default), {
                    icon: iconAfter
                })
            })
        ]
    });
};
// Workarounds to support generic types with forwardRef
/**
 * __Link Button__
 *
 * Renders a link in the style of a button.
 *
 * - [Examples](https://atlassian.design/components/link-button/examples)
 * - [Code](https://atlassian.design/components/link-button/code)
 * - [Usage](https://atlassian.design/components/link-button/usage)
 */ const $9f94761968690603$var$LinkButton = /*#__PURE__*/ (0, $42omo.forwardRef)($9f94761968690603$var$LinkButtonBase);
$9f94761968690603$var$LinkButton.displayName = 'LinkButton';
var $9f94761968690603$export$2e2bcd8739ae039 = $9f94761968690603$var$LinkButton;
module.exports["default"] = $9f94761968690603$export$2e2bcd8739ae039;

});

parcelRegister("dcJ7R", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $42omo = parcelRequire("42omo");


var $9K4OG = parcelRequire("9K4OG");


var $ecnYn = parcelRequire("ecnYn");


var $bUlM5 = parcelRequire("bUlM5");

const $bcb95e3519017b7c$var$flexGrowMap = {
    hug: (0, $ecnYn.xcss)({
        flexGrow: 0
    }),
    fill: (0, $ecnYn.xcss)({
        width: '100%',
        flexGrow: 1
    })
};
const $bcb95e3519017b7c$var$separatorStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    color: "var(--ds-text-subtle, #505258)",
    marginBlock: "var(--ds-space-0, 0px)",
    marginInline: `${"var(--ds-space-negative-025, -2px)"}`,
    pointerEvents: 'none',
    userSelect: 'none'
});
const $bcb95e3519017b7c$var$Separator = ({ children: children })=>/*#__PURE__*/ (0, $9K4OG.jsx)("span", {
        css: $bcb95e3519017b7c$var$separatorStyles
    }, children); /**
                                                      * __Inline__
                                                      *
                                                      * Inline is a primitive component based on CSS Flexbox that manages the horizontal layout of direct children.
                                                      *
                                                      * @example
                                                      * ```tsx
                                                      *  <Inline>
                                                      *    <Box padding="space.100" backgroundColor="neutral"></Box>
                                                      *    <Box padding="space.100" backgroundColor="neutral"></Box>
                                                      *  </Inline>
                                                      * ```
                                                      *
                                                      */ 
const $bcb95e3519017b7c$var$Inline = /*#__PURE__*/ (0, $42omo.memo)(/*#__PURE__*/ (0, $42omo.forwardRef)(({ as: as, alignInline: alignInline, alignBlock: alignItems = 'start', shouldWrap: shouldWrap = false, spread: spread, grow: grow, space: space, rowSpace: rowSpace, separator: separator, xcss: xcss, testId: testId, role: role, id: id, children: rawChildren }, ref)=>{
    const separatorComponent = typeof separator === 'string' ? /*#__PURE__*/ (0, $9K4OG.jsx)($bcb95e3519017b7c$var$Separator, null, separator) : separator;
    const children = separatorComponent ? (0, $42omo.Children).toArray(rawChildren).filter(Boolean).map((child, index)=>{
        return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $42omo.Fragment), {
            key: index
        }, separator && index > 0 ? separatorComponent : null, child);
    }) : rawChildren;
    const justifyContent = spread || alignInline; // We're type coercing this as Compiled styles in an array isn't supported by the types
    // But the runtime accepts it none-the-wiser. We can remove this entire block and replace
    // it with cx(defaultStyles, focusRingStyles, xcssStyles) when we've moved away from Emotion.
    const styles = grow ? [
        $bcb95e3519017b7c$var$flexGrowMap[grow],
        ...Array.isArray(xcss) ? xcss : [
            xcss
        ]
    ] : xcss;
    return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $bUlM5.default), {
        id: id,
        as: as,
        role: role,
        alignItems: alignItems,
        justifyContent: justifyContent,
        direction: "row",
        gap: space,
        rowGap: rowSpace,
        wrap: shouldWrap ? 'wrap' : undefined,
        xcss: styles,
        testId: testId,
        ref: ref
    }, children);
}));
$bcb95e3519017b7c$var$Inline.displayName = 'Inline';
var $bcb95e3519017b7c$export$2e2bcd8739ae039 = $bcb95e3519017b7c$var$Inline;
module.exports["default"] = $bcb95e3519017b7c$export$2e2bcd8739ae039;

});

parcelRegister("bUlM5", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $42omo = parcelRequire("42omo");


var $9K4OG = parcelRequire("9K4OG");


var $avd77 = parcelRequire("avd77");


var $ecnYn = parcelRequire("ecnYn");

function $5da6bf9a1ca649aa$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $5da6bf9a1ca649aa$var$justifyContentMap = {
    start: {
        name: "j1lm6p",
        styles: "justify-content:start"
    },
    center: {
        name: "f7ay7b",
        styles: "justify-content:center"
    },
    end: {
        name: "jab4lt",
        styles: "justify-content:end"
    },
    'space-between': {
        name: "2o6p8u",
        styles: "justify-content:space-between"
    },
    'space-around': {
        name: "46cjum",
        styles: "justify-content:space-around"
    },
    'space-evenly': {
        name: "16166rn",
        styles: "justify-content:space-evenly"
    },
    stretch: {
        name: "11z2bqs",
        styles: "justify-content:stretch"
    }
};
const $5da6bf9a1ca649aa$var$flexDirectionMap = {
    column: {
        name: "qdeacm",
        styles: "flex-direction:column"
    },
    row: {
        name: "mcnhyd",
        styles: "flex-direction:row"
    }
};
const $5da6bf9a1ca649aa$var$flexWrapMap = {
    wrap: {
        name: "1qemjat",
        styles: "flex-wrap:wrap"
    },
    nowrap: {
        name: "14gl6v0",
        styles: "flex-wrap:nowrap"
    }
};
const $5da6bf9a1ca649aa$var$alignItemsMap = {
    start: {
        name: "yvwru5",
        styles: "align-items:start"
    },
    center: {
        name: "1h3rtzg",
        styles: "align-items:center"
    },
    baseline: {
        name: "fzr848",
        styles: "align-items:baseline"
    },
    end: {
        name: "uj5xqj",
        styles: "align-items:end"
    },
    stretch: {
        name: "1ikgkii",
        styles: "align-items:stretch"
    }
};
const $5da6bf9a1ca649aa$var$baseStyles = {
    name: "kxpnum",
    styles: "display:flex;box-sizing:border-box"
};
/**
 * __Flex__
 *
 * `Flex` is a primitive component that implements the CSS Flexbox API.
 *
 * - [Examples](https://atlassian.design/components/primitives/flex/examples)
 * - [Code](https://atlassian.design/components/primitives/flex/code)
 *
 * @example
 * ```tsx
 * // eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
 * import { Flex, Box } from '@atlaskit/primitives'
 *
 * const Component = () => (
 *   <Flex direction="column">
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *   </Flex>
 * )
 * ```
 */ const $5da6bf9a1ca649aa$var$Flex = /*#__PURE__*/ (0, $42omo.memo)(/*#__PURE__*/ (0, $42omo.forwardRef)(({ as: Component = 'div', role: role, alignItems: alignItems, justifyContent: justifyContent, gap: gap, columnGap: columnGap, rowGap: rowGap, children: children, testId: testId, direction: direction, wrap: wrap, xcss: xcss, id: id }, ref)=>{
    const resolvedStyles = (0, $ecnYn.parseXcss)(xcss);
    return /*#__PURE__*/ (0, $9K4OG.jsx)(Component, {
        id: id,
        role: role,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: resolvedStyles.static,
        css: [
            $5da6bf9a1ca649aa$var$baseStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            gap && (0, $avd77.spaceStylesMap).gap[gap],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            columnGap && (0, $avd77.spaceStylesMap).columnGap[columnGap],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            rowGap && (0, $avd77.spaceStylesMap).rowGap[rowGap],
            alignItems && $5da6bf9a1ca649aa$var$alignItemsMap[alignItems],
            direction && $5da6bf9a1ca649aa$var$flexDirectionMap[direction],
            justifyContent && $5da6bf9a1ca649aa$var$justifyContentMap[justifyContent],
            wrap && $5da6bf9a1ca649aa$var$flexWrapMap[wrap],
            ...resolvedStyles.emotion || []
        ],
        "data-testid": testId,
        ref: ref
    }, children);
}));
$5da6bf9a1ca649aa$var$Flex.displayName = 'Flex';
var $5da6bf9a1ca649aa$export$2e2bcd8739ae039 = $5da6bf9a1ca649aa$var$Flex;
module.exports["default"] = $5da6bf9a1ca649aa$export$2e2bcd8739ae039;

});

parcelRegister("1GzhS", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $42omo = parcelRequire("42omo");


var $9K4OG = parcelRequire("9K4OG");


var $ecnYn = parcelRequire("ecnYn");


var $bUlM5 = parcelRequire("bUlM5");

const $d4078d862f8d156c$var$flexGrowMap = {
    hug: (0, $ecnYn.xcss)({
        flexGrow: 0
    }),
    fill: (0, $ecnYn.xcss)({
        width: '100%',
        flexGrow: 1
    })
};
/**
 * __Stack__
 *
 * Stack is a primitive component based on flexbox that manages the block layout of direct children.
 *
 * @example
 * ```tsx
 *  <Stack>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *  </Stack>
 * ```
 *
 */ const $d4078d862f8d156c$var$Stack = /*#__PURE__*/ (0, $42omo.memo)(/*#__PURE__*/ (0, $42omo.forwardRef)(({ as: as, alignInline: alignItems, alignBlock: alignBlock = 'stretch', spread: spread, grow: grow, space: space, children: children, testId: testId, xcss: xcss, role: role, id: id }, ref)=>{
    const justifyContent = spread || alignBlock;
    // We're type coercing this as Compiled styles in an array isn't supported by the types
    // But the runtime accepts it none-the-wiser. We can remove this entire block and replace
    // it with cx(defaultStyles, focusRingStyles, xcssStyles) when we've moved away from Emotion.
    const styles = grow ? [
        $d4078d862f8d156c$var$flexGrowMap[grow],
        ...Array.isArray(xcss) ? xcss : [
            xcss
        ]
    ] : xcss;
    return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $bUlM5.default), {
        id: id,
        as: as,
        role: role,
        gap: space,
        direction: "column",
        alignItems: alignItems,
        justifyContent: justifyContent,
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        xcss: styles,
        testId: testId,
        ref: ref
    }, children);
}));
$d4078d862f8d156c$var$Stack.displayName = 'Stack';
var $d4078d862f8d156c$export$2e2bcd8739ae039 = $d4078d862f8d156c$var$Stack;
module.exports["default"] = $d4078d862f8d156c$export$2e2bcd8739ae039;

});

parcelRegister("2W0qg", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $42omo = parcelRequire("42omo");


var $9K4OG = parcelRequire("9K4OG");


var $gxtzC = parcelRequire("gxtzC");


var $ee7An = parcelRequire("ee7An");


var $90YwQ = parcelRequire("90YwQ");


var $avd77 = parcelRequire("avd77");


var $ecnYn = parcelRequire("ecnYn");

function $1d7e397a775b6b9d$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// This duplicates FocusRing styles from `@atlaskit/focus-ring`.
const $1d7e397a775b6b9d$var$focusRingStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    '&:focus, &:focus-visible': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineColor: (0, $avd77.borderColorMap)['color.border.focused'],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineOffset: (0, $avd77.positiveSpaceMap)['space.025'],
        outlineStyle: 'solid',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineWidth: (0, $avd77.borderWidthMap)['border.width.focused']
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '&:focus:not(:focus-visible)': {
        outline: 'none'
    },
    '@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)': {
        '&:focus-visible': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
            outline: `${(0, $avd77.borderWidthMap)['border.width']} solid`
        }
    }
});
const $1d7e397a775b6b9d$var$baseStyles = {
    name: "1b8qmvl",
    styles: "box-sizing:border-box;appearance:none;border:none"
};
const $1d7e397a775b6b9d$var$enabledStyles = {
    name: "e0dnmk",
    styles: "cursor:pointer"
};
const $1d7e397a775b6b9d$var$disabledStyles = {
    name: "1sfig4b",
    styles: "cursor:not-allowed"
};
/**
 * __Pressable__
 *
 * A primitive for building custom buttons.
 *
 * - [Examples](https://atlassian.design/components/primitives/pressable/examples)
 * - [Code](https://atlassian.design/components/primitives/pressable/code)
 * - [Usage](https://atlassian.design/components/primitives/pressable/usage)
 */ const $1d7e397a775b6b9d$var$Pressable = /*#__PURE__*/ (0, $42omo.forwardRef)(({ children: children, backgroundColor: backgroundColor, padding: padding, paddingBlock: paddingBlock, paddingBlockStart: paddingBlockStart, paddingBlockEnd: paddingBlockEnd, paddingInline: paddingInline, paddingInlineStart: paddingInlineStart, paddingInlineEnd: paddingInlineEnd, isDisabled: isDisabled, type: type = 'button', onClick: providedOnClick = (0, $ee7An.default), interactionName: interactionName, componentName: componentName, analyticsContext: analyticsContext, style: style, testId: testId, xcss: xcss, ...htmlAttributes }, ref)=>{
    const interactionContext = (0, $42omo.useContext)((0, $90YwQ.default));
    const handleClick = (0, $42omo.useCallback)((e, analyticsEvent)=>{
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    const onClick = (0, $gxtzC.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: 'clicked',
        componentName: componentName || 'Pressable',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local",
        analyticsData: analyticsContext,
        actionSubject: 'button'
    });
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    const { className: _spreadClass, ...safeHtmlAttributes } = htmlAttributes;
    const resolvedStyles = (0, $ecnYn.parseXcss)(xcss);
    return /*#__PURE__*/ (0, $9K4OG.jsx)("button", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        ref: ref,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: resolvedStyles.static,
        ...safeHtmlAttributes,
        // eslint-disable-next-line react/button-has-type
        type: type,
        onClick: onClick,
        disabled: isDisabled,
        css: [
            $1d7e397a775b6b9d$var$baseStyles,
            $1d7e397a775b6b9d$var$focusRingStyles,
            isDisabled ? $1d7e397a775b6b9d$var$disabledStyles : $1d7e397a775b6b9d$var$enabledStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            backgroundColor && (0, $avd77.backgroundColorStylesMap)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            padding && (0, $avd77.paddingStylesMap).padding[padding],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlock && (0, $avd77.paddingStylesMap).paddingBlock[paddingBlock],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockStart && (0, $avd77.paddingStylesMap).paddingBlockStart[paddingBlockStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockEnd && (0, $avd77.paddingStylesMap).paddingBlockEnd[paddingBlockEnd],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInline && (0, $avd77.paddingStylesMap).paddingInline[paddingInline],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineStart && (0, $avd77.paddingStylesMap).paddingInlineStart[paddingInlineStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineEnd && (0, $avd77.paddingStylesMap).paddingInlineEnd[paddingInlineEnd],
            ...resolvedStyles.emotion || []
        ],
        "data-testid": testId
    }, children);
});
var $1d7e397a775b6b9d$export$2e2bcd8739ae039 = $1d7e397a775b6b9d$var$Pressable;
module.exports["default"] = $1d7e397a775b6b9d$export$2e2bcd8739ae039;

});

parcelRegister("ccHMk", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $iprY1 = parcelRequire("iprY1");


var $jvXSm = parcelRequire("jvXSm");


var $6kISY = parcelRequire("6kISY");

/**
 * __Button__
 *
 * A button triggers an event or action.
 *
 * - [Examples](https://atlassian.design/components/button/examples)
 * - [Code](https://atlassian.design/components/button/code)
 * - [Usage](https://atlassian.design/components/button/usage)
 */ const $f045fd88b11ec5a8$var$Button = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).forwardRef(function Button({ analyticsContext: analyticsContext, appearance: appearance, 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledBy, autoFocus: autoFocus, children: children, iconAfter: iconAfter, iconBefore: iconBefore, interactionName: interactionName, isDisabled: isDisabled, isLoading: isLoading = false, isSelected: isSelected, onClick: onClick, onClickCapture: onClickCapture, onKeyDownCapture: onKeyDownCapture, onKeyUpCapture: onKeyUpCapture, onMouseDownCapture: onMouseDownCapture, onMouseUpCapture: onMouseUpCapture, onPointerDownCapture: onPointerDownCapture, onPointerUpCapture: onPointerUpCapture, onTouchEndCapture: onTouchEndCapture, onTouchStartCapture: onTouchStartCapture, shouldFitContainer: shouldFitContainer, spacing: spacing, testId: testId, type: type = 'button', ...unsafeRest }, ref) {
    // @ts-expect-error
    const { className: _className, css: _css, as: _as, style: _style, ...saferRest } = unsafeRest;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $iprY1.default), {
        analyticsContext: analyticsContext,
        ref: ref,
        appearance: appearance,
        autoFocus: autoFocus,
        isDisabled: isDisabled,
        isLoading: isLoading,
        isSelected: isSelected,
        hasIconBefore: Boolean(iconBefore),
        hasIconAfter: Boolean(iconAfter),
        shouldFitContainer: shouldFitContainer,
        spacing: spacing,
        ariaLabel: ariaLabel,
        ariaLabelledBy: ariaLabelledBy,
        onClick: onClick,
        onClickCapture: onClickCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onTouchStartCapture: onTouchStartCapture,
        onTouchEndCapture: onTouchEndCapture,
        testId: testId,
        componentName: "Button",
        type: type,
        interactionName: interactionName,
        ...saferRest,
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $42omo.Fragment), {
            children: [
                iconBefore && /*#__PURE__*/ (0, $l998X.jsx)((0, $jvXSm.default), {
                    type: "icon",
                    position: "before",
                    isLoading: isLoading,
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $6kISY.default), {
                        icon: iconBefore
                    })
                }),
                children && /*#__PURE__*/ (0, $l998X.jsx)((0, $jvXSm.default), {
                    isLoading: isLoading,
                    children: children
                }),
                iconAfter && /*#__PURE__*/ (0, $l998X.jsx)((0, $jvXSm.default), {
                    type: "icon",
                    position: "after",
                    isLoading: isLoading,
                    children: /*#__PURE__*/ (0, $l998X.jsx)((0, $6kISY.default), {
                        icon: iconAfter
                    })
                })
            ]
        })
    });
}));
$f045fd88b11ec5a8$var$Button.displayName = 'Button';
var $f045fd88b11ec5a8$export$2e2bcd8739ae039 = $f045fd88b11ec5a8$var$Button;
module.exports["default"] = $f045fd88b11ec5a8$export$2e2bcd8739ae039;

});

parcelRegister("6xdDU", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $g9Srd = parcelRequire("g9Srd");

/**
 * __Modal transition__
 *
 * A modal transition wraps a modal to provide a fluid transition upon opening and closing.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples)
 * - [Code](https://atlassian.design/components/modal-dialog/code)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ const $64ad3bd6adfcceac$var$ModalTransition = (props)=>{
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $g9Srd.default), {
        appear: true,
        children: //Checking if children are undefined to prevent potential runtime errors in React 17
        props.children ?? null
    });
};
var $64ad3bd6adfcceac$export$2e2bcd8739ae039 = $64ad3bd6adfcceac$var$ModalTransition;
module.exports["default"] = $64ad3bd6adfcceac$export$2e2bcd8739ae039;

});

parcelRegister("d8SNb", function(module, exports) {
/* grid.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $c710d721c1aea21a$var$rowGapMap = {
    'space.0': "_1p57ze3t",
    'space.025': "_1p57v77o",
    'space.050': "_1p571b66",
    'space.075': "_1p5712x7",
    'space.100': "_1p57u2gc",
    'space.150': "_1p57utpp",
    'space.200': "_1p57pxbi",
    'space.250': "_1p57v47k",
    'space.300': "_1p571ejb",
    'space.400': "_1p57xy5q",
    'space.500': "_1p571jfw",
    'space.600': "_1p57oahv",
    'space.800': "_1p57xncg",
    'space.1000': "_1p571epz"
};
const $c710d721c1aea21a$var$columnGapMap = {
    'space.0': "_gy1pze3t",
    'space.025': "_gy1pv77o",
    'space.050': "_gy1p1b66",
    'space.075': "_gy1p12x7",
    'space.100': "_gy1pu2gc",
    'space.150': "_gy1putpp",
    'space.200': "_gy1ppxbi",
    'space.250': "_gy1pv47k",
    'space.300': "_gy1p1ejb",
    'space.400': "_gy1pxy5q",
    'space.500': "_gy1p1jfw",
    'space.600': "_gy1poahv",
    'space.800': "_gy1pxncg",
    'space.1000': "_gy1p1epz"
};
const $c710d721c1aea21a$var$justifyContentMap = {
    start: "_1bahv2br",
    center: "_1bah1h6o",
    end: "_1bahh9n0",
    'space-between': "_1bah1yb4",
    'space-around': "_1bah1b1v",
    'space-evenly': "_1bahitcz",
    stretch: "_1bah1fhb"
};
const $c710d721c1aea21a$var$alignContentMap = {
    start: "_ae4vv2br",
    center: "_ae4v1h6o",
    end: "_ae4vh9n0",
    'space-between': "_ae4v1yb4",
    'space-around': "_ae4v1b1v",
    'space-evenly': "_ae4vitcz",
    stretch: "_ae4v1fhb"
};
const $c710d721c1aea21a$var$alignItemsMap = {
    start: "_4cvrv2br",
    center: "_4cvr1h6o",
    baseline: "_4cvr1q9y",
    end: "_4cvrh9n0",
    stretch: "_4cvr1fhb"
};
const $c710d721c1aea21a$var$baseStyles = {
    root: "_1e0c11p5 _vchhusvi"
};
const $c710d721c1aea21a$var$gridAutoFlowMap = {
    row: "_wij2vrvc",
    column: "_wij21bp4",
    dense: "_wij218l3",
    'row dense': "_wij2j5tq",
    'column dense': "_wij2adhi"
};
/**
 * __Grid__
 *
 * `Grid` is a primitive component that implements the CSS Grid API.
 *
 * - [Examples](https://atlassian.design/components/primitives/grid/examples)
 * - [Code](https://atlassian.design/components/primitives/grid/code)
 *
 * @example
 * ```tsx
 * import { Grid, Box } from '@atlaskit/primitives'
 *
 * const Component = () => (
 *   <Grid gap="space.100" gridColumns="1fr 1fr">
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *   </Grid>
 * )
 * ```
 */ const $c710d721c1aea21a$var$Grid = /*#__PURE__*/ (0, $42omo.memo)(/*#__PURE__*/ (0, $42omo.forwardRef)(({ as: as, alignItems: alignItems, alignContent: alignContent, justifyContent: justifyContent, gap: gap, columnGap: columnGap, rowGap: rowGap, children: children, id: id, role: role, testId: testId, autoFlow: autoFlow, xcss: xcss }, ref)=>{
    const Component = as || 'div';
    return /*#__PURE__*/ (0, $l998X.jsx)(Component, {
        id: id,
        role: role,
        className: (0, $gMc0m.default)([
            $c710d721c1aea21a$var$baseStyles.root,
            gap && $c710d721c1aea21a$var$columnGapMap[gap],
            columnGap && $c710d721c1aea21a$var$columnGapMap[columnGap],
            gap && $c710d721c1aea21a$var$rowGapMap[gap],
            rowGap && $c710d721c1aea21a$var$rowGapMap[rowGap],
            alignItems && $c710d721c1aea21a$var$alignItemsMap[alignItems],
            alignContent && $c710d721c1aea21a$var$alignContentMap[alignContent],
            justifyContent && $c710d721c1aea21a$var$justifyContentMap[justifyContent],
            autoFlow && $c710d721c1aea21a$var$gridAutoFlowMap[autoFlow],
            xcss
        ]),
        "data-testid": testId,
        ref: ref,
        children: children
    });
}));
$c710d721c1aea21a$var$Grid.displayName = 'Grid';
var $c710d721c1aea21a$export$2e2bcd8739ae039 = $c710d721c1aea21a$var$Grid;
module.exports["default"] = $c710d721c1aea21a$export$2e2bcd8739ae039;

});

parcelRegister("fzqvY", function(module, exports) {
/* form.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $k9Smn = parcelRequire("k9Smn");


var $jTvbt = parcelRequire("jTvbt");


var $abN8T = parcelRequire("abN8T");


var $3hoG4 = parcelRequire("3hoG4");


var $3654r = parcelRequire("3654r");


var $dh538 = parcelRequire("dh538");




const $06ef50d54e9f5f3d$export$fc06342dc8588d3b = (inputs, errors)=>{
    // Guaranteed to be of type HTMLInputElement[] due to getInputs function overrided in createDecorator
    let htmlInputs = inputs;
    return htmlInputs.find(function(input) {
        // If input is hidden, do not focus
        if (input.type === 'hidden') return false;
        // If input ID matches the error, focus
        if (input.id && (0, $k9Smn.getIn)(errors, input.id)) return true;
        // Default to base behavior
        return input.name && (0, $k9Smn.getIn)(errors, input.name);
    });
};


const $4927f34870175183$export$c24727297075ec6a = /*#__PURE__*/ (0, $42omo.createContext)({
    registerField: function() {
        return ()=>{};
    },
    getCurrentValue: ()=>undefined,
    subscribe: function() {
        return ()=>{};
    }
}); /**
     * __Is disabled context__
     *
     * An is disabled context creates the context for when a value is disabled.
     */ 
const $4927f34870175183$export$c17cf6b332a82dbc = /*#__PURE__*/ (0, $42omo.createContext)(false);
const $4927f34870175183$var$FormBase = (props, ref)=>{
    const { autocomplete: autocomplete, formProps: userProvidedFormProps, id: id, label: label, labelId: labelId, name: name, noValidate: noValidate, onSubmit: onSubmit, testId: testId, xcss: xcss } = props;
    const formRef = (0, $42omo.useRef)(null);
    const onSubmitRef = (0, $42omo.useRef)(onSubmit);
    onSubmitRef.current = onSubmit;
    const [form] = (0, $42omo.useState)(()=>{
        // Types here would break the existing API
        const finalForm = (0, $k9Smn.createForm)({
            onSubmit: (...args)=>onSubmitRef.current(...args),
            destroyOnUnregister: true,
            initialValues: {},
            mutators: {
                setDefaultValue: ([name, defaultValue], state)=>{
                    if (state.formState.initialValues) {
                        const initialValues = state.formState.initialValues;
                        const values = state.formState.values;
                        const value = name && typeof defaultValue === 'function' ? defaultValue(initialValues[name]) : defaultValue;
                        (0, (/*@__PURE__*/$parcel$interopDefault($abN8T)))(initialValues, name, value);
                        (0, (/*@__PURE__*/$parcel$interopDefault($abN8T)))(values, name, value);
                    }
                }
            }
        });
        (0, $jTvbt.default)(()=>formRef.current ? Array.from(formRef.current.querySelectorAll('input')) : [], (0, $06ef50d54e9f5f3d$export$fc06342dc8588d3b))(finalForm);
        return finalForm;
    });
    const [state, setState] = (0, $42omo.useState)({
        dirty: false,
        submitting: false
    });
    (0, $42omo.useEffect)(()=>{
        const unsubscribe = form.subscribe(({ dirty: dirty, submitting: submitting })=>{
            setState({
                dirty: dirty,
                submitting: submitting
            });
        }, {
            dirty: true,
            submitting: true
        });
        return unsubscribe;
    }, [
        form
    ]);
    const registerField = (0, $42omo.useCallback)((name, defaultValue, subscriber, subscription, config)=>{
        form.pauseValidation();
        const unsubscribe = form.registerField(name, subscriber, subscription, config);
        form.mutators.setDefaultValue(name, defaultValue);
        form.resumeValidation();
        return unsubscribe;
    }, [
        form
    ]);
    const handleSubmit = (e)=>{
        if (e) e.preventDefault();
        form.submit();
    };
    const handleReset = (initialValues)=>{
        form.reset(initialValues);
    };
    const handleKeyDown = (e)=>{
        if (e.key === 'Enter' && (e.ctrlKey || e.metaKey) && formRef.current) {
            const submitButton = formRef.current.querySelector('button:not([type]), button[type="submit"], input[type="submit"]');
            if (submitButton) submitButton.click();
            e.preventDefault();
        }
    };
    const { isDisabled: isDisabled = false, children: children } = props;
    const { dirty: dirty, submitting: submitting } = state; /**
              * This method is needed in FormContext to use it on the field level
              * to check the current value of the field in case of the component re-mounting.
              */ 
    const getCurrentValue = (0, $42omo.useCallback)((name)=>{
        const formState = form.getState();
        return formState?.values[name] || undefined;
    }, [
        form
    ]);
    const FormContextValue = (0, $42omo.useMemo)(()=>{
        return {
            registerField: registerField,
            getCurrentValue: getCurrentValue,
            subscribe: form.subscribe
        };
    }, [
        registerField,
        getCurrentValue,
        form.subscribe
    ]);
    const conditionalFormProps = {
        autocomplete: autocomplete,
        className: xcss,
        id: id,
        'aria-label': label,
        'aria-labelledby': labelId,
        name: name,
        noValidate: noValidate,
        'data-testid': testId
    }; // Abstracting so we can use the same for both rendering patterns
    const formProps = {
        onKeyDown: handleKeyDown,
        onSubmit: handleSubmit,
        ref: ref ? (0, $3654r.default)([
            ref,
            formRef
        ]) : formRef
    }; // We don't want to add undefined values to the component
    Object.keys(conditionalFormProps).forEach((attr)=>{
        if (conditionalFormProps[attr] !== undefined) formProps[attr] = conditionalFormProps[attr];
    });
    const childrenContent = (()=>{
        if (typeof children === 'function') {
            const result = children.length > 0 ? children({
                formProps: formProps,
                dirty: dirty,
                reset: handleReset,
                submitting: submitting,
                disabled: isDisabled,
                getState: ()=>form.getState(),
                getValues: ()=>form.getState().values,
                setFieldValue: form.change,
                ...(0, $dh538.fg)('platform-form-reset-field-state') && {
                    resetFieldState: form.resetFieldState
                }
            }) : children();
            return result === undefined ? null : result;
        } else return /*#__PURE__*/ (0, $l998X.jsx)("form", {
            ...formProps,
            ...userProvidedFormProps,
            children: children
        });
    })();
    return /*#__PURE__*/ (0, $l998X.jsx)($4927f34870175183$export$c24727297075ec6a.Provider, {
        value: FormContextValue,
        children: /*#__PURE__*/ (0, $l998X.jsx)($4927f34870175183$export$c17cf6b332a82dbc.Provider, {
            value: isDisabled,
            children: childrenContent
        })
    });
};
/**
 * __Form__
 *
 * A form allows users to input information.
 *
 * - [Examples](https://atlassian.design/components/form/examples)
 * - [Code](https://atlassian.design/components/form/code)
 * - [Usage](https://atlassian.design/components/form/usage)
 */ const $4927f34870175183$var$Form = (0, $3hoG4.default)($4927f34870175183$var$FormBase);
var $4927f34870175183$export$2e2bcd8739ae039 = $4927f34870175183$var$Form;
module.exports["FormContext"] = $4927f34870175183$export$c24727297075ec6a;
module.exports["IsDisabledContext"] = $4927f34870175183$export$c17cf6b332a82dbc;
module.exports["default"] = $4927f34870175183$export$2e2bcd8739ae039;

});

parcelRegister("gQhRa", function(module, exports) {
/* messages.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $a3fRD = parcelRequire("a3fRD");


var $3sFtD = parcelRequire("3sFtD");


var $3SfWK = parcelRequire("3SfWK");

const $c3ec45697ea60e27$var$messageStyles = null;
const $c3ec45697ea60e27$var$messageAppearanceStyles = {
    default: "_syaz1rpy",
    error: "_syaz1tmw",
    valid: "_syazgsak"
};
const $c3ec45697ea60e27$var$iconWrapperStyles = {
    root: "_1e0c1txw _4t3i7vkz _4cvr1h6o"
};
const $c3ec45697ea60e27$var$IconWrapper = ({ children: children })=>/*#__PURE__*/ (0, $l998X.jsx)("span", {
        className: (0, $gMc0m.default)([
            $c3ec45697ea60e27$var$iconWrapperStyles.root
        ]),
        children: children
    });
const $c3ec45697ea60e27$var$messageIcons = {
    error: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($a3fRD))), {
        color: "currentColor",
        label: "error",
        size: "small"
    }),
    valid: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3sFtD))), {
        color: "currentColor",
        label: "success",
        size: "small"
    })
};
const $c3ec45697ea60e27$var$Message = ({ children: children, appearance: appearance = 'default', fieldId: fieldId, testId: testId })=>{
    const icon = $c3ec45697ea60e27$var$messageIcons[appearance];
    const messageRef = (0, $42omo.useRef)(null);
    const [hasMessageWrapper, setHasMessageWrapper] = (0, $42omo.useState)(false);
    const { isWrapper: isWrapper } = (0, $42omo.useContext)($c3ec45697ea60e27$var$MessageWrapperContext);
    (0, $42omo.useEffect)(()=>{
        if (messageRef.current) setHasMessageWrapper(isWrapper);
    }, [
        isWrapper
    ]); /**
                   * The wrapping span is necessary to preserve spaces between children.
                   * Otherwise the flex layout of the message will remove any whitespace
                   * between children.
                   *
                   * If the child is just a string, this is not required and we can use one
                   * less DOM element.
                   */ 
    const content = typeof children === 'string' ? children : /*#__PURE__*/ (0, $l998X.jsx)("span", {
        children: children
    });
    return /*#__PURE__*/ (0, $l998X.jsxs)("div", {
        "data-testid": testId,
        id: fieldId,
        ref: messageRef,
        "aria-live": !hasMessageWrapper ? 'polite' : undefined,
        className: (0, $gMc0m.default)([
            "_zulp12x7 _11c8wadc _1e0c1txw _1bah1q9y _1pfh1b66",
            $c3ec45697ea60e27$var$messageAppearanceStyles[appearance]
        ]),
        children: [
            icon && /*#__PURE__*/ (0, $l998X.jsx)($c3ec45697ea60e27$var$IconWrapper, {
                children: icon
            }),
            content
        ]
    });
};
const $c3ec45697ea60e27$export$8fbe3c7d0ed2c683 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $3SfWK.FieldId).Consumer, {
        children: (fieldId)=>/*#__PURE__*/ (0, $l998X.jsx)($c3ec45697ea60e27$var$Message, {
                fieldId: fieldId ? `${fieldId}-helper` : undefined,
                testId: testId,
                children: children
            })
    }); /**
                       * __Error message__
                       *
                       * An error message is used to tell a user that the field input is invalid. For example, an error message could be
                       * 'Invalid username, needs to be more than 4 characters'.
                       *
                       */ 
const $c3ec45697ea60e27$export$915e9e7bd4f0f96d = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $3SfWK.FieldId).Consumer, {
        children: (fieldId)=>/*#__PURE__*/ (0, $l998X.jsx)($c3ec45697ea60e27$var$Message, {
                appearance: "error",
                fieldId: fieldId ? `${fieldId}-error` : undefined,
                testId: testId,
                children: children
            })
    }); /**
                       * __Valid message__
                       *
                       * A valid message is used to tell a user that the field input is valid. For example,
                       * a helper message could be 'Nice one, this username is available'.
                       *
                       */ 
const $c3ec45697ea60e27$export$5505afb209a532c8 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $l998X.jsx)((0, $3SfWK.FieldId).Consumer, {
        children: (fieldId)=>/*#__PURE__*/ (0, $l998X.jsx)($c3ec45697ea60e27$var$Message, {
                appearance: "valid",
                fieldId: fieldId ? `${fieldId}-valid` : undefined,
                testId: testId,
                children: children
            })
    });
/**
 * __Message wrapper context__
 *
 * A message wrapper context allows the children to check
 * if it is contained within the MessageWrapper.
 */ const $c3ec45697ea60e27$var$MessageWrapperContext = /*#__PURE__*/ (0, $42omo.createContext)({
    isWrapper: false
}); /**
     * __Message wrapper __
     *
     * A message wrapper is used to allow assistive technologies, like screen readers, to announce error or
     * valid messages. This must be loaded into the DOM before the
     * ErrorMessage, ValidMessage is loaded. Otherwise, assistive technologies
     * may not render the message.
     *
     */ 
const $c3ec45697ea60e27$export$ec445f12f63100a5 = ({ children: children })=>{
    const contextValue = {
        isWrapper: true
    };
    return /*#__PURE__*/ (0, $l998X.jsx)($c3ec45697ea60e27$var$MessageWrapperContext.Provider, {
        value: contextValue,
        children: /*#__PURE__*/ (0, $l998X.jsx)("div", {
            "aria-live": "polite",
            "data-testid": "message-wrapper",
            children: children
        })
    });
};
module.exports["HelperMessage"] = $c3ec45697ea60e27$export$8fbe3c7d0ed2c683;
module.exports["ErrorMessage"] = $c3ec45697ea60e27$export$915e9e7bd4f0f96d;
module.exports["ValidMessage"] = $c3ec45697ea60e27$export$5505afb209a532c8;
module.exports["MessageWrapper"] = $c3ec45697ea60e27$export$ec445f12f63100a5;

});

parcelRegister("fb3kw", function(module, exports) {
$parcel$export(module.exports, "default", () => $b4e06a55418efd34$export$2e2bcd8739ae039);
/* field.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $c0qxy = parcelRequire("c0qxy");


var $dh538 = parcelRequire("dh538");


var $3SfWK = parcelRequire("3SfWK");


var $fzqvY = parcelRequire("fzqvY");


var $bfgIy = parcelRequire("bfgIy");


var $gQhRa = parcelRequire("gQhRa");


var $jVhgp = parcelRequire("jVhgp");

const $b4e06a55418efd34$var$fieldWrapperStyles = null;
function $b4e06a55418efd34$var$isEvent(event) {
    return Boolean(event && event.target);
}
function $b4e06a55418efd34$var$isFunction(x) {
    return typeof x === 'function';
}
function $b4e06a55418efd34$var$usePreviousRef(current) {
    const ref = (0, $42omo.useRef)(current); // will be updated on the next render
    (0, $42omo.useEffect)(()=>{
        ref.current = current;
    }); // return the existing current (pre render)
    return ref;
}
function $b4e06a55418efd34$var$isShallowEqual(previousValue, currentValue) {
    if (previousValue === currentValue) return true;
     // not checking functions
    if (typeof previousValue === 'function' && typeof currentValue === 'function') return true;
    if (Array.isArray(previousValue) && Array.isArray(currentValue)) return JSON.stringify(previousValue) === JSON.stringify(currentValue);
    if (typeof previousValue === 'object' && typeof currentValue === 'object') return JSON.stringify(previousValue) === JSON.stringify(currentValue);
    return false;
}
function $b4e06a55418efd34$export$2e2bcd8739ae039(props) {
    const { children: children = ()=>null, component: component } = props;
    const { registerField: registerField, getCurrentValue: getCurrentValue } = (0, $42omo.useContext)((0, $fzqvY.FormContext));
    const isDisabled = (0, $42omo.useContext)((0, $fzqvY.IsDisabledContext)) || props.isDisabled || false;
    const defaultValue = $b4e06a55418efd34$var$isFunction(props.defaultValue) ? props.defaultValue() : props.defaultValue;
    const latestPropsRef = $b4e06a55418efd34$var$usePreviousRef(props);
    /**
  * HACK: defaultValue can potentially be an array or object which cannot be
  * passed directly into a `useEffect` dependency array, since it will trigger
  * the hook every time.
  */ const isDefaultValueChanged = !$b4e06a55418efd34$var$isShallowEqual(latestPropsRef.current.defaultValue, props.defaultValue);
    const [state, setState] = (0, $42omo.useState)({
        fieldProps: {
            onChange: ()=>{},
            onBlur: ()=>{},
            onFocus: ()=>{},
            /* Previously, defaultValue was being set as undefined in Field.defaultProps, which
      * effectively made it an optional prop to external consumers of Field. However the
      * prop types defined defaultValue as required, so inside the component it was not
      * valid for defaultValue to be undefined. We need to suppress the error
      * after changing defaultValue to explicitly be an optional prop.
      * If default value has changed we are using new default value.
      * Otherwise we need to check if we already have value for this field
      * (because we are using changing key prop to re-run field level validation, and that
      * cause the component re-mounting) to not override the actual value with the default value.
      */ // @ts-ignore
            value: isDefaultValueChanged ? defaultValue : getCurrentValue(props.name) ?? defaultValue
        },
        error: undefined,
        valid: false,
        meta: {
            dirty: false,
            dirtySinceLastSubmit: false,
            touched: false,
            valid: false,
            validating: false,
            submitting: false,
            submitFailed: false,
            error: undefined,
            submitError: undefined
        }
    });
    const latestStateRef = $b4e06a55418efd34$var$usePreviousRef(state);
    const isRequiredDependency = (0, $dh538.fg)('platform_dst_form_fix_isrequired_effect') ? props.isRequired : undefined;
    (0, $42omo.useEffect)(()=>{
        function fieldStateToMeta(value = {}) {
            return {
                dirty: value.dirty || false,
                dirtySinceLastSubmit: value.dirtySinceLastSubmit || false,
                touched: value.touched || false,
                valid: value.valid || false,
                submitting: value.submitting || false,
                submitFailed: value.submitFailed || false,
                error: value.error,
                submitError: value.submitError,
                validating: !!value.validating
            };
        }
        const unregister = registerField(latestPropsRef.current.name, /**
    * Similar as for setting initial state value.
    * Additionally we are checking if the default value is a function,
    * it is used in checkbox fields, where fields with same name and
    * defaultIsChecked should create array of values. In this situation we can't
    * override the default value on re-registering, but also we don't need to change
    * the key prop to re-run validation.
    */ // @ts-ignore
        isDefaultValueChanged || // @ts-ignore
        $b4e06a55418efd34$var$isFunction(latestPropsRef.current.defaultValue) ? latestPropsRef.current.defaultValue : latestStateRef.current.fieldProps.value, (fieldState)=>{
            /**
      * Do not update dirtySinceLastSubmit until submission has finished.
      */ const modifiedDirtySinceLastSubmit = fieldState.submitting ? latestStateRef.current.meta.dirtySinceLastSubmit : fieldState.dirtySinceLastSubmit; /**
                                                                                                                                                       * Do not update submitFailed until submission has finished.
                                                                                                                                                       */ 
            const modifiedSubmitFailed = fieldState.submitting ? latestStateRef.current.meta.submitFailed : fieldState.submitFailed; /**
                                                                                                                               * Do not use submitError if the value has changed.
                                                                                                                               */ 
            const modifiedSubmitError = modifiedDirtySinceLastSubmit && latestPropsRef.current.validate ? undefined : fieldState.submitError;
            const modifiedError = modifiedSubmitError || (fieldState.touched || fieldState.dirty) && fieldState.error; /**
                                                                                                                 * If there has been a submit error, then use logic in modifiedError to determine validity,
                                                                                                                 * so we can determine when there is a submit error which we do not want to display
                                                                                                                 * because the value has been changed.
                                                                                                                 */ 
            const modifiedValid = modifiedSubmitFailed ? modifiedError === undefined : fieldState.valid;
            function getTransform(eventOrValue, currentValue) {
                if (latestPropsRef.current.transform) return latestPropsRef.current.transform(eventOrValue, currentValue);
                if ($b4e06a55418efd34$var$isEvent(eventOrValue)) {
                    const { currentTarget: currentTarget } = eventOrValue;
                    if (currentTarget.type === 'checkbox') {
                        if (currentTarget.checked) return currentTarget.value || true;
                        return currentTarget.value ? undefined : false;
                    } else if (currentTarget) return currentTarget.value;
                    return;
                } else return eventOrValue;
            }
            setState({
                fieldProps: {
                    onChange: (e)=>{
                        fieldState.change(getTransform(e, fieldState.value));
                    },
                    onBlur: fieldState.blur,
                    onFocus: fieldState.focus,
                    value: fieldState.value
                },
                error: modifiedError || undefined,
                /**
        * The following parameters are optionally typed in final-form to indicate that not all parameters need
        * to be subscribed to. We cast them as booleans (using || false), since this is what they are semantically.
        */ valid: modifiedValid || false,
                meta: fieldStateToMeta(fieldState)
            });
        }, {
            dirty: true,
            dirtySinceLastSubmit: true,
            touched: true,
            valid: true,
            submitting: true,
            submitFailed: true,
            value: true,
            error: true,
            submitError: true,
            validating: true
        }, {
            getValidator: ()=>function validate(value, formState, fieldState) {
                    const supplied = latestPropsRef.current.validate;
                    if (supplied && fieldState) return supplied(value, formState, fieldStateToMeta(fieldState));
                }
        });
        return unregister;
    }, [
        latestPropsRef,
        latestStateRef,
        registerField,
        props.name,
        isRequiredDependency,
        isDefaultValueChanged
    ]);
    const uid = (0, $c0qxy.useId)();
    const fieldId = (0, $42omo.useMemo)(()=>{
        return props.id ? props.id : `${props.name}-${uid}`;
    }, [
        props.id,
        props.name,
        uid
    ]);
    const getDescribedBy = ()=>{
        let value = '';
        if (state.error) value += `${fieldId}-error `;
        if (state.valid) value += `${fieldId}-valid `;
        return `${value}${fieldId}-helper`;
    };
    const extendedFieldProps = {
        ...state.fieldProps,
        name: props.name,
        isDisabled: isDisabled,
        isInvalid: Boolean(state.error),
        isRequired: Boolean(props.isRequired),
        'aria-required': String(Boolean(props.isRequired)),
        'aria-invalid': state.error ? 'true' : 'false',
        'aria-describedby': getDescribedBy(),
        'aria-labelledby': `${fieldId}-label`,
        id: fieldId
    };
    return /*#__PURE__*/ (0, $l998X.jsxs)("div", {
        "data-testid": props.testId,
        className: (0, $gMc0m.default)([
            "_1pfhu2gc"
        ]),
        children: [
            props.label && /*#__PURE__*/ (0, $l998X.jsxs)((0, $bfgIy.Label), {
                htmlFor: fieldId,
                id: `${fieldId}-label`,
                testId: props.testId && `${props.testId}--label`,
                children: [
                    props.label,
                    props.isRequired && /*#__PURE__*/ (0, $l998X.jsx)((0, $jVhgp.default), {}),
                    props.elementAfterLabel
                ]
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $3SfWK.FieldId).Provider, {
                value: fieldId,
                children: component ? /*#__PURE__*/ (0, $l998X.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, {
                    children: [
                        component({
                            fieldProps: extendedFieldProps
                        }),
                        /*#__PURE__*/ (0, $l998X.jsxs)((0, $gQhRa.MessageWrapper), {
                            children: [
                                props.helperMessage && /*#__PURE__*/ (0, $l998X.jsx)((0, $gQhRa.HelperMessage), {
                                    children: props.helperMessage
                                }),
                                state.error && /*#__PURE__*/ (0, $l998X.jsx)((0, $gQhRa.ErrorMessage), {
                                    children: props.errorMessage || state.error
                                }),
                                state.meta.touched && state.valid && props.validMessage && /*#__PURE__*/ (0, $l998X.jsx)((0, $gQhRa.ValidMessage), {
                                    children: props.validMessage
                                })
                            ]
                        })
                    ]
                }) : children({
                    fieldProps: extendedFieldProps,
                    error: state.error,
                    valid: state.valid,
                    meta: state.meta
                })
            })
        ]
    });
}

});

parcelRegister("bfgIy", function(module, exports) {
/* label.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $da15cca948d18173$var$fieldsetLabelStyles = null;
const $da15cca948d18173$export$b04be29aa201d4f5 = ({ children: children, htmlFor: htmlFor, id: id, testId: testId })=>/*#__PURE__*/ (0, $l998X.jsx)("label", {
        id: id,
        htmlFor: htmlFor,
        "data-testid": testId,
        className: (0, $gMc0m.default)([
            "_11c8wadc _1e0c1o8l _syazazsu _k48pwu06 _6rth1b66 _1pfhze3t"
        ]),
        children: children
    });
const $da15cca948d18173$export$ed247974535929c7 = ({ children: children })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)("legend", {
        className: (0, $gMc0m.default)([
            "_11c8wadc _1e0c1o8l _syazazsu _k48pwu06 _6rth1b66 _1pfhze3t"
        ]),
        children: children
    });
};
module.exports["Label"] = $da15cca948d18173$export$b04be29aa201d4f5;
module.exports["Legend"] = $da15cca948d18173$export$ed247974535929c7;

});

parcelRegister("jVhgp", function(module, exports) {
$parcel$export(module.exports, "default", () => $f1cb7484631613fe$export$2e2bcd8739ae039);
/* required-asterisk.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $f1cb7484631613fe$var$requiredIndicatorStyles = null;
function $f1cb7484631613fe$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $l998X.jsx)("span", {
        "aria-hidden": "true",
        title: "required",
        className: (0, $gMc0m.default)([
            "_syaz1tmw _ect4ttxp _bozgv77o"
        ]),
        children: "*"
    });
}

});

parcelRegister("dn4ZF", function(module, exports) {
$parcel$export(module.exports, "default", () => $0c1d2c5622b2d036$export$2e2bcd8739ae039);
/* form-footer.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");

const $0c1d2c5622b2d036$var$formFooterWrapperStyles = null;
const $0c1d2c5622b2d036$var$justifyContentStyles = null; /**
                                    * __Form footer__
                                    *
                                    * A form footer has the content to be shown at the bottom of the form. This is usually the submit button.
                                    *
                                    * - [Examples](https://atlaskit.atlassian.com/packages/design-system/form/docs/layout)
                                    * - [Code](https://atlaskit.atlassian.com/packages/design-system/form/docs/layout)
                                    * - [Usage](https://atlaskit.atlassian.com/packages/design-system/form/docs/layout)
                                    */ 
function $0c1d2c5622b2d036$export$2e2bcd8739ae039({ align: align = 'end', children: children }) {
    return /*#__PURE__*/ (0, $l998X.jsx)("footer", {
        className: (0, $gMc0m.default)([
            "_1e0c1txw _1bahesu3 _1pfh1ejb",
            align === 'start' && "_1bah1y6m"
        ]),
        children: children
    });
}

});

parcelRegister("eEA8O", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $ee7An = parcelRequire("ee7An");


var $bOG3Z = parcelRequire("bOG3Z");


var $gcG0P = parcelRequire("gcG0P");


var $10BNt = parcelRequire("10BNt");


var $hYfEs = parcelRequire("hYfEs");

const $7097509fdb1a2342$var$isFirefox = typeof navigator !== 'undefined' && navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
/**
 * __Button__
 *
 * @deprecated Legacy buttons are deprecated and will be removed from `atlaskit/button` in an upcoming major release. Please use the new Button components from `@atlaskit/button/new`
 *
 * Please refer to the [migration guide](https://atlassian.design/components/button/button-legacy/migration-guide) for further details.
 *
 * A button triggers an event or action. They let users know what will happen next.
 *
 * - [Examples](https://atlassian.design/components/button/button-legacy/examples)
 * - [Code](https://atlassian.design/components/button/button-legacy/code)
 * - [Usage](https://atlassian.design/components/button/button-legacy/usage)
 */ const $7097509fdb1a2342$var$Button = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).forwardRef(function Button({ appearance: appearance = 'default', children: children, iconBefore: iconBefore, iconAfter: iconAfter, isSelected: isSelected = false, onMouseDown: providedOnMouseDown = (0, $ee7An.default), onMouseUp: providedOnMouseUp = (0, $ee7An.default), shouldFitContainer: shouldFitContainer = false, spacing: spacing = 'default', ...rest }, ref) {
    const { mode: mode } = (0, $bOG3Z.useGlobalTheme)();
    const isOnlySingleIcon = (0, $hYfEs.default)({
        children: children,
        iconBefore: iconBefore,
        iconAfter: iconAfter
    });
    const [isActive, setIsActive] = (0, $42omo.useState)(false);
    // Wrap onMouseDown / onMouseUp to manually trigger active state
    //  in Firefox
    const onMouseDown = (0, $42omo.useCallback)((event)=>{
        providedOnMouseDown(event);
        if ($7097509fdb1a2342$var$isFirefox) setIsActive(true);
    }, [
        providedOnMouseDown,
        setIsActive
    ]);
    const onMouseUp = (0, $42omo.useCallback)((event)=>{
        providedOnMouseUp(event);
        if ($7097509fdb1a2342$var$isFirefox) setIsActive(false);
    }, [
        providedOnMouseUp,
        setIsActive
    ]);
    const buttonCss = (0, $42omo.useMemo)(()=>(0, $10BNt.getCss)({
            appearance: appearance,
            spacing: spacing,
            mode: mode,
            isSelected: isSelected,
            shouldFitContainer: shouldFitContainer,
            isOnlySingleIcon: isOnlySingleIcon
        }), [
        appearance,
        spacing,
        mode,
        isSelected,
        shouldFitContainer,
        isOnlySingleIcon
    ]);
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $gcG0P.default), {
        ...rest,
        ref: ref,
        appearance: appearance,
        buttonCss: buttonCss,
        children: children,
        // Due to how click events are set, we need to set active styles
        //  manually in Firefox and wrap onMouseDown/onMouseUp
        "data-firefox-is-active": isActive ? true : undefined,
        iconAfter: iconAfter,
        iconBefore: iconBefore,
        isSelected: isSelected,
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp,
        spacing: spacing
    });
}));
// Tools including enzyme rely on components having a display name
$7097509fdb1a2342$var$Button.displayName = 'Button';
var $7097509fdb1a2342$export$2e2bcd8739ae039 = $7097509fdb1a2342$var$Button;
module.exports["default"] = $7097509fdb1a2342$export$2e2bcd8739ae039;

});

parcelRegister("hArLp", function(module, exports) {
$parcel$export(module.exports, "default", () => $a5ff95295a4c1701$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $42omo = parcelRequire("42omo");


var $9K4OG = parcelRequire("9K4OG");

function $a5ff95295a4c1701$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $a5ff95295a4c1701$var$buttonGroupStyles = {
    name: "1oy5iav",
    styles: "display:inline-flex;gap:var(--ds-space-050, 4px);> *{flex:1 0 auto;}"
};
function $a5ff95295a4c1701$export$2e2bcd8739ae039({ children: children, testId: testId, label: label, titleId: titleId }) {
    return /*#__PURE__*/ (0, $9K4OG.jsx)("div", {
        css: $a5ff95295a4c1701$var$buttonGroupStyles,
        "data-testid": testId,
        role: "group",
        "aria-label": label,
        "aria-labelledby": titleId
    }, (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Children.map((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Children.toArray(children), (child, idx)=>{
        if (!child) return null;
        return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $42omo.Fragment), {
            key: idx
        }, child);
    }));
}

});

parcelRegister("9YwaJ", function(module, exports) {

var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $eEA8O = parcelRequire("eEA8O");


var $etbQ0 = parcelRequire("etbQ0");

/**
 * __Loading button__
 *
 * @deprecated Legacy loading buttons are deprecated and will be removed from `atlaskit/button` in an upcoming major release. Please use the new Button components from `@atlaskit/button/new` with the `isLoading` prop.
 *
 * Please refer to the [migration guide](https://atlassian.design/components/button/button-legacy/migration-guide) for further details.
 *
 * A small wrapper around Button that allows you to show an @atlaskit/spinner as an overlay on the button when you set an isLoading prop to true.
 *
 * - [Examples](https://atlassian.design/components/button/examples#loading-button)
 */ const $a39cd00511693951$var$LoadingButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).forwardRef(function LoadingButton({ appearance: appearance, isDisabled: isDisabled, isSelected: isSelected, isLoading: isLoading = false, spacing: spacing, ...rest }, ref) {
    // Button already has React.memo, so just leaning on that
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $eEA8O.default), {
        ...rest,
        ref: ref,
        appearance: appearance,
        // No need to render aria-disabled when it is false
        "aria-disabled": isLoading || undefined,
        isDisabled: isDisabled,
        isSelected: isSelected,
        overlay: isLoading ? /*#__PURE__*/ (0, $l998X.jsx)((0, $etbQ0.default), {
            spacing: spacing,
            appearance: appearance,
            isDisabled: isDisabled,
            isSelected: isSelected
        }) : null,
        spacing: spacing
    });
});
// Tools including enzyme rely on components having a display name
$a39cd00511693951$var$LoadingButton.displayName = 'LoadingButton';
var $a39cd00511693951$export$2e2bcd8739ae039 = $a39cd00511693951$var$LoadingButton;
module.exports["default"] = $a39cd00511693951$export$2e2bcd8739ae039;

});

parcelRegister("dE1p6", function(module, exports) {
/* link.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $1Whri = parcelRequire("1Whri");


var $3654r = parcelRequire("3654r");


var $f93tv = parcelRequire("f93tv");


var $dh538 = parcelRequire("dh538");


var $auNCB = parcelRequire("auNCB");


var $3gadb = parcelRequire("3gadb");


var $6F6hl = parcelRequire("6F6hl");


var $jvXSm = parcelRequire("jvXSm");


var $6kISY = parcelRequire("6kISY");

const $ff6f106cb93f476e$var$styles = {
    base: "_2rkofajl _11c8fhey _v5649dqc _189eidpf _1rjc12x7 _1e0c116y _vchhusvi _1bsb1wug _p12f1osq _kqswh2mm _4cvr1q9y _1bah1h6o _gy1p1b66 _1o9zidpf _4t3iviql _k48p1wq8 _y4tiutpp _bozgutpp _y3gn1h6o _s7n4nkob _14mj1kw7 _9v7aze3t _1tv3nqa1 _39yqe4h9 _11fnglyw _18postnw",
    baseT26Shape: "_2rko1qi0",
    linkDecorationUnset: "_4bfu1snc _1hmsagmp _ajmmvv82 _1a3b1r31 _4fprglyw _5goinqa1 _9oik1r31 _1bnxglyw _jf4cnqa1 _1nrm1r31 _c2waglyw _1iohnqa1",
    disabled: "_80om13gf _bfhkby5v _syaz1gmx _aetrglyw _irr3by5v _30l31gmx _1di6by5v _9h8h1gmx",
    spacingCompact: "_1rjcv77o _gy1p1b66 _y4tiutpp _bozgutpp _s7n4nkob _4t3i1k8s _1bsb1k8s",
    iconButton: "_4t3iviql _1bsbviql _y4tize3t _bozgze3t",
    circle: "_2rko1rr0"
};
const $ff6f106cb93f476e$var$defaultStyles = {
    root: "_bfhksm61 _syazazsu _8l3m1l7x _aetrb3bt _1053azsu _f8pjazsu _irr31dpa _30l3azsu _1di6fcek _9h8hazsu"
};
const $ff6f106cb93f476e$var$primaryStyles = {
    root: "_bfhk1856 _syaz15cr _105315cr _30l315cr _irr3hf2y _9h8h15cr _1di6g6ey"
};
const $ff6f106cb93f476e$var$discoveryStyles = {
    root: "_bfhku5tj _syaz15cr _105315cr _30l315cr _irr3fqeg _9h8h15cr _1di61f1m"
};
const $ff6f106cb93f476e$var$subtleStyles = {
    root: "_bfhksm61 _syazazsu _1053azsu _f8pj1mjl _irr31dpa _30l3azsu _1di6fcek _9h8hazsu"
};
const $ff6f106cb93f476e$var$selectedStyles = {
    root: "_bfhk15s3 _syaz6x5g _8l3mq98m _aetrb3bt _10536x5g _f8pj6x5g _30l36x5g _9h8h6x5g",
    discovery: "_bfhk15s3 _syaz6x5g _30l36x5g _irr315s3 _9h8h6x5g _1di615s3"
};
const $ff6f106cb93f476e$var$LinkIconButtonBase = ({ // Prevent duplicate labels being added.
'aria-label': preventedAriaLabel, 'aria-labelledby': ariaLabelledBy, analyticsContext: analyticsContext, appearance: appearance = 'default', autoFocus: autoFocus = false, href: href, icon: icon, interactionName: interactionName, isDisabled: isDisabled, isSelected: isSelected, isTooltipDisabled: isTooltipDisabled = true, label: label, onClick: onClick, onClickCapture: onClickCapture, onKeyDownCapture: onKeyDownCapture, onKeyUpCapture: onKeyUpCapture, onMouseDownCapture: onMouseDownCapture, onMouseUpCapture: onMouseUpCapture, onPointerDownCapture: onPointerDownCapture, onPointerUpCapture: onPointerUpCapture, onTouchEndCapture: onTouchEndCapture, onTouchStartCapture: onTouchStartCapture, shape: shape, spacing: spacing, testId: testId, tooltip: tooltip, ...unsafeRest }, ref)=>{
    // @ts-expect-error
    const { className: _className, css: _css, as: _as, style: _style, ...saferRest } = unsafeRest;
    const localRef = (0, $42omo.useRef)(null);
    (0, $f93tv.default)(localRef, autoFocus);
    if (!isTooltipDisabled) return /*#__PURE__*/ (0, $l998X.jsx)((0, $3gadb.default), {
        content: tooltip?.content ?? label,
        testId: tooltip?.testId,
        position: tooltip?.position,
        delay: tooltip?.delay,
        onShow: tooltip?.onShow,
        onHide: tooltip?.onHide,
        mousePosition: tooltip?.mousePosition,
        analyticsContext: tooltip?.analyticsContext,
        strategy: tooltip?.strategy,
        tag: tooltip?.tag,
        truncate: tooltip?.truncate,
        component: tooltip?.component,
        hideTooltipOnClick: tooltip?.hideTooltipOnClick,
        hideTooltipOnMouseDown: tooltip?.hideTooltipOnMouseDown,
        ignoreTooltipPointerEvents: tooltip?.ignoreTooltipPointerEvents,
        children: (triggerProps)=>/*#__PURE__*/ (0, $l998X.jsx)((0, $auNCB.default), {
                ...saferRest,
                "aria-labelledby": ariaLabelledBy,
                testId: testId,
                componentName: "LinkIconButton",
                analyticsContext: analyticsContext,
                interactionName: interactionName,
                onMouseOver: (e)=>{
                    triggerProps.onMouseOver?.(e);
                    saferRest.onMouseOver?.(e);
                },
                onMouseOut: (e)=>{
                    triggerProps.onMouseOut?.(e);
                    saferRest.onMouseOut?.(e);
                },
                onMouseMove: (e)=>{
                    triggerProps.onMouseMove?.(e);
                    saferRest.onMouseMove?.(e);
                },
                onMouseDown: (e)=>{
                    triggerProps.onMouseDown?.(e);
                    saferRest.onMouseDown?.(e);
                },
                onFocus: (e)=>{
                    triggerProps.onFocus?.(e);
                    saferRest.onFocus?.(e);
                },
                onBlur: (e)=>{
                    triggerProps.onBlur?.(e);
                    saferRest.onBlur?.(e);
                },
                onClick: (event, analyticsEvent)=>{
                    onClick?.(event, analyticsEvent);
                    triggerProps?.onClick?.(event);
                },
                ref: (0, $3654r.default)([
                    localRef,
                    ref,
                    triggerProps.ref
                ].filter(Boolean)),
                xcss: (0, $1Whri.cx)($ff6f106cb93f476e$var$styles.base, (0, $dh538.fg)('platform-dst-shape-theme-default') && $ff6f106cb93f476e$var$styles.baseT26Shape, appearance === 'default' && $ff6f106cb93f476e$var$defaultStyles.root, appearance === 'primary' && $ff6f106cb93f476e$var$primaryStyles.root, appearance === 'discovery' && $ff6f106cb93f476e$var$discoveryStyles.root, appearance === 'subtle' && $ff6f106cb93f476e$var$subtleStyles.root, $ff6f106cb93f476e$var$styles.linkDecorationUnset, isSelected && $ff6f106cb93f476e$var$selectedStyles.root, isSelected && appearance === 'discovery' && $ff6f106cb93f476e$var$selectedStyles.discovery, isDisabled && $ff6f106cb93f476e$var$styles.disabled, spacing === 'compact' && $ff6f106cb93f476e$var$styles.spacingCompact, $ff6f106cb93f476e$var$styles.iconButton, shape === 'circle' && $ff6f106cb93f476e$var$styles.circle),
                onMouseDownCapture: onMouseDownCapture,
                onMouseUpCapture: onMouseUpCapture,
                onKeyDownCapture: onKeyDownCapture,
                onKeyUpCapture: onKeyUpCapture,
                onTouchStartCapture: onTouchStartCapture,
                onTouchEndCapture: onTouchEndCapture,
                onPointerDownCapture: onPointerDownCapture,
                onPointerUpCapture: onPointerUpCapture,
                onClickCapture: onClickCapture,
                // @ts-expect-error (`href` is required, we could make it optional but don't want to encourage this pattern elsewhere)
                href: isDisabled ? undefined : href,
                role: isDisabled ? 'link' : undefined,
                "aria-disabled": isDisabled === true ? true : undefined,
                children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $jvXSm.default), {
                    type: "icon",
                    isLoading: false,
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $6kISY.default), {
                            icon: icon
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $6F6hl.default), {
                            children: label
                        })
                    ]
                })
            })
    });
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $auNCB.default), {
        ...saferRest,
        "aria-labelledby": ariaLabelledBy,
        ref: (0, $3654r.default)([
            localRef,
            ref
        ]),
        xcss: (0, $1Whri.cx)($ff6f106cb93f476e$var$styles.base, (0, $dh538.fg)('platform-dst-shape-theme-default') && $ff6f106cb93f476e$var$styles.baseT26Shape, appearance === 'default' && $ff6f106cb93f476e$var$defaultStyles.root, appearance === 'primary' && $ff6f106cb93f476e$var$primaryStyles.root, appearance === 'discovery' && $ff6f106cb93f476e$var$discoveryStyles.root, appearance === 'subtle' && $ff6f106cb93f476e$var$subtleStyles.root, $ff6f106cb93f476e$var$styles.linkDecorationUnset, isSelected && $ff6f106cb93f476e$var$selectedStyles.root, isSelected && appearance === 'discovery' && $ff6f106cb93f476e$var$selectedStyles.discovery, isDisabled && $ff6f106cb93f476e$var$styles.disabled, $ff6f106cb93f476e$var$styles.iconButton, spacing === 'compact' && $ff6f106cb93f476e$var$styles.spacingCompact, shape === 'circle' && $ff6f106cb93f476e$var$styles.circle),
        onClick: onClick,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onTouchStartCapture: onTouchStartCapture,
        onTouchEndCapture: onTouchEndCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onClickCapture: onClickCapture,
        testId: testId,
        // @ts-expect-error (`href` is required, we could make it optional but don't want to encourage this pattern elsewhere)
        href: isDisabled ? undefined : href,
        role: isDisabled ? 'link' : undefined,
        "aria-disabled": isDisabled === true ? true : undefined,
        componentName: "LinkIconButton",
        analyticsContext: analyticsContext,
        interactionName: interactionName,
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $jvXSm.default), {
            type: "icon",
            isLoading: false,
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)((0, $6kISY.default), {
                    icon: icon
                }),
                /*#__PURE__*/ (0, $l998X.jsx)((0, $6F6hl.default), {
                    children: label
                })
            ]
        })
    });
};
// Workarounds to support generic types with forwardRef + memo
const $ff6f106cb93f476e$var$WithRef = /*#__PURE__*/ (0, $42omo.forwardRef)($ff6f106cb93f476e$var$LinkIconButtonBase); /**
                                               * __Link Icon Button__
                                               *
                                               * Renders a link in the style of an icon button.
                                               *
                                               * - [Examples](https://atlassian.design/components/button/link-icon-button/examples)
                                               * - [Code](https://atlassian.design/components/button/link-icon-button/code)
                                               * - [Usage](https://atlassian.design/components/button/link-icon-button/usage)
                                               */ 
const $ff6f106cb93f476e$var$LinkIconButton = /*#__PURE__*/ (0, $42omo.memo)($ff6f106cb93f476e$var$WithRef);
var $ff6f106cb93f476e$export$2e2bcd8739ae039 = $ff6f106cb93f476e$var$LinkIconButton;
module.exports["default"] = $ff6f106cb93f476e$export$2e2bcd8739ae039;

});

parcelRegister("3eD0p", function(module, exports) {
/* form-section.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $cO1el = parcelRequire("cO1el");

const $c2fa156dc67ffdd6$var$formSectionDescriptionStyles = null;
const $c2fa156dc67ffdd6$var$formSectionWrapperStyles = null;
const $c2fa156dc67ffdd6$var$FormSectionWrapper = ({ children: children })=>{
    // eslint-disable-next-line @atlaskit/design-system/use-primitives
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        className: (0, $gMc0m.default)([
            "_1pfh1ejb"
        ]),
        children: children
    });
};
const $c2fa156dc67ffdd6$var$FormSectionDescription = ({ children: children })=>{
    // eslint-disable-next-line @atlaskit/design-system/use-primitives
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        className: (0, $gMc0m.default)([
            "_1pfhu2gc"
        ]),
        children: children
    });
}; /**
    * __Form section__.
    *
    * A form section is used to define a section of a form layout. This contains a section title, content
    * and a description of the section.
    *
    * - [Examples](https://atlaskit.atlassian.com/packages/design-system/form/docs/layout)
    * - [Code](https://atlaskit.atlassian.com/packages/design-system/form/docs/layout)
    * - [Usage](https://atlaskit.atlassian.com/packages/design-system/form/docs/layout).
    */ 
const $c2fa156dc67ffdd6$var$FormSection = ({ children: children, description: description, title: title })=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)($c2fa156dc67ffdd6$var$FormSectionWrapper, {
        children: [
            title && /*#__PURE__*/ (0, $l998X.jsx)((0, $cO1el.default), {
                size: "medium",
                children: title
            }),
            description && /*#__PURE__*/ (0, $l998X.jsx)($c2fa156dc67ffdd6$var$FormSectionDescription, {
                children: description
            }),
            children
        ]
    });
};
var $c2fa156dc67ffdd6$export$2e2bcd8739ae039 = $c2fa156dc67ffdd6$var$FormSection;
module.exports["default"] = $c2fa156dc67ffdd6$export$2e2bcd8739ae039;

});

parcelRegister("fpGTa", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $42omo = parcelRequire("42omo");


var $9K4OG = parcelRequire("9K4OG");


var $dRnqM = parcelRequire("dRnqM");


var $gxtzC = parcelRequire("gxtzC");


var $6i41U = parcelRequire("6i41U");


var $ee7An = parcelRequire("ee7An");


var $c0qxy = parcelRequire("c0qxy");


var $90YwQ = parcelRequire("90YwQ");


var $6F6hl = parcelRequire("6F6hl");


var $avd77 = parcelRequire("avd77");


var $ecnYn = parcelRequire("ecnYn");

function $03b8a9bd852ba155$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// TODO: duplicates FocusRing styles from `@atlaskit/focus-ring`.
const $03b8a9bd852ba155$var$focusRingStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    '&:focus, &:focus-visible': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineColor: (0, $avd77.borderColorMap)['color.border.focused'],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineOffset: (0, $avd77.positiveSpaceMap)['space.025'],
        outlineStyle: 'solid',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineWidth: (0, $avd77.borderWidthMap)['border.width.focused']
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '&:focus:not(:focus-visible)': {
        outline: 'none'
    },
    '@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)': {
        '&:focus-visible': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
            outline: `${(0, $avd77.borderWidthMap)['border.width']} solid`
        }
    }
});
const $03b8a9bd852ba155$var$baseStyles = {
    name: "9ge06c",
    styles: "box-sizing:border-box;text-decoration:underline"
};
const $03b8a9bd852ba155$var$positionStyles = {
    name: "bjn8wh",
    styles: "position:relative"
};
const $03b8a9bd852ba155$var$IS_EXTERNAL_LINK_REGEX = /^(?:(http|https):\/\/)/;
const $03b8a9bd852ba155$var$IS_NON_HTTP_BASED = /^(((mailto|tel|sms|blob):)|(#))/;
// Comma is added here to add a slight pause between announcing the anchor label and "opens in new window"
const $03b8a9bd852ba155$var$OPENS_NEW_WINDOW_LABEL = '(opens new window)';
/**
 * __Anchor__
 *
 * A primitive for building custom anchor links.
 *
 * - [Examples](https://atlassian.design/components/primitives/anchor/examples)
 * - [Code](https://atlassian.design/components/primitives/anchor/code)
 * - [Usage](https://atlassian.design/components/primitives/anchor/usage)
 */ const $03b8a9bd852ba155$var$AnchorNoRef = ({ href: href, children: children, backgroundColor: backgroundColor, newWindowLabel: newWindowLabel, padding: padding, paddingBlock: paddingBlock, paddingBlockStart: paddingBlockStart, paddingBlockEnd: paddingBlockEnd, paddingInline: paddingInline, paddingInlineStart: paddingInlineStart, paddingInlineEnd: paddingInlineEnd, onClick: providedOnClick = (0, $ee7An.default), interactionName: interactionName, componentName: componentName, analyticsContext: analyticsContext, 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledBy, style: style, target: target, testId: testId, xcss: xcss, ...htmlAttributes }, ref)=>{
    const interactionContext = (0, $42omo.useContext)((0, $90YwQ.default));
    const handleClick = (0, $42omo.useCallback)((e, analyticsEvent)=>{
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    const opensNewWindowLabelId = (0, $c0qxy.useId)();
    const onClick = (0, $gxtzC.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: 'clicked',
        componentName: componentName || 'Anchor',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local",
        analyticsData: analyticsContext,
        actionSubject: 'link'
    });
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    const { className: _spreadClass, ...safeHtmlAttributes } = htmlAttributes;
    const resolvedStyles = (0, $ecnYn.parseXcss)(xcss);
    const RouterLink = (0, $6i41U.default)();
    const isExternal = typeof href === 'string' && $03b8a9bd852ba155$var$IS_EXTERNAL_LINK_REGEX.test(href);
    const isNonHttpBased = typeof href === 'string' && $03b8a9bd852ba155$var$IS_NON_HTTP_BASED.test(href);
    /**
   * Renders a router link if:
   *
   * - a link component is set in the app provider
   * - it's not an external link (starting with `http://` or `https://`)
   * - it's not a non-HTTP-based link (e.g. emails, phone numbers, hash links etc.).
   */ const isRouterLink = RouterLink && !isExternal && !isNonHttpBased;
    const hrefObjectUsedWithoutRouterLink = RouterLink === undefined && typeof href === 'object';
    (0, $dRnqM.default)(!hrefObjectUsedWithoutRouterLink, `@atlaskit/primitives: Anchor primitive cannot pass an object to 'href' unless a router link is configured in the AppProvider`);
    const Component = isRouterLink ? RouterLink : 'a';
    return /*#__PURE__*/ (0, $9K4OG.jsx)(Component, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        ref: ref,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: resolvedStyles.static,
        ...safeHtmlAttributes,
        // @ts-expect-error
        href: !isRouterLink && typeof href !== 'string' ? undefined : href,
        target: target,
        onClick: onClick,
        "aria-label": ariaLabel && target === '_blank' && !ariaLabelledBy ? //`${ariaLabel} ${OPENS_NEW_WINDOW_LABEL}`
        `${ariaLabel} , ${newWindowLabel ? newWindowLabel : $03b8a9bd852ba155$var$OPENS_NEW_WINDOW_LABEL}` : ariaLabel,
        "aria-labelledby": ariaLabelledBy && target === '_blank' ? `${ariaLabelledBy} ${opensNewWindowLabelId}` : ariaLabelledBy,
        css: [
            $03b8a9bd852ba155$var$baseStyles,
            $03b8a9bd852ba155$var$positionStyles,
            $03b8a9bd852ba155$var$focusRingStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            backgroundColor && (0, $avd77.backgroundColorStylesMap)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            padding && (0, $avd77.paddingStylesMap).padding[padding],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlock && (0, $avd77.paddingStylesMap).paddingBlock[paddingBlock],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockStart && (0, $avd77.paddingStylesMap).paddingBlockStart[paddingBlockStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockEnd && (0, $avd77.paddingStylesMap).paddingBlockEnd[paddingBlockEnd],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInline && (0, $avd77.paddingStylesMap).paddingInline[paddingInline],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineStart && (0, $avd77.paddingStylesMap).paddingInlineStart[paddingInlineStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineEnd && (0, $avd77.paddingStylesMap).paddingInlineEnd[paddingInlineEnd],
            ...resolvedStyles.emotion || []
        ],
        "data-testid": testId,
        "data-is-router-link": testId ? isRouterLink ? 'true' : 'false' : undefined
    }, children, target === '_blank' && (children && !ariaLabel && !ariaLabelledBy || ariaLabelledBy) && /*#__PURE__*/ (0, $9K4OG.jsx)((0, $6F6hl.default), {
        id: opensNewWindowLabelId
    }, `, ${newWindowLabel ? newWindowLabel : $03b8a9bd852ba155$var$OPENS_NEW_WINDOW_LABEL}`));
};
// Workarounds to support generic types with forwardRef
/**
 * __Anchor__
 *
 * Anchor is a primitive for building custom anchor links. It's a wrapper around the HTML `<a>` element that provides a consistent API for handling client-side routing and Atlassian Design System styling.
 *
 * - [Examples](https://atlassian.design/components/primitives/anchor/examples)
 * - [Code](https://atlassian.design/components/primitives/anchor/code)
 * - [Usage](https://atlassian.design/components/primitives/anchor/usage)
 */ const $03b8a9bd852ba155$var$Anchor = /*#__PURE__*/ (0, $42omo.forwardRef)($03b8a9bd852ba155$var$AnchorNoRef);
var $03b8a9bd852ba155$export$2e2bcd8739ae039 = $03b8a9bd852ba155$var$Anchor;
module.exports["default"] = $03b8a9bd852ba155$export$2e2bcd8739ae039;

});

parcelRegister("9gE7g", function(module, exports) {
/* split-button.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $dh538 = parcelRequire("dh538");


var $48w2z = parcelRequire("48w2z");


var $42omo = parcelRequire("42omo");


var $kyRHQ = parcelRequire("kyRHQ");

const $3515e2fe28b45314$export$fe3955935f564b31 = (children)=>{
    const [PrimaryAction, SecondaryAction] = (0, $42omo.Children).toArray(children);
    typeof $kyRHQ;
    return {
        PrimaryAction: PrimaryAction,
        SecondaryAction: SecondaryAction
    };
};


const $25d44ebdfc301c3e$var$dividerStyles = {
    baseDivider: "_1bsbe4h9 _kqswh2mm _1pbykb7n",
    dividerDisabled: "_bfhkbk0g _80om13gf",
    dividerOffset: "_195g1n1a"
};
const $25d44ebdfc301c3e$var$dividerAppearanceStyles = {
    default: "_bfhk1l7x",
    primary: "_bfhkveue _tzy41wzo",
    navigation: "_1mouu2gc _195g1h5n _4t3i7vkz _bfhkazsu _tzy419lr"
};
const $25d44ebdfc301c3e$var$dividerHeightStyles = {
    default: "_4t3iviql",
    compact: "_4t3i1k8s"
}; // The divider height is calculated by subtracting twice the border width from the button height.
// This ensures the divider does not intersect with the button's border, avoiding visual issues
// caused by overlapping alpha colors (color.border) at the intersection.
const $25d44ebdfc301c3e$var$defaultDividerHeightStyles = {
    default: "_4t3im1ee",
    compact: "_4t3i1hvu"
};
const $25d44ebdfc301c3e$export$2e0a83ec2e27ecbb = ({ appearance: appearance, spacing: spacing, isDisabled: isDisabled = false })=>{
    const isDefaultDivider = appearance === 'default' && !isDisabled;
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        className: (0, $gMc0m.default)([
            $25d44ebdfc301c3e$var$dividerStyles.baseDivider,
            isDefaultDivider && $25d44ebdfc301c3e$var$defaultDividerHeightStyles[spacing],
            !isDefaultDivider && $25d44ebdfc301c3e$var$dividerHeightStyles[spacing],
            isDisabled && $25d44ebdfc301c3e$var$dividerStyles.dividerDisabled,
            !isDisabled && $25d44ebdfc301c3e$var$dividerAppearanceStyles[appearance],
            $25d44ebdfc301c3e$var$dividerStyles.dividerOffset
        ])
    });
};
const $25d44ebdfc301c3e$var$buttonStyles = {
    splitButton: "_1e0c116y _kqswh2mm _4cvr1h6o _o5721q9c",
    primaryButton: "_traeidpf _anlpidpf _p9ykidpf _bepvidpf",
    secondaryButton: "_1j4hidpf _1553idpf _1qgbidpf _y1n3idpf",
    defaultAppearanceContainer: "_2rkofajl _12ji1l7x _1cwg1n1a _1qu2nqa1 _12y3t94y",
    defaultAppearanceContainerT26Shape: "_2rko1qi0",
    defaultAppearanceDisabledContainer: "_12jibk0g"
}; /**
    * TODO: Add JSdoc
    */ 
const $25d44ebdfc301c3e$export$994ba1b4c598f7 = ({ appearance: appearance, children: children, isDisabled: isDisabled = false })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        className: (0, $gMc0m.default)([
            appearance === 'default' && $25d44ebdfc301c3e$var$buttonStyles.defaultAppearanceContainer,
            appearance === 'default' && (0, $dh538.fg)('platform-dst-shape-theme-default') && $25d44ebdfc301c3e$var$buttonStyles.defaultAppearanceContainerT26Shape,
            appearance === 'default' && isDisabled && $25d44ebdfc301c3e$var$buttonStyles.defaultAppearanceDisabledContainer,
            $25d44ebdfc301c3e$var$buttonStyles.splitButton
        ]),
        children: children
    });
};
const $25d44ebdfc301c3e$export$651ad66661acd392 = ({ children: children, appearance: appearance = 'default', spacing: spacing = 'default', isDisabled: isDisabled = false })=>{
    const { PrimaryAction: PrimaryAction, SecondaryAction: SecondaryAction } = (0, $3515e2fe28b45314$export$fe3955935f564b31)(children);
    return /*#__PURE__*/ (0, $l998X.jsx)($25d44ebdfc301c3e$export$994ba1b4c598f7, {
        appearance: appearance,
        isDisabled: isDisabled,
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $48w2z.SplitButtonContext).Provider, {
            value: {
                appearance: appearance,
                spacing: spacing,
                isDisabled: isDisabled
            },
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)("div", {
                    className: (0, $gMc0m.default)([
                        $25d44ebdfc301c3e$var$buttonStyles.primaryButton
                    ]),
                    children: PrimaryAction
                }),
                /*#__PURE__*/ (0, $l998X.jsx)($25d44ebdfc301c3e$export$2e0a83ec2e27ecbb, {
                    appearance: appearance,
                    spacing: spacing,
                    isDisabled: isDisabled
                }),
                /*#__PURE__*/ (0, $l998X.jsx)("div", {
                    className: (0, $gMc0m.default)([
                        $25d44ebdfc301c3e$var$buttonStyles.secondaryButton
                    ]),
                    children: SecondaryAction
                })
            ]
        })
    });
};
const $25d44ebdfc301c3e$export$e3ca81100b492e15 = ({ primaryAction: primaryAction, secondaryAction: secondaryAction, appearance: appearance = 'default', spacing: spacing = 'default', isDisabled: isDisabled = false })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)($25d44ebdfc301c3e$export$994ba1b4c598f7, {
        appearance: appearance,
        isDisabled: isDisabled,
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $48w2z.SplitButtonContext).Provider, {
            value: {
                appearance: appearance,
                spacing: spacing,
                isDisabled: isDisabled
            },
            children: [
                /*#__PURE__*/ (0, $l998X.jsx)("div", {
                    className: (0, $gMc0m.default)([
                        $25d44ebdfc301c3e$var$buttonStyles.primaryButton
                    ]),
                    children: primaryAction
                }),
                /*#__PURE__*/ (0, $l998X.jsx)($25d44ebdfc301c3e$export$2e0a83ec2e27ecbb, {
                    appearance: appearance,
                    spacing: spacing,
                    isDisabled: isDisabled
                }),
                /*#__PURE__*/ (0, $l998X.jsx)("div", {
                    className: (0, $gMc0m.default)([
                        $25d44ebdfc301c3e$var$buttonStyles.secondaryButton
                    ]),
                    children: secondaryAction
                })
            ]
        })
    });
};
module.exports["SplitButton"] = $25d44ebdfc301c3e$export$651ad66661acd392;

});

parcelRegister("bWLcG", function(module, exports) {
/**
 * This is an object of usable media query helpers using our internal breakpoints configuration.
 *
 * When using Compiled CSS-in-JS, please ensure that only a single declaration can take effect at a time.
 * This means that you should avoid multiple breakpoints taking effect at the same time,
 * eg. ```{ [media.above.xs]: { color: 'red' }, [media.above.sm]: { color: 'green' }}```.
 * Instead, make sure that only one breakpoint can take effect at a time,
 * e.g, ```{ [media.only.xs]: { color: 'red' }, [media.above.sm]: { color: 'green' }}```.
 * For more details, please see <https://compiledcssinjs.com/docs/atomic-css#selector-specificity>.
 */ const $3d6428cbc8265f6c$export$987d49ffe1b0900f = {
    above: {
        xxs: '@media all',
        xs: '@media (min-width: 30rem)',
        sm: '@media (min-width: 48rem)',
        md: '@media (min-width: 64rem)',
        lg: '@media (min-width: 90rem)',
        xl: '@media (min-width: 110.5rem)'
    },
    only: {
        xxs: '@media (min-width: 0rem) and (max-width: 29.99rem)',
        xs: '@media (min-width: 30rem) and (max-width: 47.99rem)',
        sm: '@media (min-width: 48rem) and (max-width: 63.99rem)',
        md: '@media (min-width: 64rem) and (max-width: 89.99rem)',
        lg: '@media (min-width: 90rem) and (max-width: 110.49rem)',
        xl: '@media (min-width: 110.5rem)'
    },
    below: {
        xs: '@media not all and (min-width: 30rem)',
        sm: '@media not all and (min-width: 48rem)',
        md: '@media not all and (min-width: 64rem)',
        lg: '@media not all and (min-width: 90rem)',
        xl: '@media not all and (min-width: 110.5rem)'
    }
};
const $3d6428cbc8265f6c$export$c881183ca713c214 = $3d6428cbc8265f6c$export$987d49ffe1b0900f;
module.exports["media"] = $3d6428cbc8265f6c$export$987d49ffe1b0900f;
module.exports["UNSAFE_media"] = $3d6428cbc8265f6c$export$c881183ca713c214;

});

parcelRegister("cwkWT", function(module, exports) {
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $42omo = parcelRequire("42omo");


var $9K4OG = parcelRequire("9K4OG");


var $avd77 = parcelRequire("avd77");


var $ecnYn = parcelRequire("ecnYn");

function $348631615944afd3$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $348631615944afd3$var$gridTemplateAreasVar = '--ds-grid--grid-template-areas';
const $348631615944afd3$var$gridTemplateColumnsVar = '--ds-grid--grid-template-columns';
const $348631615944afd3$var$gridTemplateRowsVar = '--ds-grid--grid-template-rows';
const $348631615944afd3$var$justifyContentMap = {
    start: {
        name: "j1lm6p",
        styles: "justify-content:start"
    },
    center: {
        name: "f7ay7b",
        styles: "justify-content:center"
    },
    end: {
        name: "jab4lt",
        styles: "justify-content:end"
    },
    'space-between': {
        name: "2o6p8u",
        styles: "justify-content:space-between"
    },
    'space-around': {
        name: "46cjum",
        styles: "justify-content:space-around"
    },
    'space-evenly': {
        name: "16166rn",
        styles: "justify-content:space-evenly"
    },
    stretch: {
        name: "11z2bqs",
        styles: "justify-content:stretch"
    }
};
const $348631615944afd3$var$justifyItemsMap = {
    start: {
        name: "lno2ya",
        styles: "justify-items:start"
    },
    center: {
        name: "1wg53za",
        styles: "justify-items:center"
    },
    end: {
        name: "3f7lhf",
        styles: "justify-items:end"
    },
    stretch: {
        name: "16hnylu",
        styles: "justify-items:stretch"
    }
};
const $348631615944afd3$var$alignContentMap = {
    start: {
        name: "iqu4as",
        styles: "align-content:start"
    },
    center: {
        name: "13vy23x",
        styles: "align-content:center"
    },
    end: {
        name: "1fj2toh",
        styles: "align-content:end"
    },
    'space-between': {
        name: "1pem0lx",
        styles: "align-content:space-between"
    },
    'space-around': {
        name: "127p7gk",
        styles: "align-content:space-around"
    },
    'space-evenly': {
        name: "kcqjal",
        styles: "align-content:space-evenly"
    },
    stretch: {
        name: "1f8yzab",
        styles: "align-content:stretch"
    }
};
const $348631615944afd3$var$alignItemsMap = {
    start: {
        name: "yvwru5",
        styles: "align-items:start"
    },
    center: {
        name: "1h3rtzg",
        styles: "align-items:center"
    },
    baseline: {
        name: "fzr848",
        styles: "align-items:baseline"
    },
    end: {
        name: "uj5xqj",
        styles: "align-items:end"
    }
};
const $348631615944afd3$var$baseStyles = /*#__PURE__*/ (0, $9K4OG.css)({
    display: 'grid',
    boxSizing: 'border-box',
    gridTemplateAreas: `var(${$348631615944afd3$var$gridTemplateAreasVar})`,
    gridTemplateColumns: `var(${$348631615944afd3$var$gridTemplateColumnsVar})`,
    gridTemplateRows: `var(${$348631615944afd3$var$gridTemplateRowsVar})`
});
const $348631615944afd3$var$gridAutoFlowMap = {
    row: {
        name: "k3yepi",
        styles: "grid-auto-flow:row"
    },
    column: {
        name: "qu4z1d",
        styles: "grid-auto-flow:column"
    },
    dense: {
        name: "mgx7bc",
        styles: "grid-auto-flow:dense"
    },
    'row dense': {
        name: "1u50cee",
        styles: "grid-auto-flow:row dense"
    },
    'column dense': {
        name: "5ak4pc",
        styles: "grid-auto-flow:column dense"
    }
};
/**
 * __Grid__
 *
 * `Grid` is a primitive component that implements the CSS Grid API.
 *
 * - [Examples](https://atlassian.design/components/primitives/grid/examples)
 * - [Code](https://atlassian.design/components/primitives/grid/code)
 *
 * @example
 * ```tsx
 * // eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
 * import { Grid, Box } from '@atlaskit/primitives'
 *
 * const Component = () => (
 *   <Grid gap="space.100" gridColumns="1fr 1fr">
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *   </Grid>
 * )
 * ```
 */ const $348631615944afd3$var$Grid = /*#__PURE__*/ (0, $42omo.memo)(/*#__PURE__*/ (0, $42omo.forwardRef)(({ as: as, alignItems: alignItems, alignContent: alignContent, justifyContent: justifyContent, gap: gap, columnGap: columnGap, rowGap: rowGap, children: children, id: id, role: role, testId: testId, autoFlow: autoFlow, templateAreas: gridTemplateAreas, templateRows: gridTemplateRows, templateColumns: gridTemplateColumns, xcss: xcss }, ref)=>{
    const Component = as || 'div';
    const resolvedStyles = (0, $ecnYn.parseXcss)(xcss);
    /**
   * We use CSS variables to allow for dynamic grid templates instead of dynamically setting to `props.style`
   * This allows `props.xcss` to override them as `style={{ gridTemplateAreas }}` would have higher specificity.
   *
   * This must be reset to `initial` if `gridTemplateAreas` is not set, otherwise nested grids will break!
   *
   * NOTE: If we disallow `grid-template-areas` (etc) to be set via `props.xcss`, we can remove this.
   */ const style = (0, $42omo.useMemo)(()=>({
            [$348631615944afd3$var$gridTemplateAreasVar]: gridTemplateAreas ? gridTemplateAreas.map((str)=>`"${str}"`).join('\n') || 'initial' : 'initial',
            [$348631615944afd3$var$gridTemplateColumnsVar]: gridTemplateColumns || 'initial',
            [$348631615944afd3$var$gridTemplateRowsVar]: gridTemplateRows || 'initial'
        }), [
        gridTemplateAreas,
        gridTemplateColumns,
        gridTemplateRows
    ]);
    return /*#__PURE__*/ (0, $9K4OG.jsx)(Component, {
        id: id,
        role: role,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: resolvedStyles.static,
        css: [
            $348631615944afd3$var$baseStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            gap && (0, $avd77.spaceStylesMap).gap[gap],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            columnGap && (0, $avd77.spaceStylesMap).columnGap[columnGap],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            rowGap && (0, $avd77.spaceStylesMap).rowGap[rowGap],
            alignItems && $348631615944afd3$var$alignItemsMap[alignItems],
            alignContent && $348631615944afd3$var$alignContentMap[alignContent],
            justifyContent && $348631615944afd3$var$justifyContentMap[justifyContent],
            autoFlow && $348631615944afd3$var$gridAutoFlowMap[autoFlow],
            ...resolvedStyles.emotion || []
        ],
        "data-testid": testId,
        ref: ref
    }, children);
}));
$348631615944afd3$var$Grid.displayName = 'Grid';
var $348631615944afd3$export$2e2bcd8739ae039 = $348631615944afd3$var$Grid;
module.exports["default"] = $348631615944afd3$export$2e2bcd8739ae039;

});

parcelRegister("kuB2l", function(module, exports) {
/* fieldset.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $bfgIy = parcelRequire("bfgIy");

const $e40212ecb6d63cfc$var$fieldSetStyles = null; /**
                              * __Fieldset__
                              *
                              * A fieldset groups a number of fields together. For example, when multiple CheckboxFields share the same name,
                              * a fieldset can be used to group them together. This makes the form more accessible.
                              *
                              * - [Examples](https://atlaskit.atlassian.com/packages/design-system/form/docs/fields)
                              * - [Code](https://atlaskit.atlassian.com/packages/design-system/form/docs/fields)
                              * - [Usage](https://atlaskit.atlassian.com/packages/design-system/form/docs/fields)
                              */ 
const $e40212ecb6d63cfc$var$Fieldset = ({ children: children, legend: legend })=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)("fieldset", {
        className: (0, $gMc0m.default)([
            "_1pfhu2gc"
        ]),
        children: [
            legend && /*#__PURE__*/ (0, $l998X.jsx)((0, $bfgIy.Legend), {
                children: legend
            }),
            children
        ]
    });
};
var $e40212ecb6d63cfc$export$2e2bcd8739ae039 = $e40212ecb6d63cfc$var$Fieldset;
module.exports["default"] = $e40212ecb6d63cfc$export$2e2bcd8739ae039;

});

parcelRegister("2aF5E", function(module, exports) {
/* bleed.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");

// NOTE: This maintains a full map of 10 styles as Bleed is a bit of a semantic outlier
const $cb4d7212f435cd8a$var$styles = {
    root: "_vchhusvi",
    'inline.space.025': "_195g1i6y",
    'inline.space.050': "_195gr5cr",
    'inline.space.100': "_195gx0bf",
    'inline.space.150': "_195gxmi2",
    'inline.space.200': "_195gmgjw",
    'block.space.025': "_1mou1i6y",
    'block.space.050': "_1mour5cr",
    'block.space.100': "_1moux0bf",
    'block.space.150': "_1mouxmi2",
    'block.space.200': "_1moumgjw"
};
/**
 * __Bleed__
 *
 * `Bleed` is a primitive layout component that controls negative whitespace.
 *
 * - [Examples](https://atlassian.design/components/primitives/bleed/examples)
 * - [Code](https://atlassian.design/components/primitives/bleed/code)
 */ const $cb4d7212f435cd8a$var$Bleed = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).memo(({ children: children, testId: testId, inline: inline, block: block, all: all, xcss: xcss })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        className: (0, $gMc0m.default)([
            $cb4d7212f435cd8a$var$styles.root,
            all && $cb4d7212f435cd8a$var$styles[`inline.${all}`],
            inline && $cb4d7212f435cd8a$var$styles[`inline.${inline}`],
            all && $cb4d7212f435cd8a$var$styles[`block.${all}`],
            block && $cb4d7212f435cd8a$var$styles[`block.${block}`],
            xcss
        ]),
        "data-testid": testId,
        children: children
    });
});
$cb4d7212f435cd8a$var$Bleed.displayName = 'Bleed';
var $cb4d7212f435cd8a$export$2e2bcd8739ae039 = $cb4d7212f435cd8a$var$Bleed;
module.exports["default"] = $cb4d7212f435cd8a$export$2e2bcd8739ae039;

});

parcelRegister("brqG4", function(module, exports) {
/* form-header.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/design-system/use-primitives */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $cO1el = parcelRequire("cO1el");

const $da388127300dd79c$var$formHeaderContentStyles = null;
const $da388127300dd79c$var$formHeaderDescriptionStyles = null; /**
                                           * __Form header__.
                                           *
                                           * A form header contains the form component's heading and subheadings. This provides the correct padding
                                           * and styling for it.
                                           *
                                           * - [Examples](https://atlaskit.atlassian.com/packages/design-system/form/docs/layout)
                                           * - [Code](https://atlaskit.atlassian.com/packages/design-system/form/docs/layout)
                                           * - [Usage](https://atlaskit.atlassian.com/packages/design-system/form/docs/layout).
                                           */ 
const $da388127300dd79c$var$FormHeader = ({ children: children, description: description, title: title })=>{
    return /*#__PURE__*/ (0, $l998X.jsxs)("div", {
        children: [
            title && /*#__PURE__*/ (0, $l998X.jsx)((0, $cO1el.default), {
                size: "large",
                children: title
            }),
            description && /*#__PURE__*/ (0, $l998X.jsx)("div", {
                className: (0, $gMc0m.default)([
                    "_1pfhu2gc"
                ]),
                children: description
            }),
            children && /*#__PURE__*/ (0, $l998X.jsx)("div", {
                className: (0, $gMc0m.default)([
                    "_1ul91osq _1pfhu2gc"
                ]),
                children: children
            })
        ]
    });
};
var $da388127300dd79c$export$2e2bcd8739ae039 = $da388127300dd79c$var$FormHeader;
module.exports["default"] = $da388127300dd79c$export$2e2bcd8739ae039;

});

parcelRegister("hkl5F", function(module, exports) {
$parcel$export(module.exports, "default", () => $ff53dd45a0f714d1$export$2e2bcd8739ae039);
/* character-counter-field.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $1VbAz = parcelRequire("1VbAz");


var $fb3kw = parcelRequire("fb3kw");


var $gQhRa = parcelRequire("gQhRa");

const $ff53dd45a0f714d1$var$fieldWrapperStyles = {
    root: "_14uxze3t"
}; // Override helper message margins to fix inconsistent spacing issue
const $ff53dd45a0f714d1$var$helperMessageWrapperStyles = {
    root: "_6rth1b66 _6ul5ze3t"
};
function $ff53dd45a0f714d1$export$2e2bcd8739ae039({ maxCharacters: maxCharacters, minCharacters: minCharacters, children: children, validate: userValidate, overMaximumMessage: overMaximumMessage, underMaximumMessage: underMaximumMessage, underMinimumMessage: underMinimumMessage, helperMessage: helperMessage, defaultValue: defaultValue, id: id, isRequired: isRequired, isDisabled: isDisabled, label: label, elementAfterLabel: elementAfterLabel, name: name, testId: testId }) {
    // Default validation function for character limits
    // __TOO_SHORT__ and __TOO_LONG__ are default error codes recognised by the CharacterCounter component
    const validateCharacterCount = (value)=>{
        const stringValue = String(value || '');
        const length = stringValue.length; // Check minimum length
        if (minCharacters !== undefined && length < minCharacters) return '__TOO_SHORT__';
         // Check maximum length
        if (maxCharacters !== undefined && length > maxCharacters) return '__TOO_LONG__';
        return undefined;
    }; // Combine user validation and character validation
    // Any user defined validation takes priority over character validation
    // If there is no user defined validation for character limits e.g. used maxLength prior to CharacterCounterField,
    // use the default error codes and display the appropriate error message
    const combinedValidate = (value, formState, fieldState)=>{
        // First run character validation
        const characterError = validateCharacterCount(value); // Then run user's custom validation if provided
        const userError = userValidate?.(value, formState, fieldState); // If user validation returns a promise, handle it
        if (userError instanceof Promise) return userError.then((error)=>{
            // User error takes priority over character validation
            return error || characterError;
        });
         // User error takes priority over character validation
        return userError || characterError;
    };
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        className: (0, $gMc0m.default)([
            $ff53dd45a0f714d1$var$fieldWrapperStyles.root
        ]),
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $fb3kw.default), {
            defaultValue: defaultValue,
            id: id,
            isRequired: isRequired,
            isDisabled: isDisabled,
            label: label,
            elementAfterLabel: elementAfterLabel,
            name: name,
            testId: testId,
            validate: combinedValidate,
            children: ({ fieldProps: extendedFieldProps, error: error, valid: valid, meta: meta })=>{
                // Determine if error is a character count violation (handled by CharacterCounter)
                // or an external validation error (needs ErrorMessage)
                const isCharacterCountViolation = error === '__TOO_SHORT__' || error === '__TOO_LONG__';
                const showExternalError = error && !isCharacterCountViolation;
                const showCharacterCounter = (maxCharacters !== undefined || minCharacters !== undefined) && !showExternalError; // Extend aria-describedby to reference the appropriate message component
                const fieldPropsWithCounter = {
                    ...extendedFieldProps,
                    'aria-describedby': showCharacterCounter ? `${extendedFieldProps['aria-describedby']} ${extendedFieldProps.id}-character-counter`.trim() : extendedFieldProps['aria-describedby']
                };
                return /*#__PURE__*/ (0, $l998X.jsxs)((0, $42omo.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $gQhRa.MessageWrapper), {
                            children: helperMessage && /*#__PURE__*/ (0, $l998X.jsx)("div", {
                                className: (0, $gMc0m.default)([
                                    $ff53dd45a0f714d1$var$helperMessageWrapperStyles.root
                                ]),
                                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $gQhRa.HelperMessage), {
                                    testId: `${testId}-helper`,
                                    children: helperMessage
                                })
                            })
                        }),
                        children({
                            fieldProps: fieldPropsWithCounter,
                            error: error,
                            valid: valid,
                            meta: meta
                        }),
                        /*#__PURE__*/ (0, $l998X.jsx)((0, $gQhRa.MessageWrapper), {
                            children: showExternalError && /*#__PURE__*/ (0, $l998X.jsx)((0, $gQhRa.ErrorMessage), {
                                testId: `${testId}-error`,
                                children: error
                            })
                        }),
                        showCharacterCounter && /*#__PURE__*/ (0, $l998X.jsx)((0, $1VbAz.default), {
                            maxCharacters: maxCharacters,
                            minCharacters: minCharacters,
                            currentValue: String(extendedFieldProps.value || ''),
                            shouldShowAsError: isCharacterCountViolation,
                            overMaximumMessage: overMaximumMessage,
                            underMaximumMessage: underMaximumMessage,
                            underMinimumMessage: underMinimumMessage,
                            testId: `${testId}-character-counter`
                        })
                    ]
                });
            }
        })
    });
}

});

parcelRegister("1VbAz", function(module, exports) {
/* character-counter.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $a3fRD = parcelRequire("a3fRD");


var $1s5hv = parcelRequire("1s5hv");

var $iXCQx = parcelRequire("iXCQx");


var $6F6hl = parcelRequire("6F6hl");


var $3SfWK = parcelRequire("3SfWK");

const $ae1428919a3dc513$var$messageContainerStyles = {
    root: "_11c8wadc _syaz1tmw _1pfh1b66"
}; // Extracted styles for error icon wrapper, need to use css to override the default height
const $ae1428919a3dc513$var$errorIconWrapperStyles = null; // Error icon with wrapper for character count violations
const $ae1428919a3dc513$var$ErrorIconWithWrapper = ()=>/*#__PURE__*/ (0, $l998X.jsx)("span", {
        className: (0, $gMc0m.default)([
            "_1e0c1txw _4t3i7vkz _4cvr1h6o"
        ]),
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($a3fRD))), {
            label: "error",
            size: "small"
        })
    });
// Helper to pluralise "character(s)"
const $ae1428919a3dc513$var$pluralize = (count)=>`character${count !== 1 ? 's' : ''}`; /**
                                                                            * __Character Counter__
                                                                            *
                                                                            * A character counter component that displays remaining characters for text input.
                                                                            * Displays messages for over or under the maximum or minimum character limits.
                                                                            */ 
const $ae1428919a3dc513$var$CharacterCounter = ({ maxCharacters: maxCharacters, minCharacters: minCharacters, currentValue: currentValue, overMaximumMessage: overMaximumMessage, underMaximumMessage: underMaximumMessage, underMinimumMessage: underMinimumMessage, shouldShowAsError: shouldShowAsError = true, inputId: inputId, testId: testId })=>{
    const [announcementText, setAnnouncementText] = (0, $42omo.useState)('');
    const debounceTimeoutRef = (0, $42omo.useRef)(null); // Resolve the field ID from context (form use) or inputId prop (standalone use)
    const contextFieldId = (0, $42omo.useContext)((0, $3SfWK.FieldId));
    const resolvedFieldId = contextFieldId || inputId;
    const currentLength = currentValue?.length || 0; // Check if character count violates limits
    const isTooShort = minCharacters !== undefined && currentLength < minCharacters;
    const isTooLong = maxCharacters !== undefined && currentLength > maxCharacters; // Determine what to display based on the current value, the maximum and minimum character limits, and any custom messages
    const getMessage = ()=>{
        // Below minimum so show custom message or default
        if (isTooShort) {
            const needed = minCharacters - currentLength;
            return underMinimumMessage || `${needed} more ${$ae1428919a3dc513$var$pluralize(needed)} needed`;
        } // Over maximum so show custom message or default
        if (isTooLong) {
            const over = currentLength - maxCharacters;
            return overMaximumMessage || `${over} ${$ae1428919a3dc513$var$pluralize(over)} too many`;
        } // Within limits - show remaining count (if max is defined)
        if (maxCharacters) {
            const remaining = maxCharacters - currentLength;
            return underMaximumMessage || `${remaining} ${$ae1428919a3dc513$var$pluralize(remaining)} remaining`;
        } // No message to show (min only limit satisfied)
        return null;
    };
    const displayText = getMessage(); // Determine if the current character count violates limits
    const displayAsError = (isTooShort || isTooLong) && shouldShowAsError; // Debounce screen reader announcements so that it only reads the message when it input has settled
    (0, $42omo.useEffect)(()=>{
        // Debounce by 1 second to avoid announcing every keystroke
        debounceTimeoutRef.current = setTimeout(()=>{
            setAnnouncementText(displayText || '');
        }, 1000); // Cleanup function clears the timeout when displayText changes or component unmounts
        return ()=>{
            clearTimeout(debounceTimeoutRef.current);
        };
    }, [
        displayText
    ]); // Don't render if there's no message to display (min only limit satisfied)
    if (!displayText) return null;
    return /*#__PURE__*/ (0, $l998X.jsxs)((0, $1s5hv.default), {
        testId: testId,
        children: [
            /*#__PURE__*/ (0, $l998X.jsxs)((0, $1s5hv.default), {
                gap: "space.075",
                xcss: $ae1428919a3dc513$var$messageContainerStyles.root,
                children: [
                    displayAsError && /*#__PURE__*/ (0, $l998X.jsx)($ae1428919a3dc513$var$ErrorIconWithWrapper, {}),
                    /*#__PURE__*/ (0, $l998X.jsx)((0, $iXCQx.default), {
                        color: displayAsError ? 'color.text.danger' : 'color.text.subtlest',
                        size: "small",
                        id: resolvedFieldId ? `${resolvedFieldId}-character-counter` : undefined,
                        children: displayText
                    })
                ]
            }),
            /*#__PURE__*/ (0, $l998X.jsx)((0, $6F6hl.default), {
                children: /*#__PURE__*/ (0, $l998X.jsx)("div", {
                    "aria-live": "polite",
                    children: announcementText
                })
            })
        ]
    });
};
var $ae1428919a3dc513$export$2e2bcd8739ae039 = $ae1428919a3dc513$var$CharacterCounter;
module.exports["default"] = $ae1428919a3dc513$export$2e2bcd8739ae039;

});

parcelRegister("hnPaP", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $85mFk = parcelRequire("85mFk");






function $6f3d82ec282ab712$export$103e9686fdc354e8(props) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $85mFk.default), {
        ...props,
        /**
			 * Making this an internal-only prop and exposing it through a facade
			 * component so that we can keep public types simple.
			 *
			 * Otherwise we need complex conditional types that are harder to
			 * understand / maintain and aren't actually any better for consumers.
			 */ isFullScreen: true,
        /**
			 * Setting width and height to 100% because the `isFullScreen` prop just
			 * removes the spacing around the modal. We still need to set the size to
			 * be 100%.
			 *
			 * Intentionally reusing the existing internals as much as possible to
			 * keep complexity low and avoid duplication. It also makes the fullscreen
			 * changes easier to remove.
			 */ width: "100%",
        height: "100%",
        /**
			 * Full screen modals only support body scrolling, so that the header
			 * and close button will always stay visible.
			 */ shouldScrollInViewport: false,
        /**
			 * This prop is a noop for fullscreen modals, so we aren't exposing it to consumers.
			 * Using `false` internally to avoid potential bugs.
			 */ shouldCloseOnOverlayClick: false,
        /**
			 * The blanket is only briefly visible for fullscreen modals when fading in,
			 * but provides a bit more of a visual cue that it has appeared on top.
			 *
			 * We don't want consumers to disable it.
			 */ isBlanketHidden: false
    });
}
module.exports["FullScreenModalDialog"] = $6f3d82ec282ab712$export$103e9686fdc354e8;

});

parcelRegister("dbEzH", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $f53f8c78f8ced4bf$export$ab57792b9b6974a6 = /*#__PURE__*/ (0, $42omo.createContext)(null);
const $f53f8c78f8ced4bf$export$dece24112a937f92 = /*#__PURE__*/ (0, $42omo.createContext)(null);
module.exports["ModalContext"] = $f53f8c78f8ced4bf$export$ab57792b9b6974a6;
module.exports["ScrollContext"] = $f53f8c78f8ced4bf$export$dece24112a937f92;

});

parcelRegister("10BNt", function(module, exports) {
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $9K4OG = parcelRequire("9K4OG");


var $dh538 = parcelRequire("dh538");

const $9d6e515abe0cf8ac$var$gridSize = 8;
const $9d6e515abe0cf8ac$var$HAS_DISABLED_BACKGROUND = [
    'default',
    'primary',
    'danger',
    'warning'
];
// ## Button layout
//
// /------------------------------------------------------------------------------------------------------------------\
// |       →  |  ←      |          |      →  |  ←      |           |      →  |  ←      |         |      →  |  ←       |
// |  10px →  |  ← 2px  |   icon   |  2px →  |  ← 2px  |           |  2px →  |  ← 2px  |  icon   |  2px →  |  ← 10px  |
// |  padding |  margin |  before  |  margin |  margin |  content  |  margin |  margin |  after  |  margin |  padding |
// |    (12px total)    |          |    (4px total)    |           |    (4px total)    |         |    (12px total)    |
// |       →  |  ←      |          |      →  |  ←      |           |      →  |  ←      |         |      →  |  ←       |
// \------------------------------------------------------------------------------------------------------------------/
//                                           ↑                               ↑
//                                        Margins don't collapse with inline-flex
//
const $9d6e515abe0cf8ac$var$heights = {
    default: `${32 / 14}em`,
    compact: `${24 / 14}em`,
    none: 'auto'
};
const $9d6e515abe0cf8ac$var$lineHeights = {
    default: $9d6e515abe0cf8ac$var$heights.default,
    compact: $9d6e515abe0cf8ac$var$heights.compact,
    none: 'inherit'
};
const $9d6e515abe0cf8ac$var$padding = {
    // 10px gutter
    default: `0 ${$9d6e515abe0cf8ac$var$gridSize + $9d6e515abe0cf8ac$var$gridSize / 4}px`,
    compact: `0 ${$9d6e515abe0cf8ac$var$gridSize + $9d6e515abe0cf8ac$var$gridSize / 4}px`,
    none: '0'
};
const $9d6e515abe0cf8ac$var$singleIconPadding = {
    // 2px gutter
    compact: `0 ${$9d6e515abe0cf8ac$var$gridSize / 4}px`,
    default: `0 ${$9d6e515abe0cf8ac$var$gridSize / 4}px`,
    none: '0'
};
const $9d6e515abe0cf8ac$var$verticalAlign = {
    default: 'middle',
    compact: 'middle',
    none: 'baseline'
};
const $9d6e515abe0cf8ac$var$innerMargin = {
    content: `0 ${$9d6e515abe0cf8ac$var$gridSize / 4}px`,
    icon: `0 ${$9d6e515abe0cf8ac$var$gridSize / 4}px`
};
const $9d6e515abe0cf8ac$var$defaultAfterStyles = {
    borderRadius: 'inherit',
    inset: "var(--ds-space-0, 0px)",
    borderStyle: 'solid',
    borderWidth: "var(--ds-border-width, 1px)",
    pointerEvents: 'none',
    position: 'absolute'
};
const $9d6e515abe0cf8ac$var$defaultStyles = {
    background: "var(--ds-background-neutral-subtle, #00000000)",
    color: "var(--ds-text, #292A2E)",
    '&::after': {
        ...$9d6e515abe0cf8ac$var$defaultAfterStyles,
        content: '""',
        borderColor: "var(--ds-border, #0B120E24)"
    },
    '&:hover': {
        background: "var(--ds-background-neutral-hovered, #0B120E24)"
    },
    '&:active': {
        background: "var(--ds-background-neutral-pressed, #080F214A)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "var(--ds-background-neutral-subtle, #00000000)"
    },
    '&:disabled[disabled]': {
        background: "var(--ds-background-neutral-subtle, #00000000)"
    },
    '&:disabled[disabled]:hover': {
        background: "var(--ds-background-neutral-subtle, #00000000)"
    },
    '&:disabled[disabled]:active': {
        background: "var(--ds-background-neutral-subtle, #00000000)"
    }
};
const $9d6e515abe0cf8ac$var$primaryStyles = {
    background: "var(--ds-background-brand-bold, #1868DB)",
    color: "var(--ds-text-inverse, #FFFFFF)",
    '&:hover': {
        background: "var(--ds-background-brand-bold-hovered, #1558BC)"
    },
    '&:active': {
        background: "var(--ds-background-brand-bold-pressed, #144794)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "var(--ds-background-brand-bold, #1868DB)"
    }
};
const $9d6e515abe0cf8ac$var$linkStyles = {
    background: 'transparent',
    color: "var(--ds-link, #1868DB)",
    '&:hover': {
        color: "var(--ds-link, #1868DB)",
        textDecoration: 'underline'
    },
    '&:active': {
        color: "var(--ds-link-pressed, #1558BC)",
        textDecoration: 'underline'
    }
};
const $9d6e515abe0cf8ac$var$subtleStyles = {
    background: 'transparent',
    color: "var(--ds-text-subtle, #505258)",
    '&:hover': {
        background: "var(--ds-background-neutral-subtle-hovered, #0515240F)"
    },
    '&:active': {
        background: "var(--ds-background-neutral-subtle-pressed, #0B120E24)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: 'transparent'
    }
};
const $9d6e515abe0cf8ac$var$subtleLinkStyles = {
    background: 'transparent',
    color: "var(--ds-text-subtle, #505258)",
    '&:hover': {
        background: 'transparent',
        color: "var(--ds-text-subtle, #505258)",
        textDecoration: 'underline'
    },
    '&:active': {
        background: 'transparent',
        color: "var(--ds-text, #292A2E)",
        textDecoration: 'underline'
    }
};
const $9d6e515abe0cf8ac$var$warningStyles = {
    background: "var(--ds-background-warning-bold, #FBC828)",
    color: "var(--ds-text-warning-inverse, #292A2E)",
    '&:hover': {
        background: "var(--ds-background-warning-bold-hovered, #FCA700)"
    },
    '&:active': {
        background: "var(--ds-background-warning-bold-pressed, #F68909)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "var(--ds-background-warning-bold, #FBC828)"
    }
};
const $9d6e515abe0cf8ac$var$dangerStyles = {
    background: "var(--ds-background-danger-bold, #C9372C)",
    color: "var(--ds-text-inverse, #FFFFFF)",
    '&:hover': {
        background: "var(--ds-background-danger-bold-hovered, #AE2E24)"
    },
    '&:active': {
        background: "var(--ds-background-danger-bold-pressed, #872821)"
    },
    '&[data-has-overlay="true"]:not([disabled]):hover': {
        background: "var(--ds-background-danger-bold, #C9372C)"
    }
};
const $9d6e515abe0cf8ac$var$selectedStyles = {
    background: "var(--ds-background-selected, #E9F2FE)",
    color: "var(--ds-text-selected, #1868DB)",
    '&:not([disabled])::after': {
        ...$9d6e515abe0cf8ac$var$defaultAfterStyles,
        content: '""',
        borderColor: "var(--ds-border-selected, #1868DB)"
    }
};
const $9d6e515abe0cf8ac$var$hasOverlayStyles = {
    '&[data-has-overlay="true"]': {
        cursor: 'default',
        textDecoration: 'none'
    }
};
function $9d6e515abe0cf8ac$export$955358618f994a11({ appearance: appearance, spacing: spacing, isSelected: isSelected, shouldFitContainer: shouldFitContainer, isOnlySingleIcon: isOnlySingleIcon }) {
    return {
        // 0px margin added to css-reset
        alignItems: 'baseline',
        borderWidth: 0,
        borderRadius: (0, $dh538.fg)('platform-dst-shape-theme-default') ? "var(--ds-radius-medium, 6px)" : "var(--ds-radius-small, 3px)",
        boxSizing: 'border-box',
        display: 'inline-flex',
        fontSize: 'inherit',
        fontStyle: 'normal',
        // Chrome recently changed button so that they use 'arial' as the font family
        fontFamily: 'inherit',
        fontWeight: "var(--ds-font-weight-medium, 500)",
        // margin for button has been applied to css reset
        maxWidth: '100%',
        // Needed to position overlay
        position: 'relative',
        textAlign: 'center',
        textDecoration: 'none',
        transition: 'background 0.1s ease-out, box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38)',
        whiteSpace: 'nowrap',
        cursor: 'pointer',
        height: $9d6e515abe0cf8ac$var$heights[spacing],
        lineHeight: $9d6e515abe0cf8ac$var$lineHeights[spacing],
        padding: isOnlySingleIcon ? $9d6e515abe0cf8ac$var$singleIconPadding[spacing] : $9d6e515abe0cf8ac$var$padding[spacing],
        verticalAlign: $9d6e515abe0cf8ac$var$verticalAlign[spacing],
        width: shouldFitContainer ? '100%' : 'auto',
        // justifyContent required for shouldFitContainer buttons with an icon inside
        justifyContent: 'center',
        ...isSelected ? $9d6e515abe0cf8ac$var$selectedStyles : {
            ...appearance === 'default' && $9d6e515abe0cf8ac$var$defaultStyles,
            ...appearance === 'primary' && $9d6e515abe0cf8ac$var$primaryStyles,
            ...appearance === 'link' && $9d6e515abe0cf8ac$var$linkStyles,
            ...appearance === 'subtle' && $9d6e515abe0cf8ac$var$subtleStyles,
            ...appearance === 'subtle-link' && $9d6e515abe0cf8ac$var$subtleLinkStyles,
            ...appearance === 'warning' && $9d6e515abe0cf8ac$var$warningStyles,
            ...appearance === 'danger' && $9d6e515abe0cf8ac$var$dangerStyles,
            '&[disabled]': {
                color: "var(--ds-text-disabled, #080F214A)",
                backgroundColor: $9d6e515abe0cf8ac$var$HAS_DISABLED_BACKGROUND.includes(appearance) ? "var(--ds-background-disabled, #17171708)" : 'transparent',
                cursor: 'not-allowed',
                textDecoration: 'none',
                '&:hovered': {
                    backgroundColor: $9d6e515abe0cf8ac$var$HAS_DISABLED_BACKGROUND.includes(appearance) ? "var(--ds-background-disabled, #17171708)" : 'transparent'
                },
                '&:active': {
                    backgroundColor: $9d6e515abe0cf8ac$var$HAS_DISABLED_BACKGROUND.includes(appearance) ? "var(--ds-background-disabled, #17171708)" : 'transparent'
                }
            },
            ...$9d6e515abe0cf8ac$var$hasOverlayStyles
        },
        '&::-moz-focus-inner': {
            border: 0,
            margin: 0,
            padding: 0
        }
    };
}
function $9d6e515abe0cf8ac$export$864eea3f4ec3368f({ spacing: spacing }) {
    return /*#__PURE__*/ (0, $9K4OG.css)({
        display: 'flex',
        // icon size cannot grow and shrink
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        margin: spacing === 'none' ? 0 : $9d6e515abe0cf8ac$var$innerMargin.icon,
        flexGrow: 0,
        flexShrink: 0,
        alignSelf: 'center',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontSize: 0,
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: 0,
        userSelect: 'none'
    });
} // inline-flex child
function $9d6e515abe0cf8ac$export$7ad0316cc0dd65a({ spacing: spacing }) {
    return /*#__PURE__*/ (0, $9K4OG.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        margin: spacing === 'none' ? 0 : $9d6e515abe0cf8ac$var$innerMargin.content,
        // content can grow and shrink
        flexGrow: 1,
        flexShrink: 1,
        // ellipsis for overflow text
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
    });
}
function $9d6e515abe0cf8ac$export$1b5827d324e945b1({ hasOverlay: hasOverlay }) {
    return /*#__PURE__*/ (0, $9K4OG.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        opacity: hasOverlay ? 0 : 1,
        transition: 'opacity 0.3s'
    });
}
const $9d6e515abe0cf8ac$export$1a9fe1b84c876bb5 = {
    // stretching to full width / height of button
    // this is important as we need it to still block
    // event if clicking in the button's own padding
    position: 'absolute',
    left: 0,
    top: 0,
    right: 0,
    bottom: 0,
    // Putting all children in the center
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
};
module.exports["getCss"] = $9d6e515abe0cf8ac$export$955358618f994a11;
module.exports["getIconStyle"] = $9d6e515abe0cf8ac$export$864eea3f4ec3368f;
module.exports["getContentStyle"] = $9d6e515abe0cf8ac$export$7ad0316cc0dd65a;
module.exports["getFadingCss"] = $9d6e515abe0cf8ac$export$1b5827d324e945b1;
module.exports["overlayCss"] = $9d6e515abe0cf8ac$export$1a9fe1b84c876bb5;

});

parcelRegister("kFobZ", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $94814a712afd9b2e$var$HasTextAncestorContext = /*#__PURE__*/ (0, $42omo.createContext)(false);
const $94814a712afd9b2e$export$9322276ec105d055 = ()=>(0, $42omo.useContext)($94814a712afd9b2e$var$HasTextAncestorContext);
const $94814a712afd9b2e$export$ae933c6cbe5643ad = $94814a712afd9b2e$var$HasTextAncestorContext.Provider;
module.exports["useHasTextAncestor"] = $94814a712afd9b2e$export$9322276ec105d055;
module.exports["HasTextAncestorProvider"] = $94814a712afd9b2e$export$ae933c6cbe5643ad;

});

parcelRegister("jvXSm", function(module, exports) {
/* content.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $gMc0m = parcelRequire("gMc0m");

parcelRequire("42omo");

const $b7ab755f143e12d0$var$styles = {
    text: "_1reo15vq _18m915vq _16jlkb7n _1o9zkb7n _1bto1l2s _o5721q9c",
    icon: "_1e0c1txw _16jlidpf _1o9zidpf _1wpz1h6o _1wybidpf _vwz4idpf _uiztglyw",
    beforeIcon: "_1he91b66 _w795v77o",
    afterIcon: "_1he9v77o _w7951b66",
    common: "_v564g17y",
    fade: "_tzy4idpf"
};
const $b7ab755f143e12d0$var$Content = ({ children: children, type: type = 'text', isLoading: isLoading, position: position })=>{
    return /*#__PURE__*/ (0, $l998X.jsx)("span", {
        className: (0, $gMc0m.default)([
            $b7ab755f143e12d0$var$styles.common,
            type === 'text' && $b7ab755f143e12d0$var$styles.text,
            type === 'icon' && $b7ab755f143e12d0$var$styles.icon,
            isLoading && $b7ab755f143e12d0$var$styles.fade,
            position === 'before' && $b7ab755f143e12d0$var$styles.beforeIcon,
            position === 'after' && $b7ab755f143e12d0$var$styles.afterIcon
        ]),
        children: children
    });
};
var $b7ab755f143e12d0$export$2e2bcd8739ae039 = $b7ab755f143e12d0$var$Content;
module.exports["default"] = $b7ab755f143e12d0$export$2e2bcd8739ae039;

});

parcelRegister("6kISY", function(module, exports) {

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $dh538 = parcelRequire("dh538");

function $c4a742c86a2d9540$var$isIconRenderProp(func) {
    return !func.displayName && // most function components and class components have a displayName, negate them
    !func.render && // forwardRef doesn't require a display name, however it does include a render function, negate them
    typeof func === 'function' // at the very least we need to be a function
    ;
}
/**
 * __Icon renderer__
 *
 * Used to support render props with icons.
 *
 */ const $c4a742c86a2d9540$var$IconRenderer = ({ icon: Icon })=>{
    const isRenderProp = $c4a742c86a2d9540$var$isIconRenderProp(Icon);
    let iconProps = {
        label: '',
        color: 'currentColor',
        size: (0, $dh538.fg)('platform_dst_button_chevron_sizing') ? (iconName)=>iconName.startsWith('Chevron') ? 'small' : 'medium' : undefined
    };
    // @ts-ignore - TS2322 TypeScript 5.9.2 upgrade
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $l998X.Fragment), {
        children: isRenderProp ? Icon(iconProps) : /*#__PURE__*/ (0, $l998X.jsx)(Icon, {
            ...iconProps
        })
    });
};
var $c4a742c86a2d9540$export$2e2bcd8739ae039 = $c4a742c86a2d9540$var$IconRenderer;
module.exports["default"] = $c4a742c86a2d9540$export$2e2bcd8739ae039;

});

parcelRegister("iprY1", function(module, exports) {
/* button-base.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $gMc0m = parcelRequire("gMc0m");


var $42omo = parcelRequire("42omo");


var $1Whri = parcelRequire("1Whri");


var $3654r = parcelRequire("3654r");


var $f93tv = parcelRequire("f93tv");


var $c0qxy = parcelRequire("c0qxy");


var $dh538 = parcelRequire("dh538");


var $fVUfS = parcelRequire("fVUfS");


var $6F6hl = parcelRequire("6F6hl");


var $48w2z = parcelRequire("48w2z");


var $l17gy = parcelRequire("l17gy");


var $5QLlw = parcelRequire("5QLlw");

const $a6152e390413c0af$var$LOADING_LABEL = ', Loading';
const $a6152e390413c0af$var$styles = {
    base: "_2rkofajl _11c8fhey _v5649dqc _189eidpf _1rjc12x7 _1e0c116y _vchhusvi _1bsb1wug _p12f1osq _kqswh2mm _4cvr1q9y _1bah1h6o _gy1p1b66 _1o9zidpf _4t3iviql _k48p1wq8 _y4tiutpp _bozgutpp _y3gn1h6o _s7n4nkob _14mj1kw7 _9v7aze3t _1tv3nqa1 _39yqe4h9 _11fnglyw _18postnw",
    baseT26Shape: "_2rko1qi0",
    linkDecorationUnset: "_4bfu1r31 _1hmsglyw _ajmmnqa1 _1a3b1r31 _4fprglyw _5goinqa1 _9oik1r31 _1bnxglyw _jf4cnqa1 _1nrm1r31 _c2waglyw _1iohnqa1",
    disabled: "_80om13gf _syaz1gmx _30l31gmx _9h8h1gmx",
    sharedDisabled: "_bfhkby5v _irr3by5v _1di6by5v",
    spacingCompact: "_1rjcv77o _gy1p1b66 _4t3i1k8s _y4tiutpp _bozgutpp _s7n4nkob",
    spacingCompactT26Shape: "_2rko12b0",
    circle: "_2rko1rr0",
    fullWidth: "_1bsb1osq",
    loading: "_80om15jw",
    iconButton: "_4t3iviql _1bsbviql _y4tize3t _bozgze3t",
    iconButtonCompact: "_4t3i1k8s _1bsb1k8s",
    buttonIconBefore: "_bozgu2gc",
    buttonIconAfter: "_y4tiu2gc",
    splitButton: "_g0pbb4wl",
    loadingOverlay: "_1reo15vq _18m915vq _1e0c1txw _kqswstnw _4cvr1h6o _1bah1h6o _u7coze3t _152tze3t _rjxpze3t _1e02ze3t",
    navigationSplitButton: "_1bsb1tcg _bfhksm61 _y4ti12x7 _bozg12x7"
};
const $a6152e390413c0af$var$defaultStyles = {
    root: "_bfhksm61 _syazazsu _8l3m1l7x _aetrb3bt _1053azsu _f8pjazsu _30l3azsu _9h8hazsu",
    interactive: "_irr31dpa _30l3azsu _1di6fcek _9h8hazsu",
    disabled: "_bfhk1j28 _8l3mbk0g _irr31j28 _1di61j28"
};
const $a6152e390413c0af$var$primaryStyles = {
    root: "_bfhk1856 _syaz15cr _105315cr _f8pj15cr _30l315cr _9h8h15cr",
    interactive: "_30l315cr _irr3hf2y _9h8h15cr _1di6g6ey"
};
const $a6152e390413c0af$var$warningStyles = {
    root: "_bfhk1kmu _syaz1yd3 _10531yd3 _f8pj1yd3 _30l31yd3 _9h8h1yd3",
    interactive: "_30l31yd3 _irr31spp _9h8h1yd3 _1di64m4m"
};
const $a6152e390413c0af$var$dangerStyles = {
    root: "_bfhkybec _syaz15cr _105315cr _f8pj15cr _30l315cr _9h8h15cr",
    interactive: "_30l315cr _irr3s9hg _9h8h15cr _1di613a9"
};
const $a6152e390413c0af$var$discoveryStyles = {
    root: "_bfhku5tj _syaz15cr _105315cr _f8pj15cr _30l315cr _9h8h15cr",
    interactive: "_30l315cr _irr3fqeg _9h8h15cr _1di61f1m"
};
const $a6152e390413c0af$var$subtleStyles = {
    root: "_bfhksm61 _syazazsu _1053azsu _f8pjazsu _30l3azsu _9h8hazsu",
    interactive: "_irr31dpa _30l3azsu _1di6fcek _9h8hazsu",
    disabled: "_bfhk1j28 _8l3mbk0g _irr31j28 _1di61j28"
};
const $a6152e390413c0af$var$selectedStyles = {
    root: "_bfhk15s3 _syaz6x5g _8l3mq98m _aetrb3bt _10536x5g _f8pj6x5g _30l36x5g _9h8h6x5g",
    insideSplitButton: "_1pbycs5v",
    interactive: "_irr3ufnl _30l36x5g _1di6nozp _9h8h6x5g",
    warning: "_bfhk15s3 _syaz6x5g _30l36x5g _irr315s3 _9h8h6x5g _1di615s3",
    danger: "_bfhk15s3 _syaz6x5g _30l36x5g _irr315s3 _9h8h6x5g _1di615s3",
    discovery: "_bfhk15s3 _syaz6x5g _30l36x5g _irr315s3 _9h8h6x5g _1di615s3"
}; /**
    * __button base__
    *
    * - Implements auto focus when enabled.
    * - Appends the `onClick` event with UFO analytics tracking.
    *
    * @private
    */ 
const $a6152e390413c0af$var$ButtonBase = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).forwardRef(// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore: to unblock React 18.2.0 -> 18.3.1 version bump in Jira
({ appearance: propAppearance, autoFocus: autoFocus = false, isDisabled: propIsDisabled = false, isLoading: isLoading = false, isSelected: propIsSelected = false, isIconButton: isIconButton = false, isCircle: isCircle = false, hasIconBefore: hasIconBefore = false, hasIconAfter: hasIconAfter = false, shouldFitContainer: shouldFitContainer = false, spacing: propSpacing = 'default', ariaLabel: ariaLabel, ariaLabelledBy: ariaLabelledBy, children: children, interactionName: interactionName, onClick: onClick, onMouseDown: onMouseDown, onMouseDownCapture: onMouseDownCapture, onMouseUp: onMouseUp, onMouseUpCapture: onMouseUpCapture, onKeyDown: onKeyDown, onKeyDownCapture: onKeyDownCapture, onKeyUp: onKeyUp, onKeyUpCapture: onKeyUpCapture, onTouchStart: onTouchStart, onTouchStartCapture: onTouchStartCapture, onTouchEnd: onTouchEnd, onTouchEndCapture: onTouchEndCapture, onPointerDown: onPointerDown, onPointerDownCapture: onPointerDownCapture, onPointerUp: onPointerUp, onPointerUpCapture: onPointerUpCapture, onClickCapture: onClickCapture, testId: testId, analyticsContext: analyticsContext, componentName: componentName, role: role, onMouseOver: onMouseOver, onMouseOut: onMouseOut, onFocus: onFocus, onBlur: onBlur, onMouseMove: onMouseMove, type: type, ...unsafeRest }, ref)=>{
    const localRef = (0, $42omo.useRef)(null);
    const splitButtonContext = (0, $48w2z.useSplitButtonContext)();
    const loadingLabelId = (0, $c0qxy.useId)();
    const isSplitButton = Boolean(splitButtonContext);
    const isNavigationSplitButton = splitButtonContext?.isNavigationSplitButton || false;
    const isDefaultAppearanceSplitButton = splitButtonContext?.appearance === 'default';
    const appearance = isDefaultAppearanceSplitButton ? 'subtle' : propAppearance || splitButtonContext?.appearance || 'default';
    const spacing = splitButtonContext?.spacing || propSpacing;
    const isDisabled = splitButtonContext?.isDisabled || propIsDisabled;
    const isInteractive = !isDisabled && !isLoading; // Also treat loading buttons as disabled
    const isEffectivelyDisabled = isDisabled || isLoading;
    const isSelected = propIsSelected && !isDisabled;
    (0, $f93tv.default)(localRef, autoFocus); // @ts-expect-error
    const { className: _className, css: _css, as: _as, style: _style, ...saferRest } = unsafeRest;
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $fVUfS.default), {
        ...saferRest,
        componentName: componentName || 'button',
        analyticsContext: analyticsContext,
        role: role,
        ref: (0, $3654r.default)([
            localRef,
            ref
        ]),
        xcss: (0, $1Whri.cx)($a6152e390413c0af$var$styles.base, (0, $dh538.fg)('platform-dst-shape-theme-default') && $a6152e390413c0af$var$styles.baseT26Shape, appearance === 'default' && $a6152e390413c0af$var$defaultStyles.root, appearance === 'default' && isInteractive && $a6152e390413c0af$var$defaultStyles.interactive, appearance === 'primary' && $a6152e390413c0af$var$primaryStyles.root, appearance === 'primary' && isInteractive && $a6152e390413c0af$var$primaryStyles.interactive, appearance === 'warning' && $a6152e390413c0af$var$warningStyles.root, appearance === 'warning' && isInteractive && $a6152e390413c0af$var$warningStyles.interactive, appearance === 'danger' && $a6152e390413c0af$var$dangerStyles.root, appearance === 'danger' && isInteractive && $a6152e390413c0af$var$dangerStyles.interactive, appearance === 'discovery' && $a6152e390413c0af$var$discoveryStyles.root, appearance === 'discovery' && isInteractive && $a6152e390413c0af$var$discoveryStyles.interactive, appearance === 'subtle' && $a6152e390413c0af$var$subtleStyles.root, appearance === 'subtle' && isInteractive && $a6152e390413c0af$var$subtleStyles.interactive, $a6152e390413c0af$var$styles.linkDecorationUnset, isSelected && $a6152e390413c0af$var$selectedStyles.root, isSelected && isSplitButton && $a6152e390413c0af$var$selectedStyles.insideSplitButton, isSelected && isInteractive && $a6152e390413c0af$var$selectedStyles.interactive, // TODO: remove me once we kill color fallbacks
        isSelected && appearance === 'danger' && $a6152e390413c0af$var$selectedStyles.danger, // TODO: remove me once we kill color fallbacks
        isSelected && appearance === 'warning' && $a6152e390413c0af$var$selectedStyles.warning, // TODO: remove me once we kill color fallbacks
        isSelected && appearance === 'discovery' && $a6152e390413c0af$var$selectedStyles.discovery, isDisabled && $a6152e390413c0af$var$styles.disabled, isDisabled && appearance !== 'default' && appearance !== 'subtle' && $a6152e390413c0af$var$styles.sharedDisabled, isDisabled && appearance === 'default' && $a6152e390413c0af$var$defaultStyles.disabled, isCircle && !isSplitButton && $a6152e390413c0af$var$styles.circle, spacing === 'compact' && $a6152e390413c0af$var$styles.spacingCompact, spacing === 'compact' && (0, $dh538.fg)('platform-dst-shape-theme-default') && $a6152e390413c0af$var$styles.spacingCompactT26Shape, hasIconBefore && $a6152e390413c0af$var$styles.buttonIconBefore, shouldFitContainer && $a6152e390413c0af$var$styles.fullWidth, hasIconAfter && $a6152e390413c0af$var$styles.buttonIconAfter, isIconButton && $a6152e390413c0af$var$styles.iconButton, isIconButton && spacing === 'compact' && $a6152e390413c0af$var$styles.iconButtonCompact, isLoading && $a6152e390413c0af$var$styles.loading, isSplitButton && $a6152e390413c0af$var$styles.splitButton, isNavigationSplitButton && $a6152e390413c0af$var$styles.navigationSplitButton),
        isDisabled: (0, $dh538.fg)('platform-dst_fix_not_focusable_loading_button') ? isDisabled : isEffectivelyDisabled,
        ...(0, $dh538.fg)('platform-dst_fix_not_focusable_loading_button') && {
            'aria-live': 'polite'
        },
        ...isLoading && (0, $dh538.fg)('platform-dst_fix_not_focusable_loading_button') && {
            'aria-disabled': true
        },
        "aria-label": isLoading && ariaLabel && !ariaLabelledBy ? `${ariaLabel} ${$a6152e390413c0af$var$LOADING_LABEL}` : ariaLabel,
        "aria-labelledby": isLoading && ariaLabelledBy ? `${ariaLabelledBy} ${loadingLabelId}` : ariaLabelledBy,
        onClick: onClick,
        ...(0, $l17gy.default)(isEffectivelyDisabled, {
            onMouseDownCapture: onMouseDownCapture,
            onMouseUpCapture: onMouseUpCapture,
            onKeyDownCapture: onKeyDownCapture,
            onKeyUpCapture: onKeyUpCapture,
            onTouchStartCapture: onTouchStartCapture,
            onTouchEndCapture: onTouchEndCapture,
            onPointerDownCapture: onPointerDownCapture,
            onPointerUpCapture: onPointerUpCapture,
            onClickCapture: onClickCapture
        }),
        testId: testId,
        onMouseOver: onMouseOver,
        onFocus: onFocus,
        onMouseMove: onMouseMove,
        onBlur: onBlur,
        type: type,
        interactionName: interactionName,
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp,
        onKeyDown: onKeyDown,
        onMouseOut: onMouseOut,
        onKeyUp: onKeyUp,
        onTouchStart: onTouchStart,
        onTouchEnd: onTouchEnd,
        onPointerDown: onPointerDown,
        onPointerUp: onPointerUp,
        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $48w2z.SplitButtonContext).Provider, {
            value: undefined,
            children: [
                children,
                isLoading && /*#__PURE__*/ (0, $l998X.jsx)("span", {
                    className: (0, $gMc0m.default)([
                        $a6152e390413c0af$var$styles.loadingOverlay
                    ]),
                    children: (0, $5QLlw.default)({
                        spacing: spacing,
                        appearance: appearance,
                        isDisabled: isDisabled,
                        isSelected: isSelected,
                        testId: testId
                    })
                }),
                isLoading && (ariaLabelledBy || !ariaLabel) && /*#__PURE__*/ (0, $l998X.jsx)((0, $6F6hl.default), {
                    id: loadingLabelId,
                    children: $a6152e390413c0af$var$LOADING_LABEL
                })
            ]
        })
    });
});
var $a6152e390413c0af$export$2e2bcd8739ae039 = $a6152e390413c0af$var$ButtonBase;
module.exports["default"] = $a6152e390413c0af$export$2e2bcd8739ae039;

});

parcelRegister("3SfWK", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $fff203a8152793f9$export$3c4232819458a302 = /*#__PURE__*/ (0, $42omo.createContext)(undefined);
module.exports["FieldId"] = $fff203a8152793f9$export$3c4232819458a302;

});

parcelRegister("gcG0P", function(module, exports) {
/* eslint-disable @atlaskit/design-system/consistent-css-prop-usage */ /**
* @jsxRuntime classic
* @jsx jsx
*/ 
var $42omo = parcelRequire("42omo");


var $9K4OG = parcelRequire("9K4OG");


var $gxtzC = parcelRequire("gxtzC");


var $ee7An = parcelRequire("ee7An");


var $f93tv = parcelRequire("f93tv");


var $dOMrE = parcelRequire("dOMrE");


var $90YwQ = parcelRequire("90YwQ");


var $4aKUR = parcelRequire("4aKUR");


var $10BNt = parcelRequire("10BNt");


var $gDSSU = parcelRequire("gDSSU");

function $6363a9f199f4604f$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// We are disabling pointer events on child elements so that
// the button will always be the target of events
// Note: firefox does not have this behaviour for child elements
const $6363a9f199f4604f$var$noPointerEventsOnChildrenCss = {
    '> *': {
        pointerEvents: 'none'
    }
};
const $6363a9f199f4604f$var$iconBeforeSpacingFixStyle = {
    name: "s584p2",
    styles: "--ds--button--new-icon-padding-end:var(--ds-space-025, 2px);--ds--button--new-icon-padding-start:var(--ds-space-050, 4px);margin-inline-start:var(--ds-space-negative-025, -2px)"
};
const $6363a9f199f4604f$var$iconAfterSpacingFixStyle = {
    name: "150qmyr",
    styles: "--ds--button--new-icon-padding-end:var(--ds-space-050, 4px);--ds--button--new-icon-padding-start:var(--ds-space-025, 2px);margin-inline-end:var(--ds-space-negative-025, -2px)"
};
const $6363a9f199f4604f$var$getSpacingFix = (children, spacingStyles)=>{
    if (!children || (0, $gDSSU.getIfVisuallyHiddenChildren)(children)) return null;
    return spacingStyles;
};
const $6363a9f199f4604f$var$getChildren = (children, childrenStyles)=>{
    if ((0, $gDSSU.getIfVisuallyHiddenChildren)(children)) return children;
    return children ? /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
        css: childrenStyles
    }, children) : null;
};
const $6363a9f199f4604f$var$ButtonBase = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).forwardRef(function ButtonBase(props, ref) {
    const { analyticsContext: // I don't think analytics should be in button, but for now it is
    analyticsContext, appearance: appearance = 'default', autoFocus: autoFocus = false, buttonCss: buttonCss, children: children, className: className, href: href, // use the provided component prop,
    // else default to anchor if there is a href, and button if there is no href
    component: Component = href ? 'a' : 'button', iconAfter: iconAfter, iconBefore: iconBefore, interactionName: interactionName, isDisabled: isDisabled = false, isSelected: isSelected = false, onBlur: onBlur, onClick: providedOnClick = (0, $ee7An.default), onFocus: onFocus, onMouseDown: providedOnMouseDown = (0, $ee7An.default), overlay: overlay, shouldFitContainer: // Pulling out so it doesn't spread on rendered component
    shouldFitContainer, spacing: spacing = 'default', tabIndex: tabIndex = 0, type: type = !href ? 'button' : undefined, testId: testId, ...rest } = props;
    const ourRef = (0, $42omo.useRef)();
    const setRef = (0, $42omo.useCallback)((node)=>{
        ourRef.current = node;
        if (ref == null) return;
        if (typeof ref === 'function') {
            ref(node);
            return;
        } // We can write to ref's `current` property, but Typescript does not like it.
        // @ts-ignore
        ref.current = node;
    }, [
        ourRef,
        ref
    ]); // Cross browser auto focusing is pretty broken, so we are doing it ourselves
    (0, $f93tv.default)(ourRef, autoFocus);
    const interactionContext = (0, $42omo.useContext)((0, $90YwQ.default));
    const handleClick = (0, $42omo.useCallback)((e, analyticsEvent)=>{
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    const onClick = (0, $gxtzC.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: 'clicked',
        componentName: 'button',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local",
        analyticsData: analyticsContext
    }); // Button currently calls preventDefault, which is not standard button behaviour
    const onMouseDown = (0, $42omo.useCallback)((event)=>{
        event.preventDefault();
        providedOnMouseDown(event);
    }, [
        providedOnMouseDown
    ]); // Lose focus when becoming disabled (standard button behaviour)
    (0, $42omo.useEffect)(()=>{
        const el = ourRef.current;
        if (isDisabled && el && el === document.activeElement) el.blur();
    }, [
        isDisabled
    ]); // we are 'disabling' input with a button when there is an overlay
    const hasOverlay = Boolean(overlay); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    const fadeStyles = /*#__PURE__*/ (0, $9K4OG.css)((0, $10BNt.getFadingCss)({
        hasOverlay: hasOverlay
    }));
    const isInteractive = !isDisabled && !hasOverlay; /**
                                                             * HACK: Spinner needs to have different colours in the "new" tokens design compared to the old design.
                                                             * For now, while we support both, these styles reach into Spinner when a theme is set, applies the right color.
                                                             * Ticket to remove: https://product-fabric.atlassian.net/browse/DSP-2067.
                                                             */ 
    var spinnerHackCss = {};
    if (isSelected || isDisabled || appearance === 'warning') spinnerHackCss = {
        '[data-theme] & circle': {
            stroke: `${isSelected || isDisabled ? "var(--ds-icon-subtle, #505258)" : "var(--ds-icon-warning-inverse, #292A2E)"} !important`
        }
    };
    return /*#__PURE__*/ (0, $9K4OG.jsx)((0, $dOMrE.default), null, /*#__PURE__*/ (0, $9K4OG.jsx)(Component, {
        ...rest,
        ref: setRef,
        className: className,
        css: [
            buttonCss,
            isInteractive ? null : $6363a9f199f4604f$var$noPointerEventsOnChildrenCss
        ],
        "data-has-overlay": hasOverlay ? true : undefined,
        "data-testid": testId,
        disabled: isDisabled,
        href: isInteractive ? href : undefined,
        onBlur: onBlur,
        onClick: onClick,
        onFocus: onFocus,
        onMouseDown: onMouseDown,
        // Disabling focus via keyboard navigation when disabled
        // as this is standard button behaviour
        tabIndex: isDisabled ? -1 : tabIndex,
        type: type,
        ...(0, $4aKUR.default)({
            isInteractive: isInteractive
        })
    }, iconBefore ? /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
        css: [
            fadeStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $10BNt.getIconStyle)({
                spacing: spacing
            }),
            $6363a9f199f4604f$var$getSpacingFix(children, $6363a9f199f4604f$var$iconBeforeSpacingFixStyle)
        ]
    }, iconBefore) : null, $6363a9f199f4604f$var$getChildren(children, [
        fadeStyles,
        (0, $10BNt.getContentStyle)({
            spacing: spacing
        })
    ]), iconAfter ? /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
        css: [
            fadeStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $10BNt.getIconStyle)({
                spacing: spacing
            }),
            $6363a9f199f4604f$var$getSpacingFix(children, $6363a9f199f4604f$var$iconAfterSpacingFixStyle)
        ]
    }, iconAfter) : null, overlay ? /*#__PURE__*/ (0, $9K4OG.jsx)("span", {
        css: [
            (0, $10BNt.overlayCss),
            spinnerHackCss
        ]
    }, overlay) : null));
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$6363a9f199f4604f$export$2e2bcd8739ae039 = $6363a9f199f4604f$var$ButtonBase;
module.exports["default"] = $6363a9f199f4604f$export$2e2bcd8739ae039;

});

parcelRegister("hYfEs", function(module, exports) {
$parcel$export(module.exports, "default", () => $297b32beaea491d4$export$2e2bcd8739ae039);

var $gDSSU = parcelRequire("gDSSU");

function $297b32beaea491d4$export$2e2bcd8739ae039({ children: children, iconBefore: iconBefore, iconAfter: iconAfter }) {
    if ((0, $gDSSU.getIfVisuallyHiddenChildren)(children)) return true;
    if (children) return false;
    if (iconBefore && !iconAfter) return true;
    if (!iconBefore && iconAfter) return true;
    return false;
}

});

parcelRegister("etbQ0", function(module, exports) {
$parcel$export(module.exports, "default", () => $abde033265554c13$export$2e2bcd8739ae039);

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $9hlns = parcelRequire("9hlns");

function $abde033265554c13$var$getSpinnerAppearance({ appearance: appearance, isDisabled: isDisabled, isSelected: isSelected }) {
    if (isDisabled) return 'inherit';
    if (isSelected) return 'invert';
    if (appearance === 'primary' || appearance === 'danger') return 'invert';
    return 'inherit';
}
function $abde033265554c13$export$2e2bcd8739ae039({ appearance: appearance, isDisabled: isDisabled, isSelected: isSelected, spacing: spacing = 'default' }) {
    const size = spacing === 'default' ? 'medium' : 'small';
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $9hlns.default), {
        size: size,
        label: ", Loading",
        appearance: $abde033265554c13$var$getSpinnerAppearance({
            appearance: appearance,
            isDisabled: isDisabled,
            isSelected: isSelected
        })
    });
}

});

parcelRegister("48w2z", function(module, exports) {

var $42omo = parcelRequire("42omo");

const $39cc8a8dcc98e0da$export$4b86304b2c0d7e71 = /*#__PURE__*/ (0, $42omo.createContext)(undefined);
const $39cc8a8dcc98e0da$export$47e2c6fdb142d947 = ()=>{
    const context = (0, $42omo.useContext)($39cc8a8dcc98e0da$export$4b86304b2c0d7e71);
    if (!context) return undefined;
    if (context.appearance === 'navigation') {
        const newContext = {
            spacing: 'default',
            appearance: 'subtle',
            isDisabled: false,
            isActiveOverSelected: false,
            isNavigationSplitButton: true,
            isHighlighted: context.isHighlighted
        };
        return newContext;
    }
    const splitButtonContext = {
        spacing: context.spacing,
        appearance: context.appearance,
        isDisabled: context.isDisabled,
        isActiveOverSelected: true,
        isNavigationSplitButton: false,
        isHighlighted: false
    };
    return splitButtonContext;
};
module.exports["SplitButtonContext"] = $39cc8a8dcc98e0da$export$4b86304b2c0d7e71;
module.exports["useSplitButtonContext"] = $39cc8a8dcc98e0da$export$47e2c6fdb142d947;

});

parcelRegister("85mFk", function(module, exports) {
/* modal-wrapper.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $5zdke = parcelRequire("5zdke");


var $crya1 = parcelRequire("crya1");


var $gxtzC = parcelRequire("gxtzC");


var $4kfV4 = parcelRequire("4kfV4");


var $ee7An = parcelRequire("ee7An");


var $iug2J = parcelRequire("iug2J");


var $if5rb = parcelRequire("if5rb");


var $fT2ta = parcelRequire("fT2ta");


var $caX7N = parcelRequire("caX7N");


var $dTk3A = parcelRequire("dTk3A");


var $bZ1JU = parcelRequire("bZ1JU");


var $bDzqh = parcelRequire("bDzqh");


var $amR5O = parcelRequire("amR5O");

const $abfa48199e8cddc5$var$fillScreenStyles = null;
const $abfa48199e8cddc5$var$allowlistElements = (element, callback)=>{
    // Allow focus to reach elements outside the modal:
    // if AUI dialog is allowListed and visible
    if (!!document.querySelector('.aui-blanket:not([hidden])')) return false;
     // allows to pass a callback function to allow elements be ignored by focus lock
    if (typeof callback === 'function') return callback(element);
    return true;
};
/**
 * __Modal wrapper__
 *
 * A modal wrapper displays content that requires user interaction, in a layer above the page.
 * This component is primary container for other modal components.
 *
 * - [Examples](https://atlassian.design/components/modal-dialog/examples)
 * - [Code](https://atlassian.design/components/modal-dialog/code)
 * - [Usage](https://atlassian.design/components/modal-dialog/usage)
 */ const $abfa48199e8cddc5$var$InternalModalWrapper = (props)=>{
    const { autoFocus: autoFocus = true, focusLockAllowlist: focusLockAllowlist, shouldCloseOnEscapePress: shouldCloseOnEscapePress = true, shouldCloseOnOverlayClick: shouldCloseOnOverlayClick = true, shouldScrollInViewport: shouldScrollInViewport = false, shouldReturnFocus: shouldReturnFocus = true, stackIndex: stackIndexOverride, onClose: providedOnClose, onStackChange: onStackChange = (0, $ee7An.default), isBlanketHidden: isBlanketHidden, children: children, height: height, width: width, onCloseComplete: onCloseComplete, onOpenComplete: onOpenComplete, label: label, testId: testId, isFullScreen: isFullScreen } = props;
    const calculatedStackIndex = (0, $bZ1JU.default)({
        onStackChange: onStackChange
    });
    const stackIndex = stackIndexOverride || calculatedStackIndex;
    const isForeground = stackIndex === 0; // When a user supplies a ref to focus we skip auto focus via react-focus-lock
    const autoFocusLock = typeof autoFocus === 'boolean' ? autoFocus : false;
    const onCloseHandler = (0, $gxtzC.usePlatformLeafEventHandler)({
        fn: providedOnClose || (0, $ee7An.default),
        action: 'closed',
        componentName: 'modalDialog',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    });
    const onBlanketClicked = (0, $42omo.useCallback)((e)=>{
        if (shouldCloseOnOverlayClick) onCloseHandler(e);
    }, [
        shouldCloseOnOverlayClick,
        onCloseHandler
    ]); // This ensures to prevent additional re-renders while nothing is passed to focusLockAllowlist explicitly.
    const allowListCallback = (0, $42omo.useCallback)((element)=>$abfa48199e8cddc5$var$allowlistElements(element, focusLockAllowlist), [
        focusLockAllowlist
    ]);
    (0, $bDzqh.default)();
    (0, $if5rb.useNotifyOpenLayerObserver)({
        type: 'modal',
        // Modal dialog is conditionally rendered when visible, so when this runs it is always open.
        isOpen: true,
        // Passing a no-op for now, as there isn't a real use case for closing the modal dialog programmatically
        // by the OpenLayerObserver. The only current use case is closing layers when resizing the nav layout,
        // which cannot happen while a modal dialog is open.
        onClose: (0, $ee7An.default)
    });
    const modalDialogWithBlanket = /*#__PURE__*/ (0, $l998X.jsx)((0, $4kfV4.default), {
        isTinted: !isBlanketHidden,
        onBlanketClicked: onBlanketClicked,
        testId: testId && `${testId}--blanket`,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $amR5O.default), {
            testId: testId,
            label: label,
            autoFocus: autoFocus,
            stackIndex: stackIndex,
            onClose: onCloseHandler,
            shouldCloseOnEscapePress: shouldCloseOnEscapePress && isForeground,
            shouldScrollInViewport: shouldScrollInViewport,
            height: height,
            width: width,
            onCloseComplete: onCloseComplete,
            onOpenComplete: onOpenComplete,
            hasProvidedOnClose: Boolean(providedOnClose),
            isFullScreen: isFullScreen,
            children: children
        })
    });
    let returnFocus = true;
    let onDeactivation;
    if ('boolean' === typeof shouldReturnFocus) returnFocus = shouldReturnFocus;
    else onDeactivation = ()=>{
        window.setTimeout(()=>{
            shouldReturnFocus.current?.focus();
        }, 0);
    };
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $iug2J.Layering), {
        isDisabled: false,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $caX7N.default), {
            zIndex: (0, $dTk3A.layers).modal(),
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $fT2ta.default), {
                children: (fadeInProps)=>/*#__PURE__*/ (0, $l998X.jsx)("div", {
                        ...fadeInProps,
                        className: (0, $gMc0m.default)([
                            "_1bsbauwl _4t3i1kxc _kqsw1n9t _152tze3t _1e02ze3t _18m91wug _8am5i4x0",
                            fadeInProps.className
                        ]),
                        "aria-hidden": !isForeground,
                        children: /*#__PURE__*/ (0, $l998X.jsxs)((0, $5zdke.default), {
                            autoFocus: autoFocusLock,
                            returnFocus: returnFocus,
                            onDeactivation: onDeactivation,
                            whiteList: allowListCallback,
                            children: [
                                /*#__PURE__*/ (0, $l998X.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($crya1))), {}),
                                shouldScrollInViewport ? /*#__PURE__*/ (0, $l998X.jsx)((0, $crya1.TouchScrollable), {
                                    children: modalDialogWithBlanket
                                }) : modalDialogWithBlanket
                            ]
                        })
                    })
            })
        })
    });
};
var $abfa48199e8cddc5$export$2e2bcd8739ae039 = $abfa48199e8cddc5$var$InternalModalWrapper;
module.exports["default"] = $abfa48199e8cddc5$export$2e2bcd8739ae039;

});

parcelRegister("l17gy", function(module, exports) {
$parcel$export(module.exports, "default", () => $2ebbfb42e3816633$export$2e2bcd8739ae039);
function $2ebbfb42e3816633$var$abort(event) {
    event.preventDefault();
    event.stopPropagation();
}
const $2ebbfb42e3816633$var$tabKeyCode = 9;
function $2ebbfb42e3816633$var$onKey(event) {
    // Allowing tab so that a user can move focus away
    if (event.keyCode === $2ebbfb42e3816633$var$tabKeyCode) return;
    $2ebbfb42e3816633$var$abort(event);
}
function $2ebbfb42e3816633$export$2e2bcd8739ae039(shouldBlockEvents, events) {
    return shouldBlockEvents ? {
        onMouseDownCapture: $2ebbfb42e3816633$var$abort,
        onMouseUpCapture: $2ebbfb42e3816633$var$abort,
        onKeyDownCapture: $2ebbfb42e3816633$var$onKey,
        onKeyUpCapture: $2ebbfb42e3816633$var$onKey,
        onTouchStartCapture: $2ebbfb42e3816633$var$abort,
        onTouchEndCapture: $2ebbfb42e3816633$var$abort,
        onPointerDownCapture: $2ebbfb42e3816633$var$abort,
        onPointerUpCapture: $2ebbfb42e3816633$var$abort,
        onClickCapture: $2ebbfb42e3816633$var$abort,
        // Just smashing the existing onClick for good measure
        onClick: $2ebbfb42e3816633$var$abort
    } : events;
}

});

parcelRegister("5QLlw", function(module, exports) {
$parcel$export(module.exports, "default", () => $a3958ed51c10911c$export$2e2bcd8739ae039);

var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $9hlns = parcelRequire("9hlns");

function $a3958ed51c10911c$var$getIconSpacing(spacing) {
    switch(spacing){
        case 'compact':
            return 'small';
        default:
            return 'medium';
    }
}
function $a3958ed51c10911c$var$getSpinnerAppearance({ appearance: appearance, isDisabled: isDisabled, isSelected: isSelected }) {
    if (isDisabled || isSelected) return 'inherit';
    if (appearance === 'primary' || appearance === 'danger' || appearance === 'discovery') return 'invert';
    return 'inherit';
}
function $a3958ed51c10911c$export$2e2bcd8739ae039({ appearance: appearance, spacing: spacing, isDisabled: isDisabled, isSelected: isSelected, testId: testId }) {
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $9hlns.default), {
        size: $a3958ed51c10911c$var$getIconSpacing(spacing),
        appearance: $a3958ed51c10911c$var$getSpinnerAppearance({
            appearance: appearance,
            isDisabled: isDisabled,
            isSelected: isSelected
        }),
        testId: testId ? `${testId}--loading-spinner` : undefined
    });
}

});

parcelRegister("4aKUR", function(module, exports) {
$parcel$export(module.exports, "default", () => $14ed0e9b51202eb5$export$2e2bcd8739ae039);
function $14ed0e9b51202eb5$var$abort(event) {
    event.preventDefault();
    event.stopPropagation();
}
const $14ed0e9b51202eb5$var$tabKeyCode = 9;
function $14ed0e9b51202eb5$var$onKey(event) {
    // Allowing tab so that a user can move focus away
    if (event.keyCode === $14ed0e9b51202eb5$var$tabKeyCode) return;
    $14ed0e9b51202eb5$var$abort(event);
}
const $14ed0e9b51202eb5$var$block = {
    onMouseDownCapture: $14ed0e9b51202eb5$var$abort,
    onMouseUpCapture: $14ed0e9b51202eb5$var$abort,
    // because we have tabIndex = -1 when disabled,
    // keyboard events can only occur when there is an overlay
    onKeyDownCapture: $14ed0e9b51202eb5$var$onKey,
    onKeyUpCapture: $14ed0e9b51202eb5$var$onKey,
    onTouchStartCapture: $14ed0e9b51202eb5$var$abort,
    onTouchEndCapture: $14ed0e9b51202eb5$var$abort,
    onPointerDownCapture: $14ed0e9b51202eb5$var$abort,
    onPointerUpCapture: $14ed0e9b51202eb5$var$abort,
    onClickCapture: $14ed0e9b51202eb5$var$abort,
    // Just smashing the existing onClick for good measure
    onClick: $14ed0e9b51202eb5$var$abort
};
const $14ed0e9b51202eb5$var$doNotBlock = {};
function $14ed0e9b51202eb5$export$2e2bcd8739ae039({ isInteractive: isInteractive }) {
    return isInteractive ? $14ed0e9b51202eb5$var$doNotBlock : $14ed0e9b51202eb5$var$block;
}

});

parcelRegister("gDSSU", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $6F6hl = parcelRequire("6F6hl");

const $37dd97bea21ce072$export$20bbd2efb0d734c4 = (children)=>{
    return children && /*#__PURE__*/ (0, $42omo.isValidElement)(children) && children.type === (0, $6F6hl.default);
};
module.exports["getIfVisuallyHiddenChildren"] = $37dd97bea21ce072$export$20bbd2efb0d734c4;

});

parcelRegister("bZ1JU", function(module, exports) {
$parcel$export(module.exports, "default", () => $de85b37502e8accd$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");


var $aCLu8 = parcelRequire("aCLu8");


var $bzNqF = parcelRequire("bzNqF");


var $i9I6M = parcelRequire("i9I6M");


var $g9Srd = parcelRequire("g9Srd");

/**
 *  ________________________________________________
 * | MAJOR VERSIONS WILL NOT KNOW ABOUT EACH OTHER! |
 *  ------------------------------------------------
 *
 * An array which holds references to all currently open modal dialogs.
 * This will only work for modal dialogs of the same major version,
 * as the reference will be different between them.
 *
 * E.g. V11 won't know about any from V12.
 */ const $de85b37502e8accd$var$modalStackRegister = [];
function $de85b37502e8accd$export$2e2bcd8739ae039({ onStackChange: onStackChange }) {
    const { isExiting: isExiting } = (0, $g9Srd.useExitingPersistence)();
    const [stackIndexRef, setStackIndex] = (0, $i9I6M.default)(0);
    const currentStackIndex = stackIndexRef.current;
    const previousStackIndex = (0, $bzNqF.default)(stackIndexRef.current);
    // We want to ensure this function **never changes** during the lifecycle of this component.
    // This is why it's assigned to a ref and not in a useMemo/useCallback.
    const updateStack = (0, $aCLu8.default)(()=>{
        const newStackIndex = $de85b37502e8accd$var$modalStackRegister.indexOf(updateStack);
        // We access the stack index ref instead of state because this closure will always only
        // have the initial state and not any of the later values.
        if (stackIndexRef.current !== newStackIndex) {
            setStackIndex(newStackIndex);
            stackIndexRef.current = newStackIndex;
        }
    });
    (0, $42omo.useEffect)(()=>{
        const currentStackIndex = $de85b37502e8accd$var$modalStackRegister.indexOf(updateStack);
        if (!isExiting && currentStackIndex === -1) // We are opening the modal dialog.
        // Add ourselves to the modal stack register!
        $de85b37502e8accd$var$modalStackRegister.unshift(updateStack);
        if (isExiting && currentStackIndex !== -1) // We are closing the modal dialog using a wrapping modal transition component.
        // Remove ourselves from the modal stack register!
        // NOTE: Modal dialogs that don't have a wrapping modal transition component won't flow through here!
        // For that scenario we cleanup when the component unmounts.
        $de85b37502e8accd$var$modalStackRegister.splice(currentStackIndex, 1);
        // Fire all registered modal dialogs to update their position in the stack.
        $de85b37502e8accd$var$modalStackRegister.forEach((cb)=>cb());
    }, [
        updateStack,
        isExiting
    ]);
    (0, $42omo.useEffect)(()=>()=>{
            // Final cleanup just in case this modal dialog did not have a wrapping modal transition.
            const currentStackIndex = $de85b37502e8accd$var$modalStackRegister.indexOf(updateStack);
            if (currentStackIndex !== -1) {
                $de85b37502e8accd$var$modalStackRegister.splice(currentStackIndex, 1);
                $de85b37502e8accd$var$modalStackRegister.forEach((cb)=>cb());
            }
        }, [
        updateStack
    ]);
    (0, $42omo.useEffect)(()=>{
        if (previousStackIndex === undefined) // Initial case that we don't need to notify about.
        return;
        if (previousStackIndex !== currentStackIndex) onStackChange(currentStackIndex);
    }, [
        onStackChange,
        previousStackIndex,
        currentStackIndex
    ]);
    return currentStackIndex;
}

});

parcelRegister("bDzqh", function(module, exports) {
$parcel$export(module.exports, "default", () => $a3707f93ea22b000$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");


var $fFa3V = parcelRequire("fFa3V");

/**
 * Returns how far the body is scrolled from the top of the viewport.
 *
 *   ____
 * ||____|| <-- overflow
 *  |    |  <-- viewport
 *  |____|
 *
 * Scroll distance is the height of overflow outside the viewport.
 */ function $a3707f93ea22b000$var$getScrollDistance() {
    return window.pageYOffset || document.documentElement?.scrollTop || document.body?.scrollTop || 0;
}
function $a3707f93ea22b000$export$2e2bcd8739ae039() {
    const [scrollTopOffset, setScrollTopOffset] = (0, $42omo.useState)(0);
    (0, $42omo.useLayoutEffect)(()=>{
        setScrollTopOffset($a3707f93ea22b000$var$getScrollDistance());
    }, []);
    const onWindowScroll = (0, $42omo.useCallback)(()=>{
        if ($a3707f93ea22b000$var$getScrollDistance() !== scrollTopOffset) window.scrollTo(window.pageXOffset, scrollTopOffset);
    }, [
        scrollTopOffset
    ]);
    (0, $42omo.useEffect)(()=>{
        return (0, $fFa3V.bind)(window, {
            type: 'scroll',
            listener: onWindowScroll
        });
    }, [
        onWindowScroll
    ]);
    return scrollTopOffset;
}

});

parcelRegister("amR5O", function(module, exports) {
/* modal-dialog.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");


var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $3654r = parcelRequire("3654r");


var $f93tv = parcelRequire("f93tv");


var $c0qxy = parcelRequire("c0qxy");


var $16xFS = parcelRequire("16xFS");


var $fT2ta = parcelRequire("fT2ta");


var $dh538 = parcelRequire("dh538");


var $bSjaC = parcelRequire("bSjaC");


var $dbEzH = parcelRequire("dbEzH");


var $8Gxfa = parcelRequire("8Gxfa");


var $2MqmU = parcelRequire("2MqmU");


var $gSjzW = parcelRequire("gSjzW");


var $WPNvU = parcelRequire("WPNvU");


var $5IMYZ = parcelRequire("5IMYZ");


var $7WBHn = parcelRequire("7WBHn");

const $501b75a1e057a3f1$var$LOCAL_CURRENT_SURFACE_CSS_VAR = '--ds-elevation-surface-current';
const $501b75a1e057a3f1$var$dialogStyles = {
    root: "_16jlidpf _1o9zkb7n _i0dl1wug _1e0c1txw _1bsb1osq _p12fauwl _4t3i1osq _1tkeidpf _c71l1kxc _2lx21bp4 _bfhk1bhr _syazi7uo _1q1l1bhr _lcxv1wug _1mq81kw7 _m01u1kw7 _1dg11kw7 _mizu1v1w _1ah3dkaa _ra3xnqa1 _128mdkaa _1cvmnqa1 _4davt94y _we1i1kw7 _zg7p130s _yakv1kw7 _4lht1kw7 _1xlt6m9r",
    borderRadius: "_epkxfajl",
    borderRadiusT26Shape: "_epkxpb1k"
};
const $501b75a1e057a3f1$var$viewportScrollStyles = null;
const $501b75a1e057a3f1$var$bodyScrollStyles = null;
const $501b75a1e057a3f1$var$ModalDialog = (props)=>{
    const { width: width = 'medium', shouldScrollInViewport: shouldScrollInViewport = false, shouldCloseOnEscapePress: shouldCloseOnEscapePress, autoFocus: providedAutoFocus, stackIndex: stackIndex, onClose: onClose, onCloseComplete: onCloseComplete, onOpenComplete: onOpenComplete, height: height, hasProvidedOnClose: hasProvidedOnClose, children: children, label: label, testId: testId, isFullScreen: isFullScreen = false } = props;
    const id = (0, $c0qxy.useId)();
    const titleId = `modal-dialog-title-${id}`;
    const defaultTestId = testId || 'modal-dialog'; // https://product-fabric.atlassian.net/browse/DSP-24307
    // If flag and falsy, use true instead.
    const autoFocus = !providedAutoFocus && (0, $dh538.fg)('platform_dst_autofocus-never-false') ? true : providedAutoFocus;
    (0, $42omo.useEffect)(()=>{
        // Modal dialogs can appear on top of iframe elements that are on another domain.
        // There is a Chrome bug where drag and drop in an element on top of a cross domain
        // iframe is not working. We are applying the workaround for this bug in modal so
        // that consumers of our modal don't have to worry about this bug and are free to
        // create whatever drag and drop experience they like inside a modal
        //
        // Chrome bug: https://issues.chromium.org/issues/362301053
        return (0, $bSjaC.combine)((0, $2MqmU.disableDraggingToCrossOriginIFramesForElement)(), (0, $WPNvU.disableDraggingToCrossOriginIFramesForTextSelection)(), (0, $gSjzW.disableDraggingToCrossOriginIFramesForExternal)());
    }, []);
    (0, $f93tv.default)(typeof autoFocus === 'object' ? autoFocus : undefined, // When a user supplies  a ref to focus we enable this hook
    typeof autoFocus === 'object');
    const [motionRef, onMotionFinish] = (0, $8Gxfa.default)({
        onOpenComplete: onOpenComplete,
        onCloseComplete: onCloseComplete
    });
    const modalDialogContext = (0, $42omo.useMemo)(()=>({
            testId: defaultTestId,
            titleId: titleId,
            onClose: onClose,
            hasProvidedOnClose: hasProvidedOnClose,
            isFullScreen: isFullScreen
        }), [
        defaultTestId,
        titleId,
        onClose,
        hasProvidedOnClose,
        isFullScreen
    ]);
    (0, $16xFS.useCloseOnEscapePress)({
        onClose: onClose,
        isDisabled: !shouldCloseOnEscapePress
    });
    const { currentLevel: currentLevel } = (0, $16xFS.useLayering)();
    return /*#__PURE__*/ (0, $l998X.jsx)((0, $7WBHn.default), {
        stackIndex: stackIndex,
        shouldScrollInViewport: shouldScrollInViewport,
        testId: defaultTestId,
        isFullScreen: isFullScreen,
        children: /*#__PURE__*/ (0, $l998X.jsx)((0, $dbEzH.ModalContext).Provider, {
            value: modalDialogContext,
            children: /*#__PURE__*/ (0, $l998X.jsx)((0, $dbEzH.ScrollContext).Provider, {
                value: shouldScrollInViewport,
                children: /*#__PURE__*/ (0, $l998X.jsx)((0, $fT2ta.default /**
             * We don't want a 'slide in' for the full screen modals.
             */ ), {
                    entranceDirection: isFullScreen ? undefined : 'bottom',
                    onFinish: onMotionFinish,
                    children: (bottomFadeInProps)=>/*#__PURE__*/ (0, $l998X.jsx)("section", {
                            ...bottomFadeInProps,
                            "aria-label": label,
                            ref: (0, $3654r.default)([
                                bottomFadeInProps.ref,
                                motionRef
                            ]),
                            style: {
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                                '--modal-dialog-width': (0, $5IMYZ.dialogWidth)(width),
                                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                                '--modal-dialog-height': (0, $5IMYZ.dialogHeight)(height)
                            },
                            className: (0, $gMc0m.default)([
                                $501b75a1e057a3f1$var$dialogStyles.root,
                                !isFullScreen && $501b75a1e057a3f1$var$dialogStyles.borderRadius,
                                !isFullScreen && (0, $dh538.fg)('platform-dst-shape-theme-default') && $501b75a1e057a3f1$var$dialogStyles.borderRadiusT26Shape,
                                shouldScrollInViewport ? "_1tke1kxc _c71lglyw _8kn617ks" : "_cbiz17ks _bolh1kw7",
                                bottomFadeInProps.className
                            ]),
                            role: "dialog",
                            "aria-labelledby": label ? undefined : titleId,
                            "data-testid": defaultTestId,
                            "data-modal-stack": stackIndex,
                            tabIndex: -1,
                            "aria-modal": true,
                            "data-ds--level": currentLevel,
                            children: children
                        })
                })
            })
        })
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$501b75a1e057a3f1$export$2e2bcd8739ae039 = $501b75a1e057a3f1$var$ModalDialog;
module.exports["default"] = $501b75a1e057a3f1$export$2e2bcd8739ae039;

});

parcelRegister("8Gxfa", function(module, exports) {
$parcel$export(module.exports, "default", () => $f69e1ddc60a15e0f$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");

function $f69e1ddc60a15e0f$export$2e2bcd8739ae039({ onOpenComplete: onOpenComplete, onCloseComplete: onCloseComplete }) {
    const motionRef = (0, $42omo.useRef)(null);
    const onMotionFinish = (0, $42omo.useCallback)((state)=>{
        if (state === 'entering' && onOpenComplete) onOpenComplete(motionRef.current, true);
        if (state === 'exiting' && onCloseComplete) onCloseComplete(motionRef.current);
    }, [
        onOpenComplete,
        onCloseComplete
    ]);
    return [
        motionRef,
        onMotionFinish
    ];
}

});

parcelRegister("2MqmU", function(module, exports) {

var $fFa3V = parcelRequire("fFa3V");


var $bSjaC = parcelRequire("bSjaC");


var $4T4vf = parcelRequire("4T4vf");


var $2yxa5 = parcelRequire("2yxa5");

function $78cd79ed3224f00a$var$watchForInteractionEnd({ stop: stop }) {
    let isDragging = false;
    function stopIfNotDragging() {
        if (isDragging) return;
        stop();
    }
    const unbindEvents = (0, $fFa3V.bindAll)(window, [
        {
            // Another interaction is starting, this fix should be removed.
            type: 'pointerdown',
            listener: stop
        },
        {
            // The user did not start a drag
            type: 'pointerup',
            listener: stopIfNotDragging
        },
        {
            // if a "dragstart" occurs and the flag is not set,
            // then a drag has not started.
            // Note: could not use "pointercancel" as it is not
            // published in Safari
            // → https://bugs.webkit.org/show_bug.cgi?id=222632
            type: 'dragstart',
            listener: stopIfNotDragging,
            // Need to come after the element adapter
            options: {
                capture: false
            }
        }
    ], {
        // Listening in the capture phase to increase resilience
        // against events being stopped.
        capture: true,
        // Being super clear these should only run once
        once: true
    });
    const unbindMonitor = (0, $4T4vf.monitorForElements)({
        onGenerateDragPreview () {
            isDragging = true;
        },
        onDrop () {
            isDragging = false;
            stop();
        }
    });
    return (0, $bSjaC.combine)(unbindEvents, unbindMonitor);
}
function $78cd79ed3224f00a$var$watchForInteractionStart({ start: start }) {
    return (0, $fFa3V.bind)(window, {
        // Note: Using "mousedown" rather than "pointerdown" due to a Safari bug.
        // Safari not publish a "pointerdown" on the interaction after a drag
        // → https://bugs.webkit.org/show_bug.cgi?id=279749
        type: 'mousedown',
        listener (event) {
            // Only starting if pressing down inside a draggable element
            // At this point, we are not sure which if:
            // 1. a text selection drag is starting
            // 2. a draggable managed by pdnd is going to be dragged
            // 3. a draggable not managed by pdnd is going to be dragged
            // 4. The user will be dragging anything at all (might be doing a click)
            if (event.target instanceof HTMLElement && event.target.closest('[draggable="true"]')) start();
        }
    });
}
const $78cd79ed3224f00a$var$api = (0, $2yxa5.makeFixForAdapter)({
    watchForInteractionStart: $78cd79ed3224f00a$var$watchForInteractionStart,
    watchForInteractionEnd: $78cd79ed3224f00a$var$watchForInteractionEnd
});
function $78cd79ed3224f00a$export$ec28e97c7d8b1b35() {
    return $78cd79ed3224f00a$var$api.registerUsage();
}
module.exports["disableDraggingToCrossOriginIFramesForElement"] = $78cd79ed3224f00a$export$ec28e97c7d8b1b35;

});

parcelRegister("gSjzW", function(module, exports) {

var $feJ8f = parcelRequire("feJ8f");


var $2yxa5 = parcelRequire("2yxa5");

function $9fb9b53f53535bce$var$watchForInteractionStart({ start: start }) {
    return (0, $feJ8f.monitorForExternal)({
        onDragStart () {
            start();
        }
    });
}
function $9fb9b53f53535bce$var$watchForInteractionEnd({ stop: stop }) {
    return (0, $feJ8f.monitorForExternal)({
        onDrop () {
            stop();
        }
    });
}
const $9fb9b53f53535bce$var$api = (0, $2yxa5.makeFixForAdapter)({
    watchForInteractionStart: $9fb9b53f53535bce$var$watchForInteractionStart,
    watchForInteractionEnd: $9fb9b53f53535bce$var$watchForInteractionEnd
});
function $9fb9b53f53535bce$export$27d79116d3a4e7d5() {
    return $9fb9b53f53535bce$var$api.registerUsage();
}
module.exports["disableDraggingToCrossOriginIFramesForExternal"] = $9fb9b53f53535bce$export$27d79116d3a4e7d5;

});

parcelRegister("WPNvU", function(module, exports) {

var $fFa3V = parcelRequire("fFa3V");


var $bSjaC = parcelRequire("bSjaC");


var $fNPGC = parcelRequire("fNPGC");


var $2yxa5 = parcelRequire("2yxa5");

function $7c91e8e518750b75$var$watchForInteractionEnd({ stop: stop }) {
    let isDragging = false;
    function stopIfNotDragging() {
        if (isDragging) return;
        stop();
    }
    let frameId = null;
    const unbindEvents = (0, $fFa3V.bindAll)(window, [
        {
            // User is starting another interaction
            type: 'pointerdown',
            listener: stop
        },
        {
            // User did not start a drag.
            // "pointerdown" won't be fired if a drag started
            type: 'pointerup',
            listener: stopIfNotDragging
        },
        {
            type: 'dragstart',
            listener () {
                /**
					 * The pdnd `onDragStart()` fires in the frame after "dragstart"
					 * So we are delaying our isDragging check to give a chance
					 * for `onDragStart()` to set the value correctly.
					 *
					 * Note: could not use "pointercancel" as it is not
					 * published in Safari → https://bugs.webkit.org/show_bug.cgi?id=222632
					 */ frameId = requestAnimationFrame(()=>{
                    frameId = null;
                    stopIfNotDragging();
                });
            },
            // need to schedule our frame after the text-selection
            // adapter queues it's `onDragStart` frame.
            options: {
                capture: false
            }
        }
    ], {
        // Listening in the capture phase to increase resilience
        // against events being stopped.
        capture: true,
        // being super clear these should only run once
        once: true
    });
    const unbindMonitor = (0, $fNPGC.monitorForTextSelection)({
        onDragStart () {
            isDragging = true;
        },
        onDrop () {
            isDragging = false;
            stop();
        }
    });
    return (0, $bSjaC.combine)(unbindEvents, unbindMonitor, function abortFrame() {
        if (frameId != null) cancelAnimationFrame(frameId);
    });
}
function $7c91e8e518750b75$var$watchForInteractionStart({ start: start }) {
    return (0, $fFa3V.bind)(window, {
        // Note: Using "mousedown" rather than "pointerdown" due to a Safari bug.
        // Safari not publish a "pointerdown" on the interaction after a drag
        // → https://bugs.webkit.org/show_bug.cgi?id=279749
        type: 'mousedown',
        listener () {
            // A text selection drag will only start when there is
            // an active text selection.
            const selection = window.getSelection();
            // No selection object found
            if (!selection) return;
            // `isCollapsed` is "true" if there is currently no selected text
            if (selection.isCollapsed) return;
            start();
        }
    });
}
const $7c91e8e518750b75$var$api = (0, $2yxa5.makeFixForAdapter)({
    watchForInteractionStart: $7c91e8e518750b75$var$watchForInteractionStart,
    watchForInteractionEnd: $7c91e8e518750b75$var$watchForInteractionEnd
});
function $7c91e8e518750b75$export$9c0606fcefb5d1e2() {
    return $7c91e8e518750b75$var$api.registerUsage();
}
module.exports["disableDraggingToCrossOriginIFramesForTextSelection"] = $7c91e8e518750b75$export$9c0606fcefb5d1e2;

});

parcelRegister("5IMYZ", function(module, exports) {
const $7b29cd8e727ab747$export$7e3df82ee760448c = {
    values: [
        'small',
        'medium',
        'large',
        'x-large'
    ],
    widths: {
        small: 400,
        medium: 600,
        large: 800,
        'x-large': 968
    },
    defaultValue: 'medium'
};
const $7b29cd8e727ab747$export$a3da89b899389ed8 = (input)=>{
    if (!input) return 'auto';
    const isWidthName = $7b29cd8e727ab747$export$7e3df82ee760448c.values.indexOf(input.toString()) !== -1;
    const widthName = isWidthName && input;
    if (widthName) return `${$7b29cd8e727ab747$export$7e3df82ee760448c.widths[widthName]}px`;
    return typeof input === 'number' ? `${input}px` : input;
};
const $7b29cd8e727ab747$export$ceba93bf0bdd16f2 = (input)=>{
    if (!input) return 'auto';
    return typeof input === 'number' ? `${input}px` : input;
};
module.exports["dialogWidth"] = $7b29cd8e727ab747$export$a3da89b899389ed8;
module.exports["dialogHeight"] = $7b29cd8e727ab747$export$ceba93bf0bdd16f2;

});

parcelRegister("7WBHn", function(module, exports) {
/* positioner.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $l998X = parcelRequire("l998X");

parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $ig6yX = parcelRequire("ig6yX");


var $4c48T = parcelRequire("4c48T");

const $9c93df066478d62c$var$positionerStyles = null;
const $9c93df066478d62c$var$stackStyles = {
    stackTransition: "_k8m01e03 _1bumglyw _sedtglyw",
    stackTransform: "_t9ec1b95",
    stackIdle: "_t9ecglyw"
}; // Hardcoded pixels are based off a 60px base gutter
const $9c93df066478d62c$var$scrollStyles = {
    viewport: "_4t3i1wug _kqswh2mm _1f6n1wqb _1eot1wug _eoawglyw",
    body: "_we1i18uh _e8uozwhf _y1k5stnw _5ee41nf8 _1urridpf _1juqidpf _yakv1wug _4lht1wug _eoawglyw",
    fullScreen: ""
};
function $9c93df066478d62c$var$getScrollBehavior({ isFullScreen: isFullScreen, shouldScrollInViewport: shouldScrollInViewport }) {
    if (isFullScreen) return 'fullScreen';
    if (shouldScrollInViewport) return 'viewport';
    return 'body';
}
const $9c93df066478d62c$var$Positioner = (props)=>{
    const { children: children, stackIndex: stackIndex, shouldScrollInViewport: shouldScrollInViewport, testId: testId, isFullScreen: isFullScreen } = props;
    const scrollBehavior = $9c93df066478d62c$var$getScrollBehavior({
        isFullScreen: isFullScreen,
        shouldScrollInViewport: shouldScrollInViewport
    });
    return /*#__PURE__*/ (0, $l998X.jsx)("div", {
        style: {
            '--modal-dialog-translate-y': `calc(${stackIndex}px * ${"var(--ds-space-100, 8px)"})`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            transitionDuration: `${(0, $4c48T.durations).medium}ms`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            transitionTimingFunction: (0, $ig6yX.easeInOut)
        },
        "data-testid": testId && `${testId}--positioner`,
        className: (0, $gMc0m.default)([
            "_1e0c1txw _1bsb1osq _p12f1osq _4t3i1osq _kqsw1n9t _1pby16oo _2lx21bp4 _152tidpf _1e02idpf",
            $9c93df066478d62c$var$stackStyles.stackTransition,
            stackIndex > 0 ? $9c93df066478d62c$var$stackStyles.stackTransform : $9c93df066478d62c$var$stackStyles.stackIdle,
            $9c93df066478d62c$var$scrollStyles[scrollBehavior]
        ]),
        children: children
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$9c93df066478d62c$export$2e2bcd8739ae039 = $9c93df066478d62c$var$Positioner;
module.exports["default"] = $9c93df066478d62c$export$2e2bcd8739ae039;

});

parcelRegister("2yxa5", function(module, exports) {

var $bSjaC = parcelRequire("bSjaC");

/**
 * Set a `style` property on a `HTMLElement`
 *
 * @returns a `cleanup` function to restore the `style` property to it's original state
 */ function $bb116833379cde15$var$setStyle(el, { property: property, rule: rule, priority: priority = '' }) {
    const originalValue = el.style.getPropertyValue(property);
    const originalPriority = el.style.getPropertyPriority(property);
    el.style.setProperty(property, rule, priority);
    return function cleanup() {
        el.style.setProperty(property, originalValue, originalPriority);
    };
}
function $bb116833379cde15$var$hasSameOrigin(href1, href2) {
    let url1;
    let url2;
    try {
        url1 = new URL(href1);
        url2 = new URL(href2);
    } catch  {
        // failed to parse a href
        return false;
    }
    // https://developer.mozilla.org/en-US/docs/Web/Security/Same-origin_policy
    return url1.protocol === url2.protocol && url1.host === url2.host && url1.port === url2.port;
}
function $bb116833379cde15$var$isIframeOnAnotherDomain(iframe) {
    /**
	 * iframe with contents defined inline. Runs on the current origin.
	 * `<iframe srcdoc="<!doctype html><body>Hello</body>" />`
	 */ if (iframe.srcdoc) return false;
    /**
	 * iframe with contents defined inline. Runs on the current origin.
	 * `<iframe src={`data:text/html;charset=utf-8,${encodeURI('<!doctype html><body>Hello</body>')}`} />`
	 */ if (iframe.src.startsWith('data:')) return false;
    return !$bb116833379cde15$var$hasSameOrigin(window.location.href, iframe.src);
}
const $bb116833379cde15$var$registry = new Map();
function $bb116833379cde15$var$applyFix(watchForEndOfInteraction) {
    const iframes = Array.from(document.querySelectorAll('iframe')).filter($bb116833379cde15$var$isIframeOnAnotherDomain);
    const cleanups = iframes.map((iframe)=>{
        let entry = $bb116833379cde15$var$registry.get(iframe);
        if (!entry) {
            entry = {
                reset: $bb116833379cde15$var$setStyle(iframe, {
                    property: 'pointer-events',
                    rule: 'none',
                    priority: 'important'
                }),
                count: 1
            };
            $bb116833379cde15$var$registry.set(iframe, entry);
        } else // pointer-events:none already applied to the iframe
        // increment how many things requested the fix
        entry.count++;
        return function cleanup() {
            entry.count--;
            if (entry.count < 1) {
                entry.reset();
                $bb116833379cde15$var$registry.delete(iframe);
            }
        };
    });
    function stop() {
        cleanupWatcher();
        (0, $bSjaC.combine)(...cleanups)();
    }
    const cleanupWatcher = watchForEndOfInteraction({
        stop: stop
    });
}
function $bb116833379cde15$export$a74bff2507e6126b({ watchForInteractionStart: watchForInteractionStart, watchForInteractionEnd: watchForInteractionEnd }) {
    let registrationCount = 0;
    let stopWatchingInteractionStart = null;
    function start() {
        $bb116833379cde15$var$applyFix(watchForInteractionEnd);
    }
    function registerUsage() {
        if (registrationCount === 0) stopWatchingInteractionStart = watchForInteractionStart({
            start: start
        });
        registrationCount++;
        return function unregisterUsage() {
            registrationCount--;
            if (registrationCount !== 0) return;
            stopWatchingInteractionStart?.();
            stopWatchingInteractionStart = null;
        };
    }
    return {
        registerUsage: registerUsage
    };
}
module.exports["makeFixForAdapter"] = $bb116833379cde15$export$a74bff2507e6126b;

});


$parcel$global.rlb("hhss7")
//# sourceMappingURL=vendors~editor_atlaskit_lg.8a4b55c1.js.map
